/* eslint-disable simple-import-sort/imports */
import pdf_0000BLEU from '../Asset/PDF/0000BLEU.pdf';
import pdf_0000ROUGE from '../Asset/PDF/0000ROUGE.pdf';
import pdf_0007BLEU from '../Asset/PDF/0007BLEU.pdf';
import pdf_0007ROUGE from '../Asset/PDF/0007ROUGE.pdf';
import pdf_0070BLEU from '../Asset/PDF/0070BLEU.pdf';
import pdf_0070ROUGE from '../Asset/PDF/0070ROUGE.pdf';
import pdf_0077BLEU from '../Asset/PDF/0077BLEU.pdf';
import pdf_0077ROUGE from '../Asset/PDF/0077ROUGE.pdf';
import pdf_0700BLEU from '../Asset/PDF/0700BLEU.pdf';
import pdf_0700ROUGE from '../Asset/PDF/0700ROUGE.pdf';
import pdf_0707BLEU from '../Asset/PDF/0707BLEU.pdf';
import pdf_0707ROUGE from '../Asset/PDF/0707ROUGE.pdf';
import pdf_0770BLEU from '../Asset/PDF/0770BLEU.pdf';
import pdf_0770ROUGE from '../Asset/PDF/0770ROUGE.pdf';
import pdf_0777BLEU from '../Asset/PDF/0777BLEU.pdf';
import pdf_0777ROUGE from '../Asset/PDF/0777ROUGE.pdf';
import pdf_7000BLEU from '../Asset/PDF/7000BLEU.pdf';
import pdf_7000ROUGE from '../Asset/PDF/7000ROUGE.pdf';
import pdf_7007BLEU from '../Asset/PDF/7007BLEU.pdf';
import pdf_7007ROUGE from '../Asset/PDF/7007ROUGE.pdf';
import pdf_7070BLEU from '../Asset/PDF/7070BLEU.pdf';
import pdf_7070ROUGE from '../Asset/PDF/7070ROUGE.pdf';
import pdf_7077BLEU from '../Asset/PDF/7077BLEU.pdf';
import pdf_7077ROUGE from '../Asset/PDF/7077ROUGE.pdf';
import pdf_7700BLEU from '../Asset/PDF/7700BLEU.pdf';
import pdf_7700ROUGE from '../Asset/PDF/7700ROUGE.pdf';
import pdf_7707BLEU from '../Asset/PDF/7707BLEU.pdf';
import pdf_7707ROUGE from '../Asset/PDF/7707ROUGE.pdf';
import pdf_7770BLEU from '../Asset/PDF/7770BLEU.pdf';
import pdf_7770ROUGE from '../Asset/PDF/7770ROUGE.pdf';
import pdf_7777BLEU from '../Asset/PDF/7777BLEU.pdf';
import pdf_7777ROUGE from '../Asset/PDF/7777ROUGE.pdf';
import locale from '../components/UserResult/UserResultRadarGraph/locale.json';

const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:1337';
// const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://backendstaging.e-orientaction.com';
// 'http://localhost:1337';
const AI_ENDPOINT = process.env.REACT_APP_AI_ENDPOINT;
const EXPORT_ENDPOINT = process.env.REACT_APP_EXPORT_ENDPOINT;
export const publicIconPath = '/icons';
export const publicIconDetailResultPath = '/icon-detail-result';
export const publicPath = '../public';
export const publicImagePath = '/images';
export const publicLogoPath = '/images/Logo';
export const publicSvgPath = '/images/svg';
export const imgBook1 = '/images/Book1';
export const publicBookPath = '/images/Book';
export const publicBook3Path = '/images/Book3';
export const publicBook5Path = '/images/Book5';
export const publicImgMajorTest = '/images/MajorTest';
export const publicImgMinorTest = '/images/MinorTest';

export const publicPdfPath = '/images/PDF';
export const publicVideoPath = '/video';
export const emailMatch = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
export const imgBook2 = '/images/Book2';
export const imgBookIntro = '/images/BookIntro';
export const imgBook4 = '/images/Book4';
export const coverBook = '/images/couverture';
export const ebooksImagePath = '/images/ebooks';

export const EN_PREFIX = 'en';

export const GB_PREFIX = 'GB';

export default {
  API: {
    ENDPOINT,
    EXPORT_ENDPOINT,
    AI_ENDPOINT,
    ENDPOINTS: {
      RESULT: `${ENDPOINT}/results`,
    },
  },
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
};

export const columns = [
  { id: 'date', label: 'dates', columnName: 'realization_date', type: 'date', entity: 'results' },
  { id: 'Opt-in', label: 'opt-in', columnName: 'opt_in', type: 'number', entity: 'results' },
  { id: 'bc', label: 'bc', columnName: 'bc', type: 'number', entity: 'results' },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  { id: 'age', label: 'âge', columnName: 'age', type: 'number', entity: 'users_permissions_users' },
  {
    id: 'diplome',
    label: 'diplôme',
    columnName: 'diploma',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'reso. PB',
    label: 'reso. PB',
    columnName: 'problem_solving',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'confiance',
    label: 'confiance',
    columnName: 'confidence',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'intel emo',
    label: 'intel. EMo',
    columnName: 'emotional_intelligence',
    type: 'number',
    entity: 'results',
  },
  { id: 'empathie', label: 'empathie', columnName: 'empathy', type: 'number', entity: 'results' },
  {
    id: 'com',
    label: 'communication',
    columnName: 'communication',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'temps',
    label: 'gestion temps',
    columnName: 'time_management',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'stress',
    label: 'gestion stress',
    columnName: 'stress_management',
    type: 'number',
    entity: 'results',
  },
  { id: 'creativity', label: 'créativité', columnName: 'creativity', type: 'number' },
  {
    id: 'entreprendre',
    label: 'esprit entre.',
    columnName: 'entrepreneurial_spirit',
    type: 'number',
    entity: 'results',
  },
  { id: 'audace', label: 'audace', columnName: 'daring', type: 'number', entity: 'results' },
  {
    id: 'motivation',
    label: 'motivation',
    columnName: 'motivation',
    type: 'number',
    entity: 'results',
  },
  { id: 'vision', label: 'vision', columnName: 'vision', type: 'number', entity: 'results' },
  { id: 'presence', label: 'présence', columnName: 'presence', type: 'number', entity: 'results' },
  {
    id: 'collectif',
    label: 'sens collectif',
    columnName: 'collective_sense',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'curiosité',
    label: 'curiosité',
    columnName: 'curiousity',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'critique',
    label: 'esprit critique',
    columnName: 'critical_mind',
    type: 'number',
    entity: 'results',
  },
  { id: 'score', label: 'score total', columnName: 'score', type: 'number', entity: 'results' },
  {
    id: 'temps passe',
    label: 'temps passé',
    columnName: 'time_spent',
    type: 'number',
    entity: 'results',
  },
  {
    id: 'realisation',
    label: 'période de réal.',
    columnName: 'realization_period',
    type: 'number',
    entity: 'results',
  },
];

export const meaningColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'date',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'Opt-in',
    label: 'opt-in',
    columnName: 'opt_in',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  { id: 'bc', label: 'bc', columnName: 'bc', type: 'number', entity: 'meaning_value_test_results' },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'age',
    label: 'âge',
    columnName: 'age',
    type: 'number',
    entity: 'users_permissions_users',
  },
  { id: 'diplome', label: 'diplôme', columnName: 'diploma', entity: 'users_permissions_users' },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'autonomy',
    label: 'autonomie',
    columnName: 'autonomy',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'stimulation',
    label: 'stimulation',
    columnName: 'stimulation',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'hedonism',
    label: 'hédonisme',
    columnName: 'hedonism',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'achievement',
    label: 'réussite',
    columnName: 'achievement',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'power',
    label: 'pouvoir',
    columnName: 'power',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'security',
    label: 'sécurité',
    columnName: 'security',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'tradition',
    label: 'tradition',
    columnName: 'tradition',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'compliance',
    label: 'conformité',
    columnName: 'compliance',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'kindness',
    label: 'bienveillance',
    columnName: 'kindness',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'universalism',
    label: 'universalisme',
    columnName: 'universalism',
    type: 'number',
    entity: 'meaning_value_test_results',
  },
];

export const needsColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'string',
    entity: 'needs_test_results',
  },
  {
    id: 'Opt-in',
    label: 'opt-in',
    columnName: 'opt_in',
    type: 'string',
    entity: 'needs_test_results',
  },
  { id: 'bc', label: 'bc', columnName: 'bc', type: 'string', entity: 'needs_test_results' },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  { id: 'age', label: 'âge', columnName: 'age', type: 'number', entity: 'users_permissions_users' },
  {
    id: 'diplome',
    label: 'diplôme',
    columnName: 'diploma',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'security_perso',
    label: 'besoin de sécurité - perso',
    columnName: 'security_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'security_pro',
    label: 'besoin de sécurité - pro',
    columnName: 'security_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'physiological_perso',
    label: 'besoin physiologiques - perso',
    columnName: 'physiological_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'physiological_pro',
    label: 'besoin physiologiques - pro',
    columnName: 'physiological_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'horizontal_belonging_perso',
    label: "besoin d'appartenance (horizontale) - perso",
    columnName: 'horizontal_belonging_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'horizontal_belonging_pro',
    label: "besoin d'appartenance (horizontale) - pro",
    columnName: 'horizontal_belonging_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'vertical_belonging_perso',
    label: "besoin d'appartenance (verticale) - perso",
    columnName: 'vertical_belonging_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'vertical_belonging_pro',
    label: "besoin d'appartenance (verticale) - pro",
    columnName: 'vertical_belonging_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'accomplishment_perso',
    label: "besoin d'accomplissement - perso",
    columnName: 'accomplishment_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'accomplishment_pro',
    label: "besoin d'accomplissement - pro",
    columnName: 'accomplishment_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'self_realization_perso',
    label: 'besoin de réalisation de soi - perso',
    columnName: 'self_realization_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'self_realization_pro',
    label: 'besoin de réalisation de soi - pro',
    columnName: 'self_realization_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'spirituality_perso',
    label: 'besoin de spiritualité - perso',
    columnName: 'spirituality_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'spirituality_pro',
    label: 'besoin de spiritualité - pro',
    columnName: 'spirituality_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'eternity_perso',
    label: "besoin d'éternité - perso",
    columnName: 'eternity_perso',
    type: 'number',
    entity: 'needs_test_results',
  },
  {
    id: 'eternity_pro',
    label: "besoin d'éternité - pro",
    columnName: 'eternity_pro',
    type: 'number',
    entity: 'needs_test_results',
  },
];

export const needsProColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'date',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'Opt-in',
    label: 'opt-in',
    columnName: 'opt_in',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  { id: 'bc', label: 'bc', columnName: 'bc', type: 'string', entity: 'needs_pro_test_results' },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  { id: 'age', label: 'âge', columnName: 'age', type: 'number', entity: 'users_permissions_users' },
  {
    id: 'diplome',
    label: 'diplôme',
    columnName: 'diploma',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'physiological_pro',
    label: 'besoin physiologiques - pro',
    columnName: 'physiological_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'security_pro',
    label: 'besoin de sécurité - pro',
    columnName: 'security_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'horizontal_belonging_pro',
    label: "besoin d'appartenance (horizontale) - pro",
    columnName: 'horizontal_belonging_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'vertical_belonging_pro',
    label: "besoin d'appartenance (verticale) - pro",
    columnName: 'vertical_belonging_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'accomplishment_pro',
    label: "besoin d'accomplissement - pro",
    columnName: 'accomplishment_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'self_realization_pro',
    label: 'besoin de réalisation de soi - pro',
    columnName: 'self_realization_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'spirituality_pro',
    label: 'besoin de spiritualité - pro',
    columnName: 'spirituality_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
  {
    id: 'eternity_pro',
    label: "besoin d'éternité - pro",
    columnName: 'eternity_pro',
    type: 'number',
    entity: 'needs_pro_test_results',
  },
];

export const prefPersoColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'date',
    entity: 'preference_personality_results',
  },
  {
    id: 'Opt-in',
    label: 'opt-in',
    columnName: 'opt_in',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'bc',
    label: 'bc',
    columnName: 'bc',
    type: 'string',
    entity: 'preference_personality_results',
  },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  { id: 'age', label: 'âge', columnName: 'age', type: 'number', entity: 'users_permissions_users' },
  {
    id: 'diplome',
    label: 'diplôme',
    columnName: 'diploma',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'interaction_social',
    label: 'interaction',
    columnName: 'interaction_social',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'reflexion_social',
    label: 'réflexion',
    columnName: 'reflexion_social',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'experience_perceptual',
    label: 'expérience',
    columnName: 'experience_perceptual',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'imagination_perceptual',
    label: 'imagination',
    columnName: 'imagination_perceptual',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'rationality_emotional',
    label: 'rationalité',
    columnName: 'rationality_emotional',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'empathy_emotional',
    label: 'empathie',
    columnName: 'empathy_emotional',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'action_behavioral',
    label: 'action',
    columnName: 'action_behavioral',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'observation_behavioral',
    label: 'observation',
    columnName: 'observation_behavioral',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'organization_environmental',
    label: 'organisation',
    columnName: 'organization_environmental',
    type: 'number',
    entity: 'preference_personality_results',
  },
  {
    id: 'adaptation_environmental',
    label: 'adaptation',
    columnName: 'adaptation_environmental',
    type: 'number',
    entity: 'preference_personality_results',
  },
];

export const studyColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'date',
    entity: 'meaning_value_test_results',
  },
  {
    id: 'prénom',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'nom',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'sexe',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'age',
    label: 'âge',
    columnName: 'age',
    type: 'number',
    entity: 'users_permissions_users',
  },
  { id: 'diplome', label: 'diplôme', columnName: 'diploma', entity: 'users_permissions_users' },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postalcode',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'study_competitor',
    label: 'Compétiteur',
    columnName: 'study_competitor',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'study_epicurean',
    label: 'Épicurien',
    columnName: 'study_epicurean',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'study_freethinker',
    label: 'Libre-penseur',
    columnName: 'study_freethinker',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'study_theorist',
    label: 'Théoricien',
    columnName: 'study_theorist',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'study_realistic',
    label: 'Réaliste',
    columnName: 'study_realistic',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'study_enterprising',
    label: 'Entreprenant',
    columnName: 'study_enterprising',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_trade_economy',
    label: 'Com./Éco.',
    columnName: 'love_trade_economy',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_arts_communication',
    label: 'Art/Com.',
    columnName: 'love_arts_communication',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_law_political_science',
    label: 'Droit/Sc. pol.',
    columnName: 'love_law_political_science',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_science_technology',
    label: 'Science/Tech',
    columnName: 'love_science_technology',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_health_care',
    label: 'Santé/Soins',
    columnName: 'love_health_care',
    type: 'number',
    entity: 'study_test_results',
  },
  {
    id: 'love_letter_humanities',
    label: 'Lettre/Huma.',
    columnName: 'love_letter_humanities',
    type: 'number',
    entity: 'study_test_results',
  },
];

export const minorTestBaseColumns = [
  {
    id: 'date',
    label: 'dates',
    columnName: 'realization_date',
    type: 'date',
    entity: 'response_users',
  },
  {
    id: 'firstname',
    label: 'prénom',
    columnName: 'firstname',
    type: 'string',
    entity: 'response_users',
  },
  {
    id: 'lastname',
    label: 'nom',
    columnName: 'lastname',
    type: 'string',
    entity: 'response_users',
  },
  {
    id: 'gender',
    label: 'sexe',
    columnName: 'gender',
    type: 'string',
    entity: 'users_permissions_users',
  },
  { id: 'age', label: 'âge', columnName: 'age', type: 'number', entity: 'users_permissions_users' },
  {
    id: 'diploma',
    label: 'diplôme',
    columnName: 'diploma',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'email',
    label: 'email',
    columnName: 'email',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'phone',
    label: 'téléphone',
    columnName: 'phone',
    type: 'string',
    entity: 'users_permissions_users',
  },
  {
    id: 'postal_code',
    label: 'code postal',
    columnName: 'postal_code',
    type: 'string',
    entity: 'users_permissions_users',
  },
];

export const columnsWithVariableStatique = [
  { id: 'date', label: 'dates', columnName: 'realization_date' },
  { id: 'prénom', label: 'prénom', columnName: 'firstname' },
  { id: 'nom', label: 'nom', columnName: 'lastname' },
  { id: 'sexe', label: 'sexe', columnName: 'gender' },
  { id: 'age', label: 'âge', columnName: 'age' },
  { id: 'diplome', label: 'diplôme', columnName: 'diploma' },
  { id: 'email', label: 'email', columnName: 'email' },
  { id: 'phone', label: 'téléphone', columnName: 'phone' },
  { id: 'postalcode', label: 'code postal', columnName: 'postal_code' },
];

export const columnsMesResultats = [
  { id: 'date', label: 'date', columnName: 'date' },
  { id: 'Nom du test', label: 'Nom du test', columnName: 'Nom du test' },
  { id: 'Résultat', label: 'Résultat', columnName: 'Résultat' },
];

export const columnsMesResultatsMobile = [
  { id: 'Nom du test', label: 'Nom du test', columnName: 'Nom du test' },
  { id: 'Résultat', label: 'Résultat', columnName: 'Résultat' },
  { id: 'date', label: 'date', columnName: 'date' },
];

export const columnsConsultations = [
  { id: 'consultation', label: 'CONSULTATION', columnName: 'CONSULTATION' },
  { id: 'projet', label: 'PROJET', columnName: 'PROJET' },
  { id: 'dateCreation', label: 'DATE DE CRÉATION', columnName: 'DATE DE CRÉATION' },
  { id: 'dateModification', label: 'DATE DE MODIFICATION', columnName: 'DATE DE MODIFICATION' },
  { id: 'synthese', label: 'SYNTHÈSE', columnName: 'SYNTHÈSE' },
  { id: 'echangeIA', label: 'ÉCHANGE IA', columnName: 'ÉCHANGE IA' },
];


export const backgroundChart = [
  { bg: '#ffff', bd: '#ffff', txtColor: '#23296F' },
  { bg: '#23296F', bd: '#23296F', txtColor: '#ffff' },
];

export const figure32_page1 = [
  {
    type: 'PRINCE / PRINCESSE',
    description: {
      __html:
        'Tous les groupes ont besoin d’un(e) leadeur(se) : <br /><br /> une personne qui prend des décisions, répartit les rôles et assume les responsabilités. Le(La) prince(sse) se rend utile et donne du sens à sa vie au travers de trois grands rôles : décider, représenter et assumer des responsabilités.',
    },
    img: 'prince.png',
    numero: 1,
    metiers: [
      'Entrepreneur(se)',
      'Dirigeant(e) d’entreprise',
      'Directeur(trice) d’association',
      'Directeur(trice) d’hôpital',
      'Maire',
      'Préfet(e)',
    ],
  },
  {
    type: 'CAPITAINE',
    description: {
      __html:
        'Le(La) capitaine seconde le(la) prince(sse). Il(Elle) est celui(celle) qui met en œuvre et fait appliquer ses décisions. Il(Elle) se rend utile et donne du sens à sa vie au travers de quatre grands rôles : commander, motiver, guider et contrôler.  <br /><br /> Le(La) capitaine est toujours lié(e) à un(e) prince(sse).',
    },
    img: 'capitaine.png',
    numero: 2,
    metiers: [
      'Manager(euse)',
      'Assistant(e)de direction',
      'Directeur(trice) adjoint',
      'Chef(fe) de service',
      'Attaché(e) parlementaire',
      '',
    ],
  },
  {
    type: 'SAGE',
    description: {
      __html:
        'Le(La) sage conseille. Il(Elle) cherche à améliorer la vie des autres et à les faire progresser. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : transmettre un savoir, apporter un conseil et apporter un progrès dans la réflexion.',
    },
    img: 'sage.png',
    numero: 3,
    metiers: [
      'Professeur(e)',
      'Éducateur(trice)',
      'Consultant(e)',
      'Formateur(trice)',
      'Coach',
      'Conseiller(ière)',
      'Conférencier(ère)',
      'Médiateur(trice)',
    ],
  },
  {
    type: 'GUÉRISSEUR / GUÉRISSEUSE',
    description: {
      __html:
        'Le(La) guérisseur(se) soigne les maux physiques et psychiques qui touchent ses semblables. <br /><br /> Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : écouter pour soulager les souffrances, prévenir les maladies et soigner les malades.',
    },
    img: 'guerisseur.png',
    numero: 4,
    metiers: [
      'Médecin',
      'Infirmier(ère)',
      'Vétérinaire',
      'Kinésithérapeute',
      'Psychologue',
      'Pharmacien(ne)',
      'Sophrologue',
      'Naturopathe',
    ],
  },
  {
    type: 'SCIENTIFIQUE',
    description: {
      __html:
        'Le(La) scientifique cherche, découvre et invente. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : chercher de nouvelles connaissances, expliquer le fonctionnement du monde et inventer de nouvelles machines.',
    },
    img: 'scientifique.png',
    numero: 5,
    metiers: [
      'Chercheur(se) au CNRS',
      'Professeur(e) des Universités',
      'Maître de conférences',
      'Ingénieur(e) R&D',
      'Inventeur(trice)',
      'Sociologue',
    ],
  },
  {
    type: 'ALCHIMISTE',
    description: {
      __html:
        'L’alchimiste analyse et transforme la matière. Il(Elle) se rend utile et donne du sens à sa vie au travers de deux grands rôles : analyser les matières et les matériaux (air, eau, bois, métaux etc.) et transformer les matières et les matériaux grâce à la science. ',
    },
    img: 'alchimiste.png',
    numero: 6,
    metiers: [
      'Technicien(ne) de laboratoire',
      'Technicien(ne) chimiste',
      'Chargé(e) étude qualité de l’air',
      'Chargé(e) étude qualité de l’eau',
    ],
  },
];

export const figure32_page2 = [
  {
    type: 'VISIONNAIRE',
    description: {
      __html:
        'Le(La) visionnaire manipule et développe les nouvelles technologies de l’information pour faciliter la vie des gens. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : imaginer, développer et optimiser des technologies connectées.',
    },
    img: 'visionnaire.png',
    numero: 7,
    metiers: [
      'Web développeur(se)',
      'Créateur(trice) d’applications',
      'Ingénieur(e) systèmes d’informations',
      'Domoticien(ne)',
      'Ingénieur(e) robotique',
      '',
    ],
  },
  {
    type: 'MARCHAND / MARCHANDE',
    description: {
      __html:
        'Le(La) marchand(e) passe son temps à mettre des personnes en relation. Il(Elle) souhaite offrir un service ou une marchandise à son(sa) client(e). Il(Elle) se rend utile et donne du sens à sa vie au travers d’un rôle central : faciliter les échanges de biens et de services entre les personnes.',
    },
    img: 'marchand.png',
    numero: 8,
    metiers: [
      'Commercial(e)',
      'Responsable de boutique',
      'Négociant(e)',
      'Chargé(e) d’affaires',
      'Responsable de centre de profit',
      'Vendeur(se)',
    ],
  },
  {
    type: 'ARTISTE',
    description: {
      __html:
        'L’artiste crée de nouvelles façons de penser, d’agir et de voir le monde. Il(Elle) crée de nouveaux objets ou de nouveaux concepts. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : créer pour amuser, créer pour faire réfléchir et créer pour embellir.',
    },
    img: 'artiste.png',
    numero: 9,
    metiers: [
      'Romancier(ère)',
      'Scénariste',
      'Peintre',
      'Photographe',
      'Comique',
      'Sculpteur(trice)',
      'Illustrateur(trice)',
      'Réalisateur(trice)',
    ],
  },
  {
    type: 'FORGERON / FORGERONNE',
    description: {
      __html:
        'Le(La) forgeron(ne) a en charge la fabrication, la transformation et la réparation de tous les objets que les personnes utilisent dans leur vie quotidienne. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : fabriquer, transformer et réparer. ',
    },
    img: 'forgeron.png',
    numero: 10,
    metiers: [
      'Chef(fe) d’atelier de confection textile',
      'Responsable d’une chaîne de montage',
      'Menuisier(ère)',
      'Relieur(se)',
      'Horloger(ère)',
      'Plombier(ère)',
    ],
  },
  {
    type: 'COMPAGNON / COMPAGNONNE',
    description: {
      __html:
        'Le(La) compagnon(ne) est l’assistant(e) du(de la) forgeron(ne). Il(Elle) met en œuvre les techniques du(de la) forgeron(ne) et l’assiste dans ses tâches de fabrication, de transformation et de réparation. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : fabriquer, transformer et réparer des objets du quotidien. ',
    },
    img: 'compagnon.png',
    numero: 11,
    metiers: [
      'Agent de maintenance',
      'Agent de fabrication',
      'Conducteur(trice) d’installation en usine',
      'Opérateur(trice) sur chaîne de montage',
      'Artisan',
      'Ouvrier(ère)',
    ],
  },
  {
    type: 'SHÉRIF',
    description: {
      __html:
        'Le(La) shérif fait respecter l’ordre et la loi dans la société. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : protéger les victimes, arrêter les suspects et éduquer les citoyen(ne)s au respect de la loi et des règlements.',
    },
    img: 'sherif.png',
    numero: 12,
    metiers: [
      'Policier(ère)',
      'Agent de sécurité',
      'Militaire',
      'Commissaire de police',
      'Gardien(ne) de prison',
      'Éducateur(trice) spécialisé(e)',
    ],
  },
  {
    type: 'JURISTE',
    description: {
      __html:
        'Le(La) juriste intervient dans toutes les procédures qui impliquent le recours à la justice. <br/> <br/> Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : rendre des jugements, défendre les intérêts de ses client(e)s et appliquer les procédures de justice.',
    },
    img: 'juriste.png',
    numero: 13,
    metiers: [
      'Juge aux affaires familiales',
      'Avocat(e) d’affaires',
      'Notaire',
      'Huissier(ière) de justice',
      'Député(e)',
      'Greffier(ière)',
      '',
    ],
  },
];
export const figure32_page3 = [
  {
    type: 'INTENDANT / INTENDANTE',
    description: {
      __html:
        'L’intendant(e) gère les ressources matérielles, humaines et financières d’une entreprise, d’une administration ou d’un État. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : allouer, optimiser et contrôler.',
    },
    img: 'intendant.png',
    numero: 14,
    metiers: [
      'Responsable des ressources humaines',
      'Responsable financier(ière) Comptable',
      'Administrateur(trice) de biens',
      'Magasinier(ière)',
      'Chef(fe) d’entrepôt',
    ],
  },
  {
    type: 'ARCHITECTE',
    description: {
      __html:
        'L’architecte façonne l’environnement. Il(Elle) construit, redessine ou aménage les lieux où vivent les femmes et les hommes. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : construire, aménager et embellir. ',
    },
    img: 'architecte.png',
    numero: 15,
    metiers: [
      'Architecte',
      'Urbaniste',
      'Paysagiste',
      'Designer(euse) d’intérieur et d’espace',
      'Ingénieur(e) des Ponts',
    ],
  },
  {
    type: 'BÂTISSEUR / BÂTISSEUSE',
    description: {
      __html:
        'Le(La) bâtisseur(se) concrétise les plans de l’architecte : l’architecte pense, le(la) bâtisseur(se) agit. Il(Elle) se rend utile et donne du sens à sa vie au travers d’un rôle central : bâtir et transformer le monde en fonction des plans de l’architecte. ',
    },
    img: 'batisseur.png',
    numero: 16,
    metiers: [
      'Conducteur(trice) de travaux',
      'Métreur(euse)',
      'Peintre en bâtiment',
      'Couvreur(euse)',
      'Conducteur(trice) d’engins de chantier',
      'Électricien(ne)',
    ],
  },
  {
    type: 'SCRIBE',
    description: {
      __html:
        'Le(La) scribe maîtrise l’art de communiquer, que cela soit par le biais du texte ou par celui des images, auprès d’un grand nombre de personnes. Il(Elle) se rend utile et donne du sens à sa vie au travers de deux grands rôles : communiquer et influencer. ',
    },
    img: 'scribe.png',
    numero: 17,
    metiers: [
      'Journaliste',
      'Chargé(e) de communication',
      'Attaché(e) de presse',
      'Écrivain(e) public',
      'Ingénieur(se) pédagogique',
      'Consultant(e) V.A.E',
    ],
  },
  {
    type: 'AUBERGISTE',
    description: {
      __html:
        'L’aubergiste accueille les personnes. Il(Elle) leur offre à manger, à boire et un endroit confortable pour dormir. Il(Elle) se rend utile et donne du sens à sa vie au travers d’un rôle central : apporter du confort à des personnes de façon temporaire lors d’un voyage ou le temps d’un dîner. ',
    },
    img: 'aubergiste.png',
    numero: 18,
    metiers: [
      'Maître(sse) d’hôtel',
      'Restaurateur(trice)',
      'Serveur(se)',
      'Responsable d’un hôtel',
      'Responsable d’un SPA',
      'Hôte(sse) d’accueil',
      'Responsable d’un parc d’attraction',
    ],
  },
  {
    type: 'CUISINIER / CUISINIÈRE',
    description: {
      __html:
        'Le(La) cuisinier(ère) transforme les matières alimentaires en mets destinés à émerveiller les papilles et remplir les estomacs. Il(Elle) se rend utile et donne du sens à sa vie au travers d’un rôle central : nourrir en donnant du plaisir. ',
    },
    img: 'cuisinier.png',
    numero: 19,
    metiers: [
      'Chef(fe) de cuisine dans un restaurant',
      'Boulanger(ère)',
      'Boucher(ère)',
      'Charcutier(ère)',
      'Traiteur',
      'Chocolatier(ère) confiseur(euse)',
      'Pâtissier(ère)',
      'Gérant(e) d’un salon de thé',
    ],
  },
  {
    type: 'AGRICULTEUR / AGRICULTRICE',
    description: {
      __html:
        'L’agriculteur(trice) exploite les ressources offertes par la nature et notamment par la terre pour nourrir autrui. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : fertiliser, semer et cueillir. ',
    },
    img: 'agriculteur.png',
    numero: 20,
    metiers: [
      'Exploitant(e) agricole',
      'Éleveur(euse) de bovins',
      'Marin/Pêcheur',
      'Maraîcher(ère)',
      'Horticulteur(trice)',
      'Apiculteur(trice)',
      'Fromager(ère)',
      'Berger(ère)',
      'Exploitant(e) forestière',
    ],
  },
];
export const figure32_page4 = [
  {
    type: 'NOURRICE',
    description: {
      __html:
        'La nourrice a la charge des jeunes enfants, des personnes âgées et des personnes souffrant d’un handicap lourd. Elle se rend utile et donne du sens à sa vie au travers de quatre grands rôles : nourrir, apporter des soins, éduquer et distraire.',
    },
    img: 'nourrice.png',
    numero: 21,
    metiers: [
      'Auxiliaire de puériculture',
      'Infirmier(ère) puériculteur(trice)',
      'Assistant(e) de vie aux familles',
      'Assistant(e) médico-psychologique',
      'Assistant(e) maternelle',
      '',
    ],
  },
  {
    type: 'DRESSEUR / DRESSEUSE',
    description: {
      __html:
        'Le(La) dresseur(se) est proche des animaux domestiques ou sauvages. Il(Elle) les élève, prend soin d’eux et les dresse. Il(Elle) se rend utile et donne du sens à sa vie au travers de quatre grands rôles : élever les animaux, leur apporter des soins, les éduquer et les dresser. ',
    },
    img: 'dresseur.png',
    numero: 22,
    metiers: [
      'Dresseur(se) de chiens',
      'Conducteur(trice) de chiens de traîneaux',
      'Gérant(e) de chenil',
      'Zoologiste',
      'Psychologue pour animaux',
      'Éthologue',
      'Toiletteur(euse)',
    ],
  },
  {
    type: 'CHIFFONNIER / CHIFFONNIÈRE',
    description: {
      __html:
        'Le(La) chiffonnier(ère) récupère, trie et exploite les déchets de la société. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : collecter les déchets, trier les déchets, détruire ou valoriser les déchets.',
    },
    img: 'chiffonnier.png',
    numero: 23,
    metiers: [
      'Gestionnaire de déchets',
      'Conducteur(trice) d’incinérateurs',
      'Ripper',
      'Agent de recyclage',
      'Ingénieur(e) traitement des déchets nucléaires',
    ],
  },
  {
    type: 'MESSAGER / MESSAGÈRE',
    description: {
      __html:
        'Le(La) messager(ère) transporte les femmes, les hommes, les animaux et/ou les marchandises. Il(Elle) se rend utile et donne du sens à sa vie au travers d’un rôle central : acheminer les personnes, les animaux et/ou les marchandises d’un point A à un point B en respectant les délais et la sécurité. ',
    },
    img: 'messager.png',
    numero: 24,
    metiers: [
      'Chauffeur(se) de taxi',
      'Chauffeur(se)VTC',
      'Chauffeur(se) de cars de tourisme',
      'Chauffeur(se) de poids lourds',
      'Conducteur(trice) de train',
      'Capitaine de bateau',
      'Pilote de ligne',
    ],
  },
  {
    type: 'TRÉSORIER / TRÉSORIÈRE',
    description: {
      __html:
        'Le(La) trésorier(ère) s’occupe de tout ce qui a trait à l’argent et aux pierres précieuses. Il(Elle) se rend utile et donne du sens à sa vie au travers de quatre grands rôles : conserver de l’argent, le prêter, le placer et le faire fructifier. ',
    },
    img: 'tresorier.png',
    numero: 25,
    metiers: [
      'Conseiller(ère) clientèle',
      'Investisseur(se)',
      'Trader',
      'Gestionnaire de patrimoine',
      'Concepteur(trice) de produits financiers',
      'Analyste de risques',
      'Analyste fusion et acquisition',
    ],
  },
  {
    type: 'ASSUREUR / ASSUREUSE',
    description: {
      __html:
        'L’assureur(se) évalue les risques d’accidents ou de catastrophes et dédommage les personnes quand survient un sinistre. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : évaluer les risques, assurer les biens et les personnes, dédommager les personnes. ',
    },
    img: 'assureur.png',
    numero: 26,
    metiers: [
      'Gestionnaire de sinistres',
      'Actuaire',
      'Expert(e) en assurances',
      'Souscripteur(trice)',
      'Agent général d’assurances',
      'Courtier(ère) en assurances',
      'Conseiller(ère) commercial(e) en assurances',
    ],
  },
  {
    type: 'NATURALISTE',
    description: {
      __html:
        'Le(La) naturaliste étudie la nature et agit pour la préserver des méfaits de l’Homme. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : étudier la nature, préserver la nature et sensibiliser à la protection de la nature.',
    },
    img: 'naturaliste.png',
    numero: 27,
    metiers: [
      'Responsable de parc régional',
      'Ingénieur(e) des eaux et forêts',
      'Océanologue',
      'Agent d’entretien de l’espace rural',
      'Technicien(ne) de rivières',
      'Entomologiste / Botanist',
    ],
  },
];
export const figure32_page5 = [
  {
    type: 'SAUVEUR / SAUVEUSE',
    description: {
      __html:
        'Le(La) sauveur(se) a en charge les pauvres, les marginaux et ceux qui ont commis des actes répréhensibles au sein de la société. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : nourrir et protéger, écouter et dialoguer, éduquer et réinsérer.',
    },
    img: 'sauveur.png',
    numero: 28,
    metiers: [
      'Assistant(e) de service social',
      'Conseiller(ère) d’insertion et de probation',
      'Conseiller(ère) en économie sociale et familiale',
      'Responsable chantier d’insertion',
      'Éducateur(trice) spécialisé(e)',
    ],
  },
  {
    type: 'TAILLEUR/ TAILLEUSE',
    description: {
      __html:
        'Le(La) tailleur(se) crée et fabrique les vêtements ainsi que tous les objets en tissu. Il(Elle) sait manipuler les tissus et les peaux. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : créer des patrons et des modèles, fabriquer des vêtements et des objets en tissu et les adapter aux demandes de ses client(e)s. ',
    },
    img: 'tailleur1.png',
    numero: 29,
    metiers: [
      'Styliste de mode',
      'Créateur(trice) de vêtements',
      'Créateur(trice) de bijoux',
      'Couturier(ère)',
      'Modéliste',
      'Sourceur(se) de matériaux de création',
    ],
  },
  {
    type: 'SOLDAT / SOLDATE',
    description: {
      __html:
        'Le(La) soldat(e) combat pour défendre son pays, annexer de nouveaux territoires ou faire régner l’ordre dans d’autres pays ou dans certaines régions. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : attaquer, défendre et maintenir la paix. ',
    },
    img: 'soldat.png',
    numero: 30,
    metiers: [
      'Soldat(e) / Tireur(euse) d’élite',
      'Conducteur(trice) de char',
      'Pilote d’avion de chasse',
      'Artilleur(euse)',
      'Capitaine d’infanterie',
      'Sous-marinier(ère)',
      'Mercenaire',
    ],
  },
  {
    type: 'GUIDE',
    description: {
      __html:
        'Le(La) guide a en charge les voyageur(se)s qui viennent visiter son pays ou qui souhaitent se rendre dans des pays étrangers. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : organiser les voyages, faire découvrir des curiosités et faire découvrir de nouvelles contrées.',
    },
    img: 'guide.png',
    numero: 31,
    metiers: [
      'Guide interprète',
      'Guide dans un musée',
      'Conseiller(ère) voyage',
      'Guide de haute montagne',
      'Moniteur(trice) de ski',
      'Moniteur(trice) de sport',
    ],
  },
  {
    type: 'EMBAUMEUR / EMBAUMEUSE',
    description: {
      __html:
        'L’embaumeur(se) a en charge les morts. Il(Elle) se rend utile et donne du sens à sa vie au travers de trois grands rôles : conserver et embellir le corps des morts, conduire la sépulture des défunts et protéger leur tombe ou leurs cendres. ',
    },
    img: 'embaumeur.png',
    numero: 32,
    metiers: [
      'Thanatopracteur(trice)',
      'Médecin légiste',
      'Maître(sse) de cérémonie',
      'Entrepreneur(se) des pompes funèbres',
      'Rédacteur(trice) de faire-part de décès',
      '',
    ],
  },
];
export const columnsMesRessources = [
  { id: 'nom', label: 'nom', columnName: 'nom' },
  { id: 'type', label: 'type', columnName: 'type' },
  { id: 'date', label: 'date d’assignation', columnName: 'date' },
  { id: 'etat', label: 'Lu / Non lu', columnName: 'etat' },
  { id: 'action', label: 'action', columnName: 'action' },
  { id: 'consultatio', label: 'date dernière consultation', columnName: 'consultation' },
];

export const columnsMesRessourcesMobiles = [
  { id: 'nom', label: 'nom', columnName: 'nom' },
  { id: 'type', label: 'type', columnName: 'type' },
  { id: 'action', label: 'action', columnName: 'action' },
  { id: 'date', label: 'date d’assignation', columnName: 'date' },
  { id: 'etat', label: 'Lu / Non lu', columnName: 'etat' },
  { id: 'consultatio', label: 'date dernière consultation', columnName: 'consultation' },
];

export const book = [
  {
    id: 0,
    nom: 'e-book 1',
    type: 'EBOOK',
    date: '12/05/2022',
    etat: 'Lu',
    consultation: '12/05/2022',
  },
];

export const getTestColumnsByTestId = (testId: any) => {
  let tableColumns: any;
  switch (testId) {
    case 1:
      tableColumns = meaningColumns;
      break;
    case 2:
      tableColumns = needsColumns;
      break;
    case 3:
      tableColumns = needsProColumns;
      break;
    case 4:
      tableColumns = prefPersoColumns;
      break;
    case 5:
      tableColumns = columns;
      break;
    case 6:
      tableColumns = studyColumns;
      break;
    case 7:
      tableColumns = prefPersoColumns;
      break;
    // default is harmony columns
    default:
      tableColumns = columns;
  }
  return tableColumns;
};

export const COMPANY_USER_ROLE = {
  manager_4: 1,
  manager_3: 2,
  manager_2: 3,
  manager_1: 4,
  beneficiary: 5,
};

export const resultatWithColor: any = {
  compliance: {
    color: '#0079DE',
    img: `conformite.png`,
    colorSecondary: '#80BDEF',
    opacity: true,
    longText:
      'Vous êtes une personne modérée. Vous recherchez la modération dans vos actions et vos pensées. Cela signifie que vous n’appréciez pas ce qui est radical, extrême ou excessif. Vous vous refusez à adopter des comportements ou des opinions susceptibles de déstabiliser ou de blesser les autres, ou encore de transgresser les normes. Sur le plan professionnel, vous recherchez un métier conventionnel, dans un environnement structuré, stable et constant. Vous évitez tout ce qui est nouveau et disruptif.',
    text1:
      'Si la valeur de <b>conformité</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur de conformité dans votre carrière professionnelle, en choisissant des organisations et des rôles alignés avec vos principes tout en vous permettant de maintenir un niveau de compétences élevé dans votre domaine.',
    listeAccordeon: [
      {
        title: 'Comprenez les règles et les normes de votre secteur',
        description:
          'Informez-vous sur les lois, les régulations et les pratiques professionnelles qui régissent votre domaine d’activité. Cette connaissance vous permettra de vous assurer que vous respectez les normes en vigueur.',
      },
      {
        title: 'Choisissez des organisations avec des valeurs alignées',
        description:
          'Recherchez des entreprises dont les valeurs et la culture d’entreprise correspondent à votre propre sens de la conformité. Cela vous permettra de vous épanouir dans un environnement qui reflète et soutient vos principes.',
      },
      {
        title: 'Développez des compétences en matière de communication et de négociation',
        description:
          'Savoir communiquer clairement et efficacement, ainsi que négocier avec les autres, peut vous aider à naviguer dans des situations où la conformité aux règles et aux normes est importante.',
      },
      {
        title: 'Soyez attentif(ve) aux détails',
        description:
          'La conformité implique souvent de respecter des processus et des procédures précises. Cultivez une attention aux détails pour vous assurer que vous suivez les règles et les directives établies.',
      },
      {
        title: 'Prenez des responsabilités dans la gestion des risques et la conformité',
        description:
          'Si la conformité est une valeur importante pour vous, envisagez de vous spécialiser dans des rôles liés à la gestion des risques, à la conformité réglementaire ou à l’audit interne. Ces postes vous permettront d’avoir un impact direct sur la conformité au sein de votre organisation.',
      },
      {
        title: 'Cultivez l’intégrité et l’éthique professionnelle',
        description:
          'Agissez avec intégrité et éthique dans toutes vos actions professionnelles. Ces qualités vous permettront de gagner la confiance de vos collègues et de vos supérieurs, tout en respectant les normes et les valeurs auxquelles vous tenez.',
      },
      {
        title: 'Renseignez-vous sur les meilleures pratiques de votre secteur',
        description:
          'Restez informé(e) des meilleures pratiques et des tendances dans votre domaine pour vous assurer que vous respectez les normes et les attentes de votre secteur.',
      },
      {
        title: 'Participez à des formations et des ateliers sur la conformité',
        description:
          'Investissez dans votre formation continue en participant à des formations, des ateliers ou des conférences sur la conformité et les régulations spécifiques à votre secteur. Cela vous permettra de maintenir vos connaissances à jour et de renforcer votre engagement envers la conformité.',
      },
      {
        title: 'N’hésitez pas à demander des conseils',
        description:
          'Si vous rencontrez des situations complexes ou incertaines, n’hésitez pas à demander conseil à des collègues expérimenté(e)s, des mentors ou des expert(e)s en conformité. Leur expérience et leur expertise pourront vous aider à prendre des décisions éclairées.',
      },
      {
        title: 'Soyez prêt(e) à vous adapter aux changements',
        description:
          'Les régulations et les normes peuvent évoluer avec le temps. Faites preuve de souplesse et d’adaptabilité pour vous conformer aux nouvelles exigences et maintenir votre engagement envers la conformité.',
      },
    ],
    listEmploi1: [
      'Comptable / Expert-comptable',
      'Auditeur(trice) interne / Auditeur(trice) externe',
      'Juriste / Avocat(e) d’affaires',
      'Analyste en conformité / Responsable conformité',
      'Inspecteur(trice) des impôts / Contrôleur(se) fiscal(e)',
      'Contrôleur(se) de gestion ',
      'Agent administratif / Secrétaire',
      'Rédacteur(trice) technique / Rédacteur(trice) juridique',
      'Gestionnaire de dossiers médicaux',
      'Fonctionnaire / Employé(e) de l’administration publique',
    ],
    listEmploi2: [
      'Analyste en assurance qualité / Responsable qualité ',
      'Agent immobilier / Gestionnaire de biens ',
      'Gestionnaire des ressources humaines / Assistant(e) RH',
      'Bibliothécaire / Documentaliste',
      'Pharmacien(ne) / Préparateur(trice) en pharmacie',
      'Gestionnaire de stocks / Logisticien(ne)',
      'Opérateur(trice) de saisie / Opérateur(trice) de traitement de données ',
      'Gestionnaire de projet / Coordinateur(trice) de projets',
      'Agent de sécurité / Gardien(ne) ',
      'Technicien(ne) en informatique / Administrateur(trice) système',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>conformité</b>. Ces professions impliquent généralement le respect des règles, des procédures et des normes établies, ainsi que l’importance de travailler de manière structurée et organisée :',
    text4:
      'Ces métiers requièrent généralement de la rigueur, de la précision, de l’organisation et le respect des protocoles établis. Ils sont souvent axés sur la conformité aux normes légales, réglementaires ou de qualité, et impliquent de travailler avec des informations détaillées et complexes. Les personnes travaillant dans ces domaines contribuent à la stabilité et à la bonne gestion des organisations.',
  },
  universalism: {
    color: '#CA2F40',
    img: `Universalisme.png`,
    colorSecondary: '#E598A0',
    opacity: true,
    longText:
      'Vous voulez changer le monde. Vous êtes un(e) idéaliste, un(e) utopiste, un(e) visionnaire. Votre vision des choses, vous avez envie de la faire partager, d’amener un vrai progrès pour la société dans laquelle vous vivez. Les valeurs, c’est ce qui compte le plus pour vous avant toutes autres considérations matérielles. Vous n’êtes pas vraiment intéressé(e) par l’argent ou le confort, ce qui vous intéresse c’est de voir les choses évoluer dans le sens voulu. Sur le plan professionnel, vous avez besoin d’un vrai projet auquel adhérer dans votre entreprise ou votre organisation.',
    text1:
      'Si la valeur d’<b>universalisme</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur d’universalisme qui vous est chère dans votre carrière professionnelle en choisissant des organisations tournées vers un idéal et des objectifs à vocation universaliste.',
    listeAccordeon: [
      {
        title: 'Recherchez des secteurs et des organisations axés sur l’impact global',
        description:
          'Orientez-vous vers des domaines d’activité et des entreprises qui ont une portée internationale ou qui œuvrent pour des causes mondiales, telles que la protection de l’environnement, la lutte contre la pauvreté ou la promotion de l’éducation.',
      },
      {
        title: 'Développez des compétences interculturelles',
        description:
          'Pour travailler efficacement dans un contexte international, il est essentiel de développer des compétences en communication interculturelle. Apprenez différentes langues et familiarisez-vous avec les coutumes et les valeurs culturelles de différentes régions du monde.',
      },
      {
        title: 'Poursuivez des études ou des formations liées aux questions mondiales',
        description:
          'Investissez dans votre formation et votre développement professionnel en suivant des cours, des ateliers ou des conférences sur des sujets tels que les relations internationales, les droits de l’homme, le développement durable ou la coopération internationale.',
      },
      {
        title: 'Réseautez avec des professionnels du monde entier',
        description:
          'Élargissez votre réseau professionnel en participant à des conférences, des événements et des forums internationaux. Cela vous permettra de rencontrer des personnes partageant les mêmes valeurs et de découvrir des opportunités de carrière à l’échelle mondiale.',
      },
      {
        title: 'Engagez votre dans des projets internationaux',
        description:
          'Recherchez des opportunités pour travailler sur des projets ayant un impact international, que ce soit au sein de votre entreprise ou en tant que bénévole pour une organisation non gouvernementale (ONG) ou une institution internationale.',
      },
      {
        title: 'Favorisez la diversité et l’inclusion sur votre lieu de travail',
        description:
          'Œuvrez pour la promotion de la diversité et de l’inclusion au sein de votre organisation, en encourageant des pratiques de recrutement équitables, en soutenant des initiatives de formation interculturelle et en créant un environnement de travail respectueux et inclusif.',
      },
      {
        title: 'Soyez ouvert(e) aux nouvelles perspectives et aux idées innovantes',
        description:
          'L’universalisme implique d’être ouvert(e) aux différentes perspectives et aux idées innovantes qui peuvent contribuer à l’amélioration de la situation mondiale. Encouragez l’échange d’idées et la collaboration entre collègues et partenaires internationaux.',
      },
      {
        title:
          'Prenez en compte l’impact environnemental et social de vos actions professionnelles',
        description:
          'Intégrez les préoccupations environnementales et sociales dans vos décisions professionnelles, en veillant à minimiser votre empreinte écologique et à promouvoir des pratiques de travail éthiques et responsables.',
      },
      {
        title: 'Impliquez-vous dans des initiatives de développement durable',
        description:
          'Participez à des projets et des initiatives visant à promouvoir le développement durable et à résoudre les défis mondiaux, tels que le changement climatique, la préservation de la biodiversité ou la réduction des inégalités.',
      },
      {
        title: 'Cultivez l’empathie et la compassion',
        description:
          'L’universalisme implique de se soucier du bien-être de tous, indépendamment des frontières géographiques ou culturelles. Cultivez l’empathie et la compassion envers les autres, et agissez de manière à soutenir le bien-être collectif.',
      },
    ],
    listEmploi1: [
      'Travailleur(se) humanitaire / Coopérant(trice) international(e)',
      'Diplomate / Fonctionnaire international(e)',
      'Écologiste / Biologiste de la conservation',
      'Responsable du développement durable / Responsable RSE (Responsabilité Sociétale des Entreprises)',
      'Expert(e) en droits de l’homme / Avocat(e) spécialisé(e) en droits de l’homme ',
      'Chercheur en études internationales / Politologue ',
      'Professeur de langues étrangères / Linguiste ',
      'Médecin sans frontières / Infirmier(ère) sans frontières',
      'Journaliste spécialisé(e) en affaires internationales / Correspondant(e) à l’étranger ',
      'Anthropologue / Ethnologue',
      'Coordinateur(trice) de projets internationaux / Chef(fe) de projets',
    ],
    listEmploi2: [
      'Ingénieur spécialisé(e) en énergies renouvelables / Expert(e) en transition énergétique',
      'Urbaniste / Architecte spécialisé(e) en développement durable ',
      'Chargé(e) de mission en coopération internationale / Coopération décentralisée',
      'Économiste du développement / Expert(e) en microfinance ',
      'Spécialiste en gestion des déchets / Économie circulaire',
      'Activiste / Lobbyiste pour les droits de l’homme ou l’environnement',
      'Expert(e) en éducation interculturelle / Formateur(trice) en diversité culturelle',
      'Expert(e) en politiques migratoires / Intégration des réfugiés',
      'Spécialiste en commerce équitable / Développement local',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur d’<b>universalisme</b>. Ces professions sont généralement axées sur la promotion de l’égalité, la protection de l’environnement, la compréhension interculturelle et le bien-être global :',
    text4:
      'Ces métiers requièrent généralement une sensibilité aux questions sociales, culturelles et environnementales, ainsi qu’une volonté d’agir pour un monde plus juste, inclusif et durable. Les personnes travaillant dans ces domaines contribuent à la promotion de l’égalité, à la protection de l’environnement et à la compréhension entre les différentes cultures et communautés.',
  },
  hedonism: {
    color: '#FFB0A4',
    img: `Hedonisme.png`,
    colorSecondary: '#834144',
    longText:
      'Vous êtes un(e) hédoniste. Vous recherchez le plaisir avant tout. Ce plaisir, vous le tirez de vos sens mais aussi de votre intellect. Vous entretenez une relation sensuelle à votre environnement. Vous avez besoin d’évoluer dans un environnement qui flatte par sa beauté, par les sensations qu’il procure. Sur le plan professionnel, cela se traduit par la recherche du beau, de l’excellence et de l’harmonie. Vous avez besoin d’évoluer dans un milieu où l’activité, le produit, votre environnement relationnel et matériel sont une source continue de plaisir.',
    text1:
      'Si la valeur d’<b>hédonisme</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur d’hédonisme dans votre carrière professionnelle, et prendre ainsi du plaisir et ressentir du bien-être dans l’accomplissement de vos tâches au quotidien.',
    listeAccordeon: [
      {
        title: 'Identifiez vos passions et ce qui vous procure du plaisir',
        description:
          'Faites le point sur ce que vous aimez faire et ce qui vous rend heureux(se). Cela vous permettra de déterminer les domaines dans lesquels vous vous sentirez le(a) plus épanoui(e) et satisfait(e) dans votre travail.',
      },
      {
        title: 'Choisissez un secteur ou un métier qui vous passionne',
        description:
          'Pour maximiser votre plaisir au travail, choisissez un secteur d’activité ou un métier qui correspond à vos centres d’intérêt et à vos passions. Ainsi, votre travail vous procurera satisfaction et plaisir au quotidien.',
      },
      {
        title: 'Valorisez un environnement de travail agréable',
        description:
          'Recherchez des organisations et des postes qui offrent des conditions de travail plaisantes, telles qu’un bon équilibre entre vie professionnelle et vie personnelle, une atmosphère détendue ou des avantages sociaux intéressants.',
      },
      {
        title: 'Soyez attentif(ve) à l’ambiance et à la culture d’entreprise',
        description:
          'L’environnement dans lequel vous travaillez peut grandement influencer votre bien-être et votre plaisir au travail. Recherchez des entreprises ayant une culture d’entreprise positive, où la convivialité et le soutien entre collègues sont valorisés.',
      },
      {
        title: 'Créez des relations positives au travail',
        description:
          'Établir des relations amicales et de confiance avec vos collègues peut améliorer votre expérience de travail et contribuer à votre plaisir professionnel. Prenez le temps de tisser des liens avec les personnes qui vous entourent.',
      },
      {
        title: 'Fixez-vous des objectifs réalistes',
        description:
          'Bien qu’il soit important de viser le plaisir dans votre travail, il est également essentiel de rester réaliste quant à vos objectifs professionnels. Évitez de vous imposer une pression excessive et de vous surcharger de travail, ce qui pourrait nuire à votre bien-être.',
      },
      {
        title: 'Soyez flexible et ouvert(e) aux opportunités',
        description:
          'L’hédonisme implique parfois de saisir des opportunités inattendues qui vous permettront d’explorer de nouvelles expériences professionnelles plaisantes. Soyez ouvert(e) aux changements et aux nouvelles expériences pour maximiser votre plaisir au travail.',
      },
      {
        title: 'Trouvez un équilibre entre travail et plaisir',
        description:
          'Il est important de maintenir un équilibre entre votre travail et les autres aspects de votre vie qui vous procurent du plaisir. Assurez-vous de consacrer du temps à vos loisirs, à vos ami(e)s et à votre famille pour préserver votre bien-être général.',
      },
      {
        title: 'Cultivez la gratitude et l’appréciation',
        description:
          'Prenez le temps de reconnaître et d’apprécier les aspects positifs de votre travail et de votre vie. La gratitude peut vous permettre de vous concentrer sur les éléments qui vous procurent du plaisir et de renforcer votre bien-être professionnel.',
      },
      {
        title: 'N’oubliez pas l’importance de la croissance personnelle',
        description:
          'Le plaisir au travail ne doit pas se faire au détriment de votre développement personnel et professionnel. Trouvez des moyens d’équilibrer votre plaisir avec l’acquisition de nouvelles compétences et la réalisation de projets stimulants.',
      },
    ],
    listEmploi1: [
      'Acteur / Actrice Musicien(ne)',
      'Musicien(ne) / Chanteur(se)',
      'Danseur / Danseuse',
      'DJ (disc-jockey) / Producteur(trice) de musique',
      'Artiste peintre / Sculpteur(se)',
      'Écrivain / Auteur',
      'Comédien(ne) / Humoriste',
      'Chef(fe) cuisinier(ère)/ Pâtissier(ère)',
      'Sommelier(ère) / Expert(e) en vins',
      'Designer(euse) de mode / Styliste',
    ],
    listEmploi2: [
      'Photographe / Vidéaste',
      'Maquilleur(se) / Coiffeur(se) / Styliste personnel(le)',
      'Wedding planner / Organisateur(trice) de mariages',
      'Animateur(trice) de télévision / de radio',
      'Critique gastronomique / Critique de cinéma',
      'Blogueur(se) / Influenceur(se) lifestyle',
      'Designer(euse) de jeux vidéo / Game designer(euse)',
      'Barman(barmaid) / Mixologiste ',
      'Guide touristique / Guide de voyage',
      'Coach sportif / Coach bien-être',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur d’<b>hédonisme</b>. Ces professions sont généralement associées à des activités agréables, divertissantes ou créatives, permettant de profiter de la vie et d’apporter du plaisir aux autres :',
    text4:
      'Ces métiers mettent souvent l’accent sur la créativité, la passion et la recherche du plaisir. Ils impliquent généralement de travailler dans des environnements stimulants et divertissants et d’interagir avec des personnes partageant les mêmes centres d’intérêt. Ces professions offrent la possibilité de s’épanouir en faisant ce que l’on aime et en apportant du plaisir aux autres.',
  },
  power: {
    color: '#FD9E3A',
    img: `Pouvoir.png`,
    colorSecondary: '#AA6B28',
    longText:
      'Vous êtes animé(e) par une quête de pouvoir et d’influence. Que cela soit par l’argent, vos réseaux, votre statut ou votre intelligence, vous cherchez à développer votre pouvoir sur le monde et les gens qui vous entourent. Sur le plan professionnel, vous tirez votre puissance de votre statut, qui doit être élevé dans la hiérarchie, de votre capacité à influencer et à convaincre. Cela nécessite chez vous de développer des compétences politiques pour pouvoir gravir au plus vite les échelons et atteindre des sommets.',
    text1:
      'Si la valeur de <b>pouvoir</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez progressivement développer votre pouvoir et votre influence au sein de votre organisation, tout en respectant vos valeurs et en contribuant au succès de l’entreprise.',
    listeAccordeon: [
      {
        title: 'Définissez vos objectifs de carrière',
        description:
          'Commencez par établir des objectifs clairs et précis concernant les positions de pouvoir ou d’influence que vous souhaitez atteindre. Cela peut inclure des postes de management, de direction ou des rôles stratégiques au sein d’une organisation.',
      },
      {
        title: 'Acquérez des compétences en leadership',
        description:
          'Les personnes ayant du pouvoir sont souvent appelées à diriger et à motiver les autres. <br/> Développez des compétences en leadership, en communication et en gestion d’équipe pour vous préparer à assumer des responsabilités de direction.',
      },
      {
        title: 'Apprenez à prendre des décisions',
        description:
          'Les postes de pouvoir impliquent souvent la prise de décisions importantes pour l’organisation. <br/> Cultivez votre capacité à analyser des situations complexes, à évaluer les risques et à prendre des décisions éclairées.',
      },
      {
        title: 'Cultivez votre expertise',
        description:
          'Les leaders(euses) et les personnes influentes sont souvent respecté(e)s pour leur expertise dans un domaine particulier. Approfondissez vos connaissances et compétences dans votre secteur d’activité pour devenir un(e) expert(e) reconnu(e) et augmenter votre influence.',
      },
      {
        title: 'Développez votre réseau professionnel',
        description:
          'Un réseau solide peut ouvrir des opportunités pour accéder à des positions de pouvoir. Participez à des événements, des conférences et des rencontres professionnelles pour élargir votre réseau et vous faire connaître.',
      },
      {
        title: 'Soyez proactif(ve) et volontaire',
        description:
          'Les personnes ayant du pouvoir sont souvent celles qui prennent des initiatives et s’impliquent dans la résolution des problèmes. Proposez des solutions innovantes, prenez des responsabilités supplémentaires et montrez que vous êtes prêt(e) à vous engager pour le succès de l’organisation.',
      },
      {
        title: 'Apprenez à déléguer',
        description:
          'Les leaders(euses) efficaces savent comment déléguer les tâches et responsabilités à leur équipe. Cela leur permet de se concentrer sur les décisions stratégiques et de gérer efficacement leur temps et leurs ressources.',
      },
      {
        title: 'Faites preuve de résilience',
        description:
          'Les personnes en position de pouvoir sont souvent confrontées à des défis et des obstacles. Apprenez à faire face à l’adversité et à rebondir après un échec pour continuer à avancer vers vos objectifs.',
      },
      {
        title: 'Soyez éthique et responsable',
        description:
          'Exercer du pouvoir implique une responsabilité accrue. Assurez-vous que vos actions sont guidées par des principes éthiques et que vous prenez en compte l’impact de vos décisions sur les autres membres de l’organisation.',
      },
      {
        title: 'Soyez patient(e) et persévérant(e)',
        description:
          'L’accès aux postes de pouvoir peut prendre du temps et nécessite de la persévérance. Restez déterminé(e) et continuez de travailler pour atteindre vos objectifs, même si les résultats ne sont pas immédiats.',
      },
    ],
    listEmploi1: [
      'Directeur(trice) général(e) / PDG(Président(e)-directeur(trice) général(e))',
      'Directeur(trice) des opérations (COO)',
      'Directeur(trice) financier (CFO) ',
      'Directeur(trice) des ressources humaines (DRH) ',
      'Directeur(trice) commercial / Directeur(trice) des ventes',
      'Directeur(trice) marketing',
      'Directeur(trice) de la communication',
      'Directeur(trice) de la stratégie ',
      'Directeur(trice) de projet / Chef(fe) de projet ',
      'Directeur(trice) informatique / Directeur(trice) des systèmes d’information (DSI)',
      'Directeur(trice) de production / Directeur(trice) industriel ',
      'Directeur(trice) de la recherche et développement (R&D)',
      'Responsable d’équipe / Manager(euse)',
    ],
    listEmploi2: [
      'Consultant(e) en management / Consultant(e) en stratégie',
      'Avocat(e) / Associé(e) dans un cabinet d’avocats',
      'Banquier(ère) d’affaires / Analyste financier',
      'Lobbyiste / Conseiller(ère) politique ',
      'Responsable des relations publiques',
      'Officier supérieur dans l’armée (grade de commandement) ',
      'Administrateur(trice) / Directeur(trice) d’établissement scolaire ou universitaire ',
      'Fonctionnaire de haut rang / Haut fonctionnaire',
      'Juge / Magistrat(e)',
      'Commissaire de police / Chef(fe) de la police',
      'Responsable syndical(e) / Leader(euse) syndical(e)',
      'Élu(e) politique (maire, député, sénateur(trice), ministre, etc.)',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>pouvoir</b>. Ces professions impliquent généralement des responsabilités de gestion, de direction ou de supervision, ainsi que la prise de décisions qui influencent les individus, les équipes ou les organisations :',
    text4:
      'Ces métiers requièrent souvent des compétences en leadership, en gestion, en communication et en prise de décision. Ils offrent également des opportunités d’influence et de contrôle sur les ressources, les politiques et les personnes.',
  },
  tradition: {
    color: '#6C4D95',
    img: `Tradition.png`,
    colorSecondary: '#B7A5CA',
    opacity: true,
    longText:
      'La sauvegarde des traditions de votre communauté est ce qui compte le plus à vos yeux. Il peut s’agir de coutumes religieuses ou profanes. Vous êtes la courroie de transmission de ces valeurs, le lien entre deux générations. Vous avez envie de transmettre des connaissances et surtout des valeurs aux autres. Sur le plan professionnel, vous défendez les traditions, vous êtes l’ambassadeur(rice) des valeurs de votre pays ou de votre organisation. Vous défendez la règle par l’éducation ou la sanction.',
    text1:
      'Si la valeur de <b>tradition</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur de tradition dans votre carrière professionnelle, en choisissant des organisations qui partagent votre attachement à des normes ou à des traditions qui vous tiennent à cœur.',
    listeAccordeon: [
      {
        title: 'Identifiez les secteurs et les entreprises valorisant la tradition',
        description:
          'Recherchez des domaines d’activité et des organisations qui respectent et valorisent les traditions, qu’elles soient culturelles, familiales ou professionnelles. Cela vous permettra de vous épanouir dans un environnement qui partage vos valeurs.',
      },
      {
        title: 'Privilégiez les entreprises familiales ou de longue date',
        description:
          'Les entreprises familiales et celles ayant une longue histoire ont tendance à accorder plus d’importance aux traditions. En choisissant de travailler pour de telles entreprises, vous pourrez vous aligner sur des organisations qui valorisent la tradition.',
      },
      {
        title: 'Cultivez des relations intergénérationnelles au travail',
        description:
          'Établissez des relations avec des collègues de différentes générations pour partager des expériences, des savoir-faire et des perspectives variés. Cela favorisera un environnement de travail respectueux des traditions et de la diversité des expériences.',
      },
      {
        title: 'Soyez respectueux(se) des hiérarchies et des protocoles',
        description:
          'Dans un environnement professionnel qui valorise la tradition, il est important de respecter les hiérarchies et les protocoles établis. Faites preuve de politesse et de respect envers vos supérieurs, vos collègues et vos subordonné(e)s.',
      },
      {
        title: 'Développez des compétences en communication interculturelle',
        description:
          'Si les traditions culturelles sont importantes pour vous , il est essentiel de développer des compétences en communication interculturelle pour interagir efficacement et respectueusement avec des collègues issu(e)s de différentes cultures et traditions.',
      },
      {
        title: 'Partagez vos connaissances et votre expérience',
        description:
          'Transmettez votre savoir-faire et votre expérience aux nouvelles générations de collègues. Cette transmission de connaissances est une manière de perpétuer les traditions et de contribuer à la continuité de son organisation.',
      },
      {
        title: 'Apprenez des autres et respectez leurs traditions',
        description:
          'Soyez ouvert(e) à l’apprentissage et au respect des traditions des autres. Cette attitude favorisera un climat de travail harmonieux et inclusif.',
      },
      {
        title: 'Impliquez-vous dans des activités et des événements traditionnels',
        description:
          'Participez à des célébrations, des événements ou des activités traditionnelles organisés par votre entreprise ou votre communauté professionnelle. Cela vous permettra de vous connecter avec d’autres personnes qui partagent vos valeurs et de maintenir les traditions vivantes.',
      },
      {
        title: 'Faites preuve de loyauté et d’engagemente',
        description:
          'Les entreprises qui valorisent la tradition apprécient généralement la loyauté et l’engagement de leurs employé(e)s. Montrez votre dévouement envers votre organisation en vous impliquant activement dans votre travail et en soutenant les objectifs de l’entreprise.',
      },
      {
        title: 'Trouvez un équilibre entre tradition et innovation',
        description:
          'Il est important de respecter et de valoriser les traditions, tout en étant ouvert(e) à l’innovation et au progrès. Trouvez un équilibre entre le maintien des traditions et l’adaptation aux évolutions du marché et de la technologie.',
      },
    ],
    listEmploi1: [
      'Prêtre(sse) / Pasteur(e) / Rabbin(ne) / Imam ',
      'Historien(ne) / Archéologue',
      'Conservateur(trice) de musée / Archiviste',
      'Professeur d’histoire / de littérature / de langues anciennes',
      'Artisan traditionnel (ébéniste, céramiste, tailleur (se) de pierre, etc.) ',
      'Restaurateur(trice) d’art / d’objets anciens',
      'Guide touristique spécialisé(e) en patrimoine culturel / historique',
      'Bibliothécaire spécialisé(e) dans les ouvrages anciens ',
      'Ethnologue / Anthropologue culturel(le)',
      'Musicien(ne) / Danseur(se) spécialisé(e) dans les arts traditionnels)',
    ],
    listEmploi2: [
      'Auteur / Écrivain spécialisé(e) en histoire ou en culture',
      'Artiste peintre spécialisé(e) dans les techniques traditionnelles',
      'Horticulteur(trice) / Jardinier(ère) spécialisé(e) dans les jardins historiques',
      'Chef(fe) cuisinier(ère) spécialisé(e) dans la cuisine traditionnelle',
      'Maître(sse) d’hôtel / Sommelier(ère) spécialisé(e) dans les traditions culinaires et œnologiques',
      'Enseignant(e) de langues rares ou en voie de disparition',
      'Conférencier(ère) / Orateur(trice) spécialisé(e) en traditions et patrimoine culturel',
      'Couturier(ère) / Designer(euse) spécialisé(e) dans les costumes traditionnels ',
      'Maître(sse) de cérémonies traditionnelles (mariages, rites, etc.)',
      'Expert(e) en généalogie / Héraldique',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>tradition</b>. Ces professions impliquent généralement le respect des coutumes, des valeurs culturelles ou religieuses et la préservation du patrimoine :',
    text4:
      'Ces métiers requièrent souvent une connaissance approfondie des traditions, des coutumes et de l’histoire, ainsi qu’une sensibilité et un respect envers les valeurs culturelles et religieuses. Les personnes travaillant dans ces domaines contribuent à la préservation et à la transmission du patrimoine culturel, historique et spirituel.',
  },
  kindness: {
    color: '#F0CC42',
    img: `Bienveillance.png`,
    colorSecondary: '#8D7725',
    longText:
      'Vous êtes animé(e) par le désir d’améliorer le sort et le bien-être des personnes avec lesquelles vous vivez. Il peut s’agir de vos proches mais aussi de personnes plus éloignées. Vous aspirez à l’harmonie sociale. Vous voulez que tout le monde soit bien et heureux. Sur le plan professionnel, vous avez besoin d’évoluer dans un environnement et avec des personnes qui partagent ce souci : indulgence, prévenance, solidarité sont les ingrédients indispensables à votre épanouissement personnel.',
    text1:
      'Si la valeur de <b>bienveillance</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur de bienveillance dans votre carrière professionnelle, en choisissant des organisations et des rôles alignés avec votre envie d’évoluer dans un environnement où la qualité de relations humaines est primordiale et les échanges entre collègues harmonieux.',
    listeAccordeon: [
      {
        title: 'Choisissez un secteur et des entreprises axés sur la bienveillance',
        description:
          'Recherchez des domaines d’activité et des organisations qui ont pour mission d’aider les autres, de soutenir le bien-être des employé(e)s ou de promouvoir des causes sociales et environnementales. Cela vous permettra de vous épanouir dans un environnement qui partage vos valeurs.',
      },
      {
        title: 'Développez des compétences en communication empathique',
        description:
          'L’empathie est essentielle pour comprendre les besoins et les préoccupations des autres. Cultivez vos compétences en communication empathique pour mieux interagir avec vos collègues, client(e)s ou bénéficiaires.',
      },
      {
        title: 'Cultivez un esprit d’équipe et de collaboration',
        description:
          'La bienveillance se manifeste souvent par la volonté de travailler ensemble pour atteindre des objectifs communs. Encouragez la collaboration et le soutien mutuel au sein de votre équipe pour favoriser un environnement de travail positif.',
      },
      {
        title: 'Impliquez-vous dans des projets et des initiatives caritatifs',
        description:
          'Participez à des projets bénévoles, des collectes de fonds ou des initiatives caritatives organisées par votre entreprise ou dans votre communauté. Cela vous permettra de mettre en pratique vos valeurs de bienveillance tout en contribuant à des causes qui vous tiennent à cœur.',
      },
      {
        title: 'Poursuivez un développement personnel et professionnel axé sur la bienveillance',
        description:
          'Investissez dans votre formation et votre développement personnel en suivant des cours, des ateliers ou des conférences axés sur la bienveillance, l’empathie ou le leadership servant.',
      },
      {
        title: 'Soyez un(e) mentor(e) et un soutien pour les autres',
        description:
          'Offrez votre aide et vos conseils aux collègues, aux nouveaux(elles) employé(e)s ou aux étudiant(e)s qui pourraient bénéficier de votre expérience et de votre soutien. En agissant comme mentor, vous contribuerez à créer un environnement de travail bienveillant.',
      },
      {
        title: 'Traitez les autres avec respect et considération',
        description:
          'Faites preuve de respect, d’écoute et de considération envers les personnes que vous rencontrez dans le cadre de votre travail. Ces attitudes renforceront un climat de bienveillance et de confiance.',
      },
      {
        title: 'Pratiquez l’autocompassion',
        description:
          'La bienveillance envers soi-même est tout aussi importante que la bienveillance envers les autres. Prenez soin de vous, accordez-vous du temps pour vous reposer et vous ressourcer, et soyez indulgent(e) envers vous-même en cas d’erreur ou d’échec.',
      },
      {
        title: 'Encouragez et valorisez les réussites des autres',
        description:
          'Félicitez et reconnaissez les réussites et les efforts de vos collègues. Ce soutien contribuera à créer une atmosphère de bienveillance et d’encouragement au sein de votre équipe.',
      },
      {
        title: 'Prônez des politiques et des pratiques de travail éthiques',
        description:
          'Encouragez et soutenez des pratiques de travail éthiques et responsables au sein de votre organisation. Cela peut inclure des initiatives en matière de responsabilité sociale, d’équité et de diversité, ou de protection de l’environnement.',
      },
    ],
    listEmploi1: [
      'Infirmier / Infirmière',
      'Médecin généraliste / Pédiatre / Psychiatre',
      'Psychologue / Psychothérapeute / Conseiller(ère) d’orientation',
      'Travailleur(se) social(e) / Assistant(e) social(e)',
      'Éducateur(trice) spécialisé(e) / Éducateur(trice) de jeunes enfants',
      'Enseignant(e) / Professeur / Formateur(trice)',
      'Bénévole / Coordinateur(trice) de bénévoles',
      'Aide-soignant(e) / Auxiliaire de vie',
      'Animateur(trice) socio-culturel (le) / Animateur(trice) en maison de retraite',
      'Coach de vie / Coach en développement personnel',
    ],
    listEmploi2: [
      'Kinésithérapeute / Ergothérapeute / Orthophoniste ',
      'Directeur(trice) d’ONG / Responsable d’association caritative',
      'Nutritionniste / Diététicien(ne) ',
      'Conseiller(ère) en insertion professionnelle / Conseiller(ère) en emploi',
      'Médiateur(trice) / Médiateur(trice) familial(e)',
      'Conseiller(ère) conjugal / Thérapeute de couple',
      'Gardien(ne) d’immeuble / Concierge',
      'Puéricultrice / Auxiliaire de puériculture',
      'Animateur(trice) de groupe de soutien / Groupe d’entraide',
      'Soignant(e) en soins palliatifs / Accompagnateur(trice) de fin de vie',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>bienveillance</b>. Ces professions sont généralement axées sur l’aide et le soutien aux autres, la compassion et l’empathie :',
    text4:
      'Ces métiers nécessitent généralement des compétences en communication, en écoute active et en empathie, ainsi qu’un désir sincère d’aider et de soutenir les autres. Ils offrent la possibilité de contribuer au bien-être et à l’épanouissement des individus et de la communauté, et de travailler dans un environnement où la bienveillance et la compassion sont des valeurs clés.',
  },
  autonomy: {
    color: '#A9B0FB',
    img: `autonomie.png`,
    colorSecondary: '#5C619D',
    longText:
      'La liberté de penser et d’agir, voilà ce que vous recherchez par-dessus tout. C’est un besoin vital. Votre crédo : créer, explorer, inventer. Vous voulez vous affranchir le plus possible des contraintes et des obligations. Vous avez soif de liberté et y tenez plus que tout. Dans votre métier, cela se traduit par le besoin de vous organiser par vous-même, de maîtriser votre emploi du temps, de choisir vos méthodes de travail, l’environnement dans lequel vous évoluez et les personnes avec lesquelles vous travaillez.',
    text1:
      'Si l’<b>autonomie</b> est une valeur importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et dans votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez orienter votre carrière professionnelle de manière à respecter votre valeur d’autonomie tout en continuant à développer vos compétences et à progresser dans votre domaine.',
    listeAccordeon: [
      {
        title: 'Identifiez vos passions et vos compétences',
        description:
          'Faites le point sur ce que vous aimez faire et sur vos compétences. Cela vous permettra de déterminer les domaines dans lesquels vous vous sentirez le plus à l’aise pour exercer une activité professionnelle qui respecte votre valeur de liberté.',
      },
      {
        title: 'Recherchez des métiers et secteurs flexibles',
        description:
          'Certains métiers et secteurs offrent une plus grande flexibilité en termes d’horaires, de lieu de travail et d’autonomie. Les métiers du numérique, du consulting, de l’art ou encore le travail indépendant sont des exemples d’opportunités qui pourraient correspondre à vos attentes.',
      },
      {
        title: 'Pensez à l’entrepreneuriat',
        description:
          'Si vous avez une idée ou un projet qui vous tient à cœur, créez votre propre entreprise peut être une excellente façon de vivre votre valeur de liberté. Cela vous permettra de prendre vos propres décisions et de gérer votre temps comme vous le souhaitez.',
      },
      {
        title: 'Développez vos compétences en gestion du temps',
        description:
          'La liberté professionnelle implique souvent une grande autonomie dans la gestion de votre temps. Apprenez à prioriser vos tâches, à fixer des objectifs réalistes et à éviter la procrastination pour tirer le meilleur parti de cette liberté.',
      },
      {
        title: 'Cultivez votre réseau professionnel',
        description:
          'Les opportunités de travail flexible peuvent se présenter à travers votre réseau. Participez à des événements, rejoignez des groupes professionnels et restez en contact avec des personnes qui partagent vos valeurs pour multiplier les chances de trouver des opportunités qui correspondent à vos attentes.',
      },
      {
        title: 'Soyez ouvert(e) aux opportunités',
        description:
          'La liberté professionnelle peut parfois signifier accepter des projets temporaires ou des missions courtes. Ne fermez pas la porte à ces opportunités, car elles peuvent vous aider à développer de nouvelles compétences et à élargir votre réseau.',
      },
      {
        title: 'Apprenez à négocier',
        description:
          'Dans certains cas, il est possible de négocier des conditions de travail plus flexibles avec votre employeur. Soyez honnête sur vos besoins et apprenez à présenter des arguments convaincants pour obtenir l’autonomie et la liberté que vous recherchez.',
      },
      {
        title: 'Trouvez un équilibre entre vie professionnelle et vie personnelle',
        description:
          'La liberté professionnelle ne doit pas se faire au détriment de votre vie personnelle. Prenez le temps de définir vos limites et de respecter un équilibre entre travail et loisirs pour préserver votre bien-être général.',
      },
    ],
    listEmploi1: [
      'Entrepreneur(euse)/ Créateur(trice) d’entreprise ',
      'Freelance / Travailleur(euse) indépendant(e) (dans divers domaines tels que la rédaction, la conception graphique, le développement web, la photographie, etc.)',
      'Consultant(e) (dans divers domaines tels que le conseil en gestion, en informatique, en ressources humaines, etc.)',
      'Artiste (peintre, sculpteur(euse) , écrivain, musicien(ne), etc.)',
      'Coach de vie ou coach professionnel(le)',
      'Blogueur(euse) / Influenceur(euse) / Créateur(trice) de contenu en ligne',
      'Agent immobilier indépendant(e)',
      'Formateur(trice) indépendant(e) (dans divers domaines de compétences)',
      'Thérapeute / Psychologue en cabinet privé',
      'Designer(euse) / Architecte d’intérieur indépendant(e)',
    ],
    listEmploi2: [
      'Professeur particulier / Tuteur(Tutrice) ',
      'Commercial(e) indépendant(e)',
      'Artisan (menuisier(ère), plombier(ère), électricien(ne), etc.) ',
      'Agriculteur(trice) / Horticulteur(trice) / Viticulteur(trice) indépendant(e)',
      'Rédacteur(trice) technique / Rédacteur(trice) scientifique freelance ',
      'Traducteur(trice) / Interprète indépendant(e) ',
      'Conseiller(ère) en gestion de patrimoine indépendant(e) ',
      'Chef(fe) cuisinier(ère) à domicile / Traiteur indépendant(e)',
      'Gestionnaire de projets indépendant(e)',
      'Développeur(euse) / Programmeur(euse) freelance',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur d’<b>autonomie</b>. Ces professions permettent généralement de travailler de manière indépendante, de gérer son emploi du temps et de prendre des décisions sans avoir à rendre systématiquement des comptes à un(e) supérieur(e) hiérarchique :',
    text4:
      'Notez que l’autonomie dans ces métiers varie en fonction des circonstances et des choix personnels. Par exemple, un(e) artiste peut choisir de travailler en étroite collaboration avec une galerie ou un(e) éditeur(trice), ou bien de gérer entièrement sa carrière de manière indépendante.',
  },
  achievement: {
    color: '#2435BD',
    img: `reussite.png`,
    colorSecondary: '#939ADE',
    opacity: true,
    longText:
      'Fortune, gloire et beauté, vous voulez être la star de votre domaine. Vous voulez réussir DANS la vie ! Vous êtes en quête de reconnaissance sociale. Vous voulez rayonner par votre charisme et votre aura. Sur le plan professionnel, vous avez besoin d’être reconnu(e) et écouté(e) par vos pairs, mais aussi par vos clients et en général par toutes les personnes qui travaillent avec vous. Vous êtes prêt(e) à faire de nombreux efforts et sacrifices pour y arriver.Le travail ne vous fait pas peur. Reste juste à trouver le domaine dans lequel vous pouvez devenir le(a) meilleur(e).',
    text1:
      'Si la valeur de <b>réussite</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur de réussite dans votre carrière professionnelle, tout en développant vos compétences, en vous adaptant aux défis et en vous rapprochant de vos objectifs.',
    listeAccordeon: [
      {
        title: 'Fixez-vous des objectifs clairs et mesurables',
        description:
          'Déterminez quels sont vos objectifs de carrière à court, moyen et long terme. Assurez-vous que ces objectifs soient précis, réalisables et quantifiables pour pouvoir évaluer et célébrer vos réussites.',
      },
      {
        title: 'Élaborez un plan d’action',
        description:
          'Une fois vos objectifs définis, élaborez un plan d’action pour les atteindre. Identifiez les étapes, les compétences à acquérir, et les ressources nécessaires pour progresser dans votre carrière.',
      },
      {
        title: 'Développez votre expertise',
        description:
          'Maîtrisez les compétences et connaissances requises dans votre domaine pour devenir un(e) expert(e) reconnu(e). Cela vous permettra de vous démarquer et d’accroître vos chances de réussite professionnelle.',
      },
      {
        title: 'Cultivez un état d’esprit de croissance',
        description:
          'Adoptez une attitude positive face à l’apprentissage et aux défis. L’état d’esprit de croissance vous aidera à persévérer et à tirer des leçons de vos échecs pour continuer à progresser.',
      },
      {
        title: 'Faites preuve de persévérance et de résilience',
        description:
          'La réussite professionnelle demande souvent du temps, de la patience et de la détermination. Ne vous découragez pas face aux obstacles et aux échecs, mais considérez-les plutôt comme des occasions d’apprendre et de grandir.',
      },
      {
        title: 'Soyez proactif(ve) et volontaire',
        description:
          'Prenez des initiatives, proposez des solutions et engagez-vous activement dans votre travail. Cette attitude témoignera de votre sérieux et de votre implication, favorisant ainsi votre réussite.',
      },
      {
        title: 'Développez votre réseau professionnel',
        description:
          'Un réseau solide peut vous aider à découvrir de nouvelles opportunités, à recevoir des conseils précieux et à progresser dans votre carrière. Participez à des événements, conférences et rencontres professionnelles pour élargir votre réseau.',
      },
      {
        title: 'Soyez adaptable et flexible',
        description:
          'Les environnements de travail évoluent rapidement, et la capacité à s’adapter aux changements est essentielle pour réussir. Apprenez à faire preuve de souplesse et d’agilité face aux situations nouvelles ou imprévues.',
      },
      {
        title: 'Apprenez à communiquer efficacement',
        description:
          'Les compétences en communication sont cruciales pour réussir professionnellement. Apprenez à exprimer clairement vos idées, à écouter les autres et à travailler en équipe pour atteindre des objectifs communs.',
      },
      {
        title: 'Mesurez et célébrez vos réussites',
        description:
          'Prenez le temps de reconnaître et de célébrer vos accomplissements, qu’ils soient petits ou grands. Cette reconnaissance vous motivera à continuer à travailler dur et à viser des objectifs encore plus élevés.',
      },
    ],
    listEmploi1: [
      'Directeur(trice) général / PDG (Président(e)-directeur(trice) général(e)) ',
      'Médecin / Chirurgien(ne) spécialisé(e)',
      'Avocat(e) d’affaires / Associé(e) dans un cabinet d’avocats',
      'Banquier(ère) d’affaires / Analyste financier',
      'Ingénieur de haut niveau / Expert(e) en technologie',
      'Consultant(e) en management / Consultant(e) en stratégie',
      'Entrepreneur(euse) / Fondateur(trice) de startup',
      'Directeur(trice) commercial(e) / Directeur(trice) des ventes ',
      'Directeur(trice) marketing / Directeur(trice) de la communication',
      'Architecte / Designer(euse) renommé(e)',
    ],
    listEmploi2: [
      'Artiste / Écrivain / Musicien(ne) de renom',
      'Athlète professionnel(le) / Sportif (ve) de haut niveau ',
      'Acteur(trice) / Réalisateur(trice) / Producteur(trice) de cinéma',
      'Scientifique / Chercheur reconnu(e) ',
      'Journaliste / Reporter célèbre',
      'Chef(fe) cuisinier(ère) étoilé(e) / Restaurateur(trice) de renom',
      'Coach de vie / Coach professionnel(le)',
      'Conférencier(ère) / Expert(e) en développement personnel',
      'Professeur d’université / Enseignant(e)-chercheur',
      'Expert(e) en immobilier / Agent immobilier de luxe',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>réussite</b>. Ces professions sont généralement associées à la performance, la compétence, la reconnaissance et le succès :',
    text4:
      'Ces métiers nécessitent généralement une grande compétence, un engagement fort, une capacité à se démarquer et une volonté d’atteindre l’excellence. Ils offrent souvent des opportunités de reconnaissance, de succès financier et de développement professionnel. Les personnes qui réussissent dans ces domaines sont souvent motivées par le désir de se surpasser et d’être reconnues pour leurs réalisations.',
  },
  stimulation: {
    color: '#EC343A',
    img: `stimulation.png`,
    colorSecondary: '#741923',
    longText:
      'Pour vous, la vie est une aventure ! <br/> Ce qui vous motive et vous stimule, ce sont les défis. Vous fuyez la routine, aimez les challenges, ce qui est difficile, nouveau, exigeant. Vous aimez prendre des risques. Vous aimez les poussées d’adrénaline. Explorateur(trice) des temps modernes, vous aimez faire de nouvelles rencontres et explorer de nouveaux territoires. Dans votre métier, il faut que cela bouge tout le temps ! <br/> Vous vous plaisez dans un environnement professionnel mouvant, exigeant, et excitant. Après tout, le travail est une forme d’aventure moderne !',
    text1:
      'Si la valeur de <b>stimulation</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez orienter votre carrière de manière à avoir le sentiment d’apprendre et de vous développer en permanence dans votre travail au quotidien et d’ainsi d’être en accord avec vos valeurs et votre exigence de stimulation.',
    listeAccordeon: [
      {
        title: 'Explorez différents domaines d’intérêt',
        description:
          'Identifiez vos passions et centres d’intérêt, puis envisagez des carrières qui vous permettront d’explorer et de développer ces domaines. La diversité des sujets et des tâches vous permettra de maintenir un niveau de stimulation élevé.',
      },
      {
        title: 'Choisissez un secteur en constante évolution',
        description:
          'Certains secteurs, tels que la technologie, la recherche ou la créativité, sont caractérisés par un rythme rapide et des changements constants. Travailler dans ces domaines vous permettra de rester stimulé(e) et de continuer à apprendre tout au long de votre carrière.',
      },
      {
        title: 'Recherchez des opportunités de formation continue',
        description:
          'La stimulation intellectuelle passe souvent par l’apprentissage et le développement de nouvelles compétences. Recherchez des opportunités de formation continue, des ateliers ou des conférences pour rester à jour dans votre domaine et élargir vos connaissances.',
      },
      {
        title: 'Favorisez la créativité et l’innovation',
        description:
          'Les environnements créatifs et innovants peuvent offrir une stimulation intellectuelle et émotionnelle. Recherchez des postes ou des organisations qui encouragent la créativité, la pensée critique et l’expérimentation.',
      },
      {
        title: 'Acceptez les défis',
        description:
          'Les défis peuvent être source de stimulation et de croissance personnelle. N’hésitez pas à sortir de votre zone de confort et à accepter des projets ou des responsabilités qui vous mettront au défi et vous permettront d’apprendre.',
      },
      {
        title: 'Variez les tâches et les projets',
        description:
          'Essayez d’éviter la routine en vous impliquant dans des projets variés et en travaillant sur des tâches diversifiées. Cette variété vous permettra de rester stimulé(e) et de maintenir votre intérêt pour votre travail.',
      },
      {
        title: 'Cultivez un réseau professionnel diversifié',
        description:
          'Établir des relations avec des personnes de différents horizons et domaines d’expertise peut vous apporter de nouvelles perspectives et idées. Participez à des événements professionnels et sociaux pour rencontrer des personnes intéressantes et élargir votre réseau.',
      },
      {
        title: 'Soyez curieux(se) et ouvert(e) d’esprit',
        description:
          'La curiosité et l’ouverture d’esprit sont des atouts pour rester stimulé(e) et engagé(e) dans votre travail. Posez des questions, explorez de nouvelles idées et soyez prêt(e) à remettre en question vos propres hypothèses.',
      },
      {
        title: 'Trouvez un équilibre entre vie professionnelle et vie personnelle',
        description:
          'La stimulation ne doit pas se limiter à votre carrière professionnelle. Assurez-vous de maintenir un équilibre entre travail et loisirs, en vous accordant du temps pour vous adonner à vos passions et hobbies en dehors du travail.',
      },
      {
        title: 'Développez votre capacité d’adaptation',
        description:
          'Dans un environnement en constante évolution, la capacité à s’adapter et à réagir rapidement aux changements est essentielle pour maintenir un niveau de stimulation élevé. Cultivez votre agilité mentale et votre flexibilité pour vous adapter aux nouvelles situations.',
      },
    ],
    listEmploi1: [
      'Journaliste / Reporter ',
      'Photographe de presse / Caméraman',
      'Pilote d’avion / Pilote de ligne',
      'Guide de voyage / Guide touristique',
      'Animateur(trice) de télévision ou de radio',
      'Concepteur(trice) de jeux vidéo / Game designer(euse)',
      'Chercheur scientifique ',
      'Ingénieur en robotique ',
      'Spécialiste en marketing créatif / Publicité',
      'Designer(euse) d’intérieur / Architecte d’intérieur',
    ],
    listEmploi2: [
      'Artiste de cirque / Acrobate',
      'Cascadeur(euse) ',
      'Ingénieur en aérospatiale ',
      'Explorateur(trice)/ Aventurier(ère)',
      'Anthropologue / Archéologue',
      'Détective privé(e)',
      'Chef(fe) cuisinier(ère)',
      'Sommelier(ère)',
      'Événementiel / Organisateur(trice) d’événements',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>stimulation</b>. Ces professions sont généralement caractérisées par un environnement dynamique, des défis variés et la possibilité de vivre des expériences nouvelles et passionnantes :',
    text4:
      'Ces métiers nécessitent généralement une certaine capacité d’adaptation, de l’ingéniosité, de la créativité et une attitude ouverte aux changements et aux défis. Ils offrent des opportunités d’apprendre et de grandir, ainsi que la possibilité d’explorer des domaines, des cultures et des expériences variés.',
  },
  security: {
    color: '#531B5F',
    img: `Securite.png`,
    colorSecondary: '#A88DAE',
    opacity: true,
    longText:
      'La recherche de sécurité est ce qui guide votre vie, que cela soit dans vos relations aux autres, dans votre métier ou dans la gestion de votre vie personnelle. Vous aimez la stabilité. L’incertitude vous effraie. Prendre des risques n’est pas dans votre tempérament. Sur le plan professionnel, cela se traduit par la nécessité de travailler dans de grandes organisations vous offrant la possibilité de développer votre potentiel sur le long terme tout en vous offrant une sécurité de l’emploi. Vous appréciez les employeurs aux reins solides.',
    text1:
      'Si la valeur de <b>sécurité</b> est importante pour vous dans votre carrière professionnelle, voici quelques conseils pour vous aider à l’intégrer dans vos choix et votre parcours :',
    text2:
      'En suivant ces conseils, vous pourrez intégrer la valeur de sécurité dans votre carrière professionnelle, en privilégiant des secteurs et des entreprises stables, en développant des compétences polyvalentes et en cultivant un réseau professionnel solide.',
    listeAccordeon: [
      {
        title: 'Choisissez un secteur d’activité stable',
        description:
          'Certains secteurs, tels que la santé, l’éducation ou les services publics, sont souvent considérés comme plus stables et moins sujets aux fluctuations économiques. Orientez-vous vers ces domaines pour vous assurer une sécurité d’emploi à long terme.',
      },
      {
        title: 'Privilégiez les entreprises solides et bien établies',
        description:
          'Recherchez des organisations qui ont une bonne réputation, une solide situation financière et une vision à long terme. Ces entreprises offrent généralement une plus grande sécurité d’emploi et des avantages sociaux intéressants.',
      },
      {
        title: 'Développez des compétences polyvalentes et transférables',
        description:
          'En acquérant des compétences applicables dans divers domaines, vous augmenterez votre valeur sur le marché du travail et assurerez votre sécurité professionnelle, même en cas de changements dans l’industrie ou l’économie.',
      },
      {
        title: 'Investissez dans la formation continue',
        description:
          'Restez à jour sur les tendances et les compétences de votre secteur et investissez dans la formation continue pour maintenir votre employabilité. Cette démarche démontre votre engagement envers votre développement professionnel et peut renforcer votre sécurité d’emploi.',
      },
      {
        title: 'Faites preuve de loyauté et d’engagement',
        description:
          'Les employeurs apprécient les employé(e)s loyaux(loyales) et engagé(e)s qui contribuent à la réussite de l’entreprise. En démontrant votre engagement et votre investissement, vous augmentez vos chances de maintenir une position stable au sein de l’organisation.',
      },
      {
        title: 'Gérez vos finances de manière responsable',
        description:
          'Assurez-vous de disposer d’une épargne d’urgence et d’un plan financier solide pour faire face à d’éventuelles perturbations dans votre carrière. Cela vous aidera à vous sentir plus en sécurité et mieux préparé(e) face aux imprévus.',
      },
      {
        title: 'Cultivez un réseau professionnel solide',
        description:
          'Un réseau professionnel bien développé peut vous offrir des opportunités d’emploi, des recommandations et du soutien en cas de besoin. Maintenez des relations professionnelles solides pour renforcer votre sécurité d’emploi.',
      },
      {
        title: 'Soyez attentif(ve) aux opportunités de croissance interne',
        description:
          'Les entreprises offrant des opportunités de croissance interne permettent de progresser et de consolider votre position au sein de l’organisation. Saisissez ces occasions pour améliorer votre sécurité professionnelle.',
      },
      {
        title: 'Privilégiez les entreprises offrant de bons avantages sociaux',
        description:
          'La sécurité ne concerne pas seulement l’emploi, mais aussi les avantages liés à la santé, à la retraite et à la qualité de vie. Recherchez des employeurs qui offrent de bons avantages pour renforcer votre sécurité globale.',
      },
      {
        title: 'Maintenez un équilibre entre vie professionnelle et vie personnelle',
        description:
          'La sécurité professionnelle doit être complétée par une bonne qualité de vie et une santé mentale solide. Assurez-vous de trouver un équilibre entre votre travail et votre vie personnelle pour préserver votre bien-être.',
      },
    ],
    listEmploi1: [
      'Policier(ère) / Gendarme',
      'Pompier / Secouriste',
      'Militaire / Soldat(e)',
      'Agent de sécurité / Vigile',
      'Détective privé(e) / Enquêteur(trice)',
      'Gardien(ne) de prison / Surveillant(e) pénitentiaire',
      'Cybersécurité / Analyste en sécurité informatique',
      'Ingénieur en sécurité / Sécurité des systèmes',
      'Contrôleur(se) aérien(ne) / Ingénieur en sécurité aérienne',
      'Médecin / Infirmier(ère) / Professionnel(le) de santé',
      'Expert(e) en santé et sécurité au travail',
    ],
    listEmploi2: [
      'Gestionnaire des risques / Analyste en gestion des risques',
      'Inspecteur(trice) de la sécurité des aliments / Contrôleur(se) sanitaire',
      'Technicien(ne) en prévention des incendies / Agent de sécurité incendie',
      'Conseiller(ère) en sécurité financière / Gestionnaire de patrimoine',
      'Ingénieur en génie civil / Ingénieur en structures',
      'Spécialiste en sécurité environnementale / Écologiste',
      'Technicien(ne) en radioprotection / Spécialiste en sécurité nucléaire ',
      'Ingénieur en sécurité routière / Expert(e) en transports)',
    ],
    text3:
      'Voici une liste de métiers en lien avec une valeur de <b>sécurité</b>. Ces professions sont généralement axées sur la protection des individus, des biens ou des informations, ainsi que sur la prévention des risques et des dangers :',
    text4:
      'Ces métiers requièrent généralement de la rigueur, de la responsabilité, de la vigilance et des compétences spécifiques en matière de prévention et de gestion des risques. Ils sont axés sur la protection de la vie, de la propriété et de la stabilité, et contribuent à la création d’un environnement sûr et sécurisé pour les individus et les organisations.',
  },
};
export const dataHarmony = (resultToShow: any) => {
  return [
    {
      key: locale.problemSolving,
      value: resultToShow?.attributes?.problem_solving || resultToShow?.problem_solving,
      color: '#531B5F',
      img: 'carte_resolution_problemes.png',
      colorSecondary: '#AF8CB1',
      citation:
        '« On ne peut pas résoudre un problème avec le même niveau de pensée que celle qui l’a créé. » <br/> <b>Albert Einstein</b>',
      title: 'Comment développer votre capacité à résoudre les problèmes ?',
      text1:
        '<i>La résolution de problèmes</i> renvoie à la capacité d’analyser une situation et de prendre une décision en fonction de facteurs multiples (matériels, économiques, mais aussi sociaux et/ou psychologiques). Cette capacité est d’autant plus importante que l’on gravit les échelons hiérarchiques. <br/> La quantité d’informations à analyser et le nombre de facteurs à prendre en considération sont alors plus importants et les décisions doivent être prises plus rapidement. <i>La résolution de problèmes</i> renvoie au raisonnement, mais aussi à l’intuition.',
      text2: '',
      titleAd: 'Les escapes games',
      descriptionAd:
        'Depuis quelques années se sont développés partout en France des jeux grandeur nature d’une nouvelle génération. Dans ces jeux qui se jouent la plupart du temps à plusieurs, vous devez résoudre des énigmes pour pouvoir sortir d’une pièce dans laquelle vous avez été enfermé. Les escape game sont des jeux véritablement stimulants pour développer votre capacité à résoudre des problèmes. Vous passerez à coup sûr un excellent moment avec vos proches et apprendrez à les découvrir sous un jour nouveau.',
      listeAccordeon: [
        {
          title: 'Développez votre capacité à raisonner de façon logique',
          description: [
            'Comme un muscle, le cerveau s’entretient, et des exercices adaptés permettent d’améliorer les performances cognitives. Des moyens très variés faisant appel à votre sens de la déduction existent pour vous entraîner et développer votre capacité à résoudre des problèmes. Pour stimuler vos qualités de raisonnement, les méthodes ludiques sont conseillées. Un problème à résoudre ne sera alors progressivement plus perçu comme une corvée, et le cerveau sera davantage disposé à recommencer l’exercice. <br/><br/> Des jeux en ligne ou dans la presse, avec tous les niveaux de difficulté, sont disponibles. Mieux vaut progresser étape par étape pour gagner en estime de soi. Des casse-têtes de tout ordre vous tendent les bras : <ul><li>Anagrammes,</li> <li>Rébus (les rébus classiques avec des dessins ou les dingbats),</li> <li>Énigmes,</li> <li>Logigrammes (jeux de logique appelés aussi intégrammes),</li> <li>Mots croisés,</li> <li>Sudoku,</li> <li>Suites logiques à compléter, etc.</li> </ul> Vous pouvez également vous procurer un taquin. Ce petit jeu malin a été inventé en 1870 aux États-Unis. À l’origine, des petits carreaux, numérotés de 1 à 15, glissaient dans un cadre prévu pour 16. Plusieurs formats existent, donc plusieurs niveaux de difficulté. Les carrés sont aujourd’hui souvent remplacés par des blocs rectangulaires, et représentent une image une fois le taquin résolu. Le but est de remettre les différentes pièces du taquin dans l’ordre, en les faisant glisser un nombre minimal de fois de préférence. Le Rubik’s Cube, inventé en 1974 en Hongrie, n’est quant à lui plus à présenter. Ce casse-tête est un excellent moyen de développer votre capacité à résoudre des problèmes.',
            'Des jeux de réflexion et/ou de stratégie permettent de jouer à plusieurs, et sont aussi efficaces pour stimuler le cerveau : des jeux à deux comme le jeu d’échecs, le jeu de dames ou le Quarto, des jeux à deux ou plus comme le Scrabble… Dans le Quarto, moins connu que les autres jeux cités, pour gagner, il faut créer sur le plateau un alignement (horizontal, vertical ou diagonal) de quatre pièces ayant au moins un caractère en commun : la couleur, la taille, la forme, quatre pièces creuses ou quatre pièces pleines. Pour tous ces jeux, des sites dédiés offrent en outre la possibilité de jouer contre l’ordinateur et proposent différents niveaux de difficulté pour s’entraîner. <br/><br/> Pour être en mesure de résoudre des problèmes, votre cerveau a besoin d’être habitué à réfléchir de façon logique et de détenir les informations nécessaires. Mais cela demande aussi d’être capable de se concentrer sur un problème ou une idée (voir <i>Soft skill n°13</i>). Surtout, fuyez la routine et variez les plaisirs. La multiplicité des expériences stimule les connexions neuronales',
          ],
        },
        {
          title: 'Développez votre intelligence intuitive',
          description: [
            'L’intuition est une forme d’intelligence qui peut aussi se développer, et qui contribue à la résolution de problèmes. Nous avons tous cette « petite voix intérieure », mais certains la refoulent plutôt que de l’écouter et d’en tenir compte. Or elle peut se révéler une vraie alliée pour résoudre des problèmes et nous faciliter la vie. C’est elle qui se fait entendre par exemple lors de déclics ou « d’éclairs de génie » face à des situations difficiles. Pour percevoir cette voix discrète et furtive, soyez à l’écoute de vos ressentis. <br/><br/> L’intelligence intuitive n’est pas dépourvue de rationalité. Elle se base notamment sur des informations sensorielles captées par notre cerveau, sans que nous en ayons conscience. En se fiant à notre intuition, nous arrivons donc à une conclusion sans connaître les perceptions qui nous y ont conduits. Pour être intuitif, il faut développer ses qualités sensorielles, mais aussi se faire confiance (voir <i> Soft skill n°2</i>)',
            'Au-delà de la résolution de problèmes, l’intuition participe à notre bonheur, car elle permet de savoir ce qui est bon pour nous. Pour entendre davantage notre guide intérieur, la méditation consciente représente une bonne méthode. Ainsi, une à deux fois par semaine, assis dans un endroit calme, expirez puis inspirez profondément puis portez votre attention sur vos ressentis : détente, tension… <br/><br/> Demandez-vous ce qui pourrait vous rendre plus épanoui à ce moment de votre vie. Laissez venir la réponse sans la chercher de façon rationnelle. Ne réfléchissez pas, restez simplement connecté à vos émotions. Si la réponse n’arrive pas, recommencez à un autre moment de la journée. Cela demande de la patience et de la persévérance, mais cette pratique se révèle très bénéfique pour votre intelligence intuitive et votre bien-être.',
          ],
        },
      ],
      listEmploi1: [
        'Ingénierie,',
        'R&D,',
        'Consulting,',
        'Entrepreneuriat,',
        'Management,',
        'Conduite de projets',
      ],
      opacity: true,
    },
    {
      key: locale.confidence,
      value: resultToShow?.attributes?.confidence || resultToShow?.confidence,
      color: '#0E1444',
      img: 'carte_confiance.png',
      colorSecondary: '#868AA4',
      citation:
        '« Le problème avec ce monde est que les personnes intelligentes sont pleines de doutes tandis que les personnes stupides sont pleines de confiance. » <br/><b>Charles Bukowski</b>',
      title: 'Comment développer votre confiance en soi et aux autres ?',
      text1:
        'La <i>confiance</i> correspond au niveau de confiance en soi, et donc à la capacité à faire face aux défis quotidiens d’une activité professionnelle, mais aussi au niveau de confiance envers les autres (manager, collègues, clients, fournisseurs, etc.), et donc <i>in fine</i>, à l’aptitude à collaborer efficacement avec eux. Une personne qui n’a pas confiance en elle ou dans les autres aura tendance à gaspiller du temps et de l’énergie pour se protéger. Elle aura des difficultés à travailler en équipe et si elle occupe une fonction managériale à déléguer.',
      text2: '',
      titleAd: 'Apprendre à soutenir le regard',
      descriptionAd:
        'Soutenir le regard, cela s’apprend. En faisant du théâtre ou en prenant des cours de communication, vous apprendrez à bien ancrer vos jambes au sol, à adopter la bonne posture corporelle et à soutenir le regard d’autrui. Les yeux sont composés de muscles et il faut en quelque sorte ʺmuscler son regardʺ pour parvenir à ce résultat, qui vous aidera à développer votre charisme. Vous paraîtrez plus sûr de vous et vous serez donc plus attractif tant d’un point de vue personnel que professionnel, car la plupart des êtres humains recherchent la sécurité et apprécient donc la compagnie de personnes qui ont confiance en elles-mêmes.',
      listeAccordeon: [
        {
          title: 'Commencez par adopter les bons réflexes',
          description: [
            'Pour stimuler votre confiance en vous, commencez par vous sourire devant votre miroir le matin. Cela vous aidera aussi à vous sentir heureux, et à transmettre des émotions positives. Quand vous croisez une personne, n’hésitez pas à lui sourire également. <br/><br/> C’est déjà un premier pas vers l’autre. L’étape suivante consiste à soutenir le regard de l’autre quelques secondes. Ensuite, quand vous vous adressez à quelqu’un, veillez à regarder votre interlocuteur droit dans les yeux.',
            '',
          ],
        },
        {
          title: 'Développez votre capacité à penser de manière positive',
          description: [
            'La pensée positive constitue également un outil pour accroître votre confiance en vous. Si vous recevez une critique au travail, il n’est pas recommandé, pour votre bien-être, de la ruminer toute la journée. <br/> Cela nuirait considérablement à votre confiance. Rappelez-vous plutôt les fois où vous avez été complimenté ou remercié. Cela vous permettra de relativiser, de prendre du recul sur la situation. De même, face à des situations difficiles, il s’agit de penser de manière optimiste, et de se répéter des pensées positives. C’est la base de la méthode de la pensée positive, pour gagner en sérénité. <br/><br/> Pour favoriser cette attitude, soyez bienveillant avec vous-même au quotidien. Vous êtes extraordinairement imparfait ! Acceptez les compliments des autres et remerciez-les.',
            'Laissez-vous le droit à l’erreur et n’oubliez pas vos réussites passées. Un exercice qui peut vous aider consiste à faire la liste sur « un carnet des fiertés » de toutes les choses que vous avez accomplies au cours de votre vie et dont vous êtes fier, à la fois dans le domaine personnel et le domaine professionnel. Complétez cette liste au fur et à mesure (vous ne penserez pas à tout en une seule fois) et relisez-la de temps en temps. Appliquez cette bienveillance également à votre entourage. <br/><br/> Avant de vous endormir, pensez à trois points positifs de votre journée, pour cultiver cette façon de penser et vous apaiser. Vous pouvez aussi écrire quotidiennement vos moments de bonheur dans un journal dédié.',
          ],
        },
        {
          title: 'Découvrez l’art de faire la conversation',
          description: [
            'Comprendre les clefs d’un small talk (conversation informelle) vous aidera à gagner en assurance dans vos relations. Inviter les autres à parler d’eux-mêmes constitue la bonne méthode pour montrer votre intérêt et vous faire apprécier. Cela tombe bien, car, si vous manquez de confiance en vous, cela évite de trop parler de vous-même (dans un premier temps).',
            'Vous posez simplement des questions et rebondissez sur les propos de votre interlocuteur. En outre, cela vous oblige à écouter attentivement, à observer votre interlocuteur. En faisant cela, petit à petit, vous ne vous inquiétez plus de l’image que vous renvoyez. Vous êtes focalisé sur l’autre et non plus sur vous-même.',
          ],
        },
        {
          title: 'Éliminez la peur du regard des autres',
          description: [
            'Vous avez souvent l’impression que des projecteurs sont braqués sur vous, vous avez peur du regard des autres. La présence d’autres personnes vous rend mal à l’aise. Si c’est votre cas, prenez conscience qu’en réalité la plupart des gens ne vous regardent pas, trop occupés avec leur téléphone ou à résoudre leurs propres problèmes… Non, personne n’analyse vos faits et gestes. <br/><br/> Identifiez vos qualités et vos points forts et concentrez-vous là-dessus. Apprenez à vous connaître afin de vous aimer davantage. N’essayez pas de ressembler aux autres, mais acceptez vos différences. Votre « carnet des fiertés » vous aidera à vous valoriser.',
            'Vous devez également accepter le fait que l’on ne peut pas plaire à tout le monde. Chacun d’entre nous, à un moment donné, se sent rejeté par les autres. Ne le prenez jamais personnellement : c’est leur choix, ils ont leurs raisons. Voyez le côté positif : cela vous permet de vous rapprocher de personnes qui vous correspondent davantage, avec qui vous avez plus d’affinités. Allez de l’avant.',
          ],
        },
      ],
      listEmploi1: [
        'Consulting,',
        'Service achats,',
        'Recrutement,',
        'Direction générale,',
        'Management,',
        'Conduite de projets',
      ],
      opacity: 'true',
    },
    {
      key: locale.emotionalIntelligence,
      value:
        resultToShow?.attributes?.emotional_intelligence || resultToShow?.emotional_intelligence,
      color: '#FFC572',
      img: 'carte_intelligence_emotionnelle.png',
      colorSecondary: '#B48746',
      citation: '« Au commencement était l’émotion. » <br/> <b>Louis-Ferdinand Céline</b>',
      title: 'Comment développer votre intelligence émotionnelle ?',
      text1:
        '<i>L’intelligence émotionnelle</i> correspond à la capacité à utiliser ses propres émotions (après les avoir identifiées) pour prendre des décisions efficaces et passer à l’action. Contrairement à une idée reçue, il ne s’agit pas de réprimer ses émotions ou de les maîtriser, mais plutôt d’en faire des moteurs utiles de l’action. <i>L’intelligence émotionnelle</i> permet également d’identifier les émotions ressenties par les autres. Elle permet donc d’adapter ses messages et d’améliorer <i>in fine</i> sa communication et son leadership.',
      text2:
        'Pour développer votre intelligence émotionnelle, il est crucial de vous exercer d’une part à prendre du recul sur vos propres ressentis, et, d’autre part, à analyser les émotions des autres.',
      titleAd: 'd',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Commencez par être attentif à ce que vous ressentez',
          description: [
            'L’intelligence émotionnelle vous permet d’utiliser vos propres émotions comme un moteur pour agir efficacement. <br/> Pour développer votre intelligence émotionnelle, vous devez donc savoir analyser vos propres émotions et vos besoins, en prendre conscience. Interrogez-vous sur les valeurs qui sont importantes à vos yeux, ce qui est primordial dans votre vie, ce qui vous rend heureux, ce qui contribue à votre accomplissement. Cette réflexion vous aide à identifier vos besoins. <br/><br/> Faites ensuite une liste de ce que vous aimeriez faire dans un futur proche ou lointain : des expériences rapidement réalisables ou pas. Ne les classez pas, laissez parler votre cœur, écoutez-vous. Ne vous censurez pas. Alimentez de nouveau ou modifiez la liste de vos envies quand vous avez une idée nouvelle ou plus précise.',
            'Des exercices d’écriture automatique peuvent également vous aider à libérer votre inconscient. Plus vous en ferez, plus vous réussirez à être spontané. Une autre façon de faire ressortir vos émotions est de vous exercer à parler de vous à partir d’une image prise au hasard. Après un court temps de réflexion (trente secondes par exemple), faites le lien entre cette image et ce que cela fait ressurgir de vous, de préférence une émotion positive : un trait de votre tempérament, un projet, une anecdote passée… <br/> Laissez parler vos émotions afin de vous redécouvrir. <br/><br/> Quand vous avez une pensée positive vis-à-vis de votre interlocuteur, exprimez-la et expliquez la raison de votre compliment ou remerciement. Les compliments et les remerciements font toujours plaisir. En outre, cela vous permet d’extérioriser vos émotions.',
          ],
        },
        {
          title: 'Soyez attentif à ce que ressentent les autres',
          description: [
            'Plusieurs moyens sont à votre disposition pour développer votre sens de l’écoute et vous exercer à identifier les émotions des autres. Les méthodes ludiques restent les plus efficaces. <br/><br/> De nombreux jeux de société vous demandent d’être à l’écoute des autres et/ou d’analyser leurs attitudes, ce qui constitue un bon moyen de développer votre intelligence émotionnelle. <br/><br/> Dans le jeu <i>Dixit</i> par exemple, cette qualité est utile pour comprendre le lien entre la carte du joueur et son message, c’est-à-dire ce que l’image représentée lui a inspiré. Dans d’autres jeux, c’est cette même analyse qui vous permettra de trouver le meilleur moyen de connexion avec votre partenaire, afin qu’il vous identifie (un mot pertinent dans le cas du jeu <i>Linq</i>, etc.). <br/><br/> Les jeux de bluff représentent bien sûr un très bon exercice pour vous entraîner à identifier les émotions des autres. Le poker est un incontournable des jeux de bluff avec des cartes. Pour changer des cartes rectangulaires classiques, vous pouvez essayer le jeu de société <i>Skull & Roses</i>.',
            'Lorsque vous vous retrouvez dans un petit groupe d’individus où personne ne se connaît, n’hésitez pas à proposer un petit jeu pour apprendre à se connaître et briser la glace. Les règles sont très simples. Un joueur énonce trois affirmations sur lui-même, mais une seule est vraie. Les autres peuvent éventuellement lui poser chacun une question. Puis ils doivent dire l’affirmation qui leur semble vraie. Le joueur « cible » donne la bonne réponse, commente, puis c’est au tour du joueur suivant. Ce jeu ne nécessite aucun matériel, peut se faire n’importe où, et est accessible à n’importe qui, même des gens peu habitués aux jeux de société. En outre, cela développe l’intelligence émotionnelle. Des petits indices peuvent aider à trouver l’affirmation correcte : posture, façon d’énoncer l’affirmation, ce que vous pouvez imaginer des goûts de la personne ou de son tempérament… Soyez attentif.',
          ],
        },
      ],
      listEmploi1: [
        'Service à la personne,',
        'Métiers d’aide,',
        'Formation & Insertion,',
        'Enseignement,',
        'Communication,',
        'Management',
      ],
    },
    {
      key: locale.empathy,
      value: resultToShow?.attributes?.empathy || resultToShow?.empathy,
      color: '#2435BD',
      img: 'carte_empathie.png',
      colorSecondary: '#909AE3',
      citation:
        '« L’empathie, c’est voir avec les yeux de l’autre, écouter avec les oreilles de l’autre et ressentir avec le cœur de l’autre. » <br/> <b>Louis-Ferdinand Céline</b>',
      title: 'Comment développer votre empathie ?',
      text1:
        '<i>L’empathie</i> consiste à « se mettre à la place de », à élaborer une représentation du système de pensée et d’action de son interlocuteur (trice). Il s’agit de comprendre pourquoi il (elle) se comporte de telle ou telle façon, pourquoi il (elle) prend telle ou telle décision, pourquoi il(elle) ressent telle ou telle émotion, de façon <i>in fine</i> à pouvoir l’influencer positivement. Cela peut s’appliquer à un(e) client(e), un(e) collaborateur(trice), ou encore à un(e) élève ou un(e) patient(e). <i>L’empathie</i> est une compétence clef dans tous les métiers où la relation humaine est fondamentale.',
      text2: '',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Commencez par développer votre écoute empathique',
          description: [
            'Afin de développer votre écoute empathique, commencez par écouter attentivement votre interlocuteur sans lui couper la parole. Puis, dans un deuxième temps, prenez l’habitude de reformuler ses paroles. Cela évite de donner l’impression à l’autre d’être jugé ou analysé : plutôt que de conseiller, consoler… montrez simplement que vous comprenez ses émotions et ses besoins. La paraphrase invite également votre interlocuteur à apporter des précisions et/ou poursuivre. Questionnez-le ensuite pour éclaircir certains points et pour montrer votre intérêt. <br/><br/> Résistez à l’envie parfois d’interrompre la personne pour proposer une solution ou partager une expérience personnelle. Essayez plutôt de vous concentrer sur la compréhension de l’autre : son ressenti et les raisons de son ressenti. Posez des questions pertinentes, sans émettre de jugement. Vous pouvez également exprimer ce que vous ressentiriez dans la même situation, à condition d’être sincère. <br/><br/> Une fois que vous comprenez mieux la personne, vous pouvez, pour l’aider, proposer une solution comme une option qui vous semble adaptée à la situation. Mais il ne faut surtout pas donner l’impression de tout connaître ou d’avoir toutes les réponses. Ne vous laissez pas non plus submerger et contaminer par les émotions de l’autre. Vous ne seriez alors plus dans l’empathie, mais dans la compassion, et ne pourriez plus apporter de solution adaptée. Gardez un certain recul.',
            'Ayez une écoute active, c’est-à-dire tournée vers la compréhension de l’autre. Souvenez-vous qu’une personne en souffrance a souvent besoin d’être entendue et comprise, avant d’être aidée. En outre, vous lui laisserez une image plus positive de vous. En amenant l’autre à parler spontanément, votre interlocuteur appréciera forcément la conversation, car c’est toujours gratifiant. <br/><br/> Pour aller plus loin, mettez en valeur votre interlocuteur, soit avec un compliment utilisé à bon escient (sans que cela puisse faire douter de votre sincérité), soit en demandant son avis. Cette méthode est plus efficace et plus subtile. Vous montrez ainsi que vous accordez de l’importance à son opinion, ce qui est favorable à la poursuite du dialogue. <br/><br/> Afin de faciliter cette écoute active, vous devez veiller à regarder votre interlocuteur en permanence et être pleinement disponible et concentré, donc ne pas vous laisser distraire. Quelques indices peuvent vous aider à savoir si vous avez écouté l’autre avec empathie, notamment : un relâchement des tensions corporelles de part et d’autre, le fait que votre interlocuteur s’arrête de parler. En cas de doute, demandez-lui s’il souhaitait dire autre chose.',
          ],
        },
        {
          title: 'Exercez-vous régulièrement à faire preuve d’empathie',
          description: [
            'Faire preuve d’empathie, c’est donc se mettre à la place de son interlocuteur, se représenter sa façon de penser. Cela va au-delà d’une écoute attentive. Il s’agit de comprendre les souhaits de son interlocuteur. Pour développer cette faculté, vous pouvez faire l’exercice suivant : quand vous rencontrez une personne pour la première fois, soyez particulièrement attentif et observateur, et notez, après l’entretien, ce que vous avez appris sur cette personne à travers son attitude et votre conversation, ce que vous en déduisez sur ses souhaits et ce qui les motive. Les gestes et les postures sont aussi intéressants à relever que les paroles. <br/><br/> Retenir le prénom de vos interlocuteurs est la première étape pour montrer de l’intérêt à l’autre. Faites cet effort pour vous rapprocher d’eux plus facilement. Dans une soirée où vous ne connaissez pas tous les invités, entraînez-vous en essayant de mémoriser au moins six prénoms parmi ces personnes avant de quitter les lieux.',
            'Que ce soit dans le cadre professionnel ou privé, préparer une surprise à une personne que vous connaissez constitue un bon moyen de développer votre empathie. Pour un anniversaire par exemple, vous devez vous mettre à la place de cette personne pour comprendre ce qui lui ferait le plus plaisir. Vous devez analyser ce que cette personne aime dans la vie, ce qui est important à ses yeux, ce qui suscitera le plus d’émotions positives chez elle. <br/><br/> Soyez attentif aux personnes qui vous entourent, même si vous ne les connaissez pas. Cherchez à comprendre les besoins de ces personnes. Si une personne vous semble perdue, n’hésitez pas à lui proposer votre aide pour retrouver son chemin. Vous pouvez également aider des personnes en difficulté pour traverser la rue… Beaucoup de gens n’osent pas demander. Il faut faire preuve d’empathie pour les remarquer, mais aussi simplement pour offrir son aide. Consacrer du temps à une autre personne représente un bon moyen de développer votre empathie.',
          ],
        },
        {
          title: 'Faites preuve d’empathie avec vous-même',
          description: [
            'Pour pouvoir faire preuve d’empathie vis-à-vis des autres, vous devez être suffisamment disponible mentalement, être à l’aise avec vos émotions du moment, vous comprendre vous-même. Si ce n’est pas le cas, faites preuve d’auto-empathie avant d’essayer de comprendre les autres. Faites une pause pour vous recentrer sur vous-même. Exprimez vos émotions internes et vos besoins.',
            'Prenez le temps de réfléchir à des solutions, des souhaits. Pardonnez-vous vos erreurs du passé, essayez d’identifier quel besoin vous tentiez de satisfaire à ce moment-là, et reconnaissez simplement que c’était un moyen inapproprié. Faites le choix conscient d’agir chaque jour au service de vos propres besoins et valeurs.',
          ],
        },
      ],
      listEmploi1: [
        'Psychologie,',
        'Enseignement,',
        'Formation & insertion,',
        'Santé,',
        'Communication,',
        'Management',
      ],
      opacity: true,
    },
    {
      key: locale.communication,
      value: resultToShow?.attributes?.communication || resultToShow?.communication,
      color: '#FFB0A4',
      img: 'carte_communication.png',
      colorSecondary: '#834144',
      citation:
        '« La chose la plus importante en communication, c’est d’entendre ce qui n’est pas dit. » <br/> <b>Peter Drucker</b>',
      title: 'Comment développer vos qualités de communicant ?',
      text1:
        'Plus un(e) salarié(e) monte dans la hiérarchie et plus sa capacité à communiquer doit être élevée. Pour bien communiquer, il faut d’abord être capable de traiter une grande quantité d’informations, de sélectionner à l’intérieur de ce flot d’informations celles qui sont pertinentes en écartant les informations inutiles (ou fausses) pour ensuite retransmettre sous une forme efficace, attractive et mémorisable ces informations à un public large. <i>La communication</i> associe donc traitement de l’information et élaboration de messages.',
      text2:
        'Pour être un bon communicant, il faut à la fois développer sa capacité de synthèse et savoir s’adapter au public et aux circonstances. Pour certaines occasions, mieux vaut également bien préparer son intervention orale.',
      listeAccordeon: [
        {
          title: 'Commencez par améliorer votre capacité de synthèse',
          description: [
            'Maîtriser l’art de communiquer permet avant tout d’être écouté et compris. Cela nécessite une grande capacité de synthèse pour identifier et transmettre uniquement les informations les plus pertinentes. Vous n’aurez souvent que quelques minutes pour convaincre. Vous devez donc apprendre à être concis tout en étant précis, et, si possible, capter l’attention de vos interlocuteurs dès les premières secondes. <br/> <br/> Pour apprendre à aller à l’essentiel tout en restant suffisamment clair, vous pouvez vous entraîner à résumer un article de presse ou une conférence. Quand vous parlez d’un film que vous avez vu, appliquez-vous à mettre en avant les éléments importants, en vous demandant ce qui était le plus significatif (la performance d’un acteur, l’émotion…). Cet autre exercice est très facile à mettre en pratique.',
            'Pour aller plus loin, vous pouvez développer cette aptitude en vous exerçant par exemple à trouver un titre court et juste à la journée que vous venez de passer, ou chercher un nom judicieux à votre habitation… <br/> <br/> Pour vous entraîner, vous pouvez également, à la fin de chaque mois, prendre du recul sur tout ce que vous avez fait, et ce qu’il vous est arrivé dans votre vie les quatre dernières semaines. Si vous ne deviez retenir qu’une chose, qu’est-ce que ce serait ? Un autre exercice consiste à choisir un objet chez vous et trouver un slogan le plus accrocheur possible, comme si vous deviez le vendre, ou encore faire l’éloge de ce produit en quelques minutes (pitch)…',
          ],
        },
        {
          title:
            'Vous pouvez aussi chercher à améliorer votre capacité à adapter votre communication en fonction du public et des circonstances',
          description: [
            'Une bonne expérience pratique pour communiquer avec des personnes différentes pendant une journée entière est de tenir un stand dans un vide-grenier. Pour développer vos qualités de communicant, essayez de trouver un message adapté pour chaque nouveau passant, de façon à ce que le plus grand nombre s’arrête à votre stand. Puis poursuivez pour les inciter à découvrir vos produits, et à acheter. Souvenez-vous que vos qualités de communicant sont essentielles pour vendre. <br/><br/> De nombreux jeux de société font également appel à la communication. C’est le cas de <i>Petits meurtres et faits divers</i>. Ce jeu (pour 4 à 7 joueurs) propose de nombreuses enquêtes ubuesques. Pour chaque enquête, un joueur joue le rôle d’un inspecteur. Les autres sont suspects, et parmi les suspects se trouve le coupable. Les suspects doivent intégrer trois mots imposés durant leur interrogatoire, ceux du coupable étant différents de ceux des autres suspects.',
            'Le but consiste pour tous à tromper l’inspecteur. Seul un sens de la communication efficace pourra induire en erreur l’inspecteur. Dans le jeu <i>Nonsense family</i>, le principe est le même : raconter à partir d’une situation imposée une histoire en une minute tout en glissant un mot secret dans son récit. Avec l’objectif que personne ne repère ce mot ! <br/> <br/> Pour développer vos qualités de communicant, vous pouvez également jouer à une variante du jeu télévisé <i>Mot de passe</i>. Nommons cette variante « Oracle ». Dans cette variante, un joueur, l’oracle, doit deviner le mot attribué à chacun des autres joueurs (ces joueurs se sont échangé des mots écrits sur un papier au préalable). Les règles principales sont les suivantes : l’oracle demande un premier indice à un joueur ; l’oracle et le donneur d’indice reçoivent chacun trois points si le mot est trouvé au premier indice, deux si deux indices sont nécessaires et un point pour trois indices. Être donneur d’indice, donc trouver le ou les mots les plus pertinents à donner à l’oracle, développe votre sens de la communication.',
          ],
        },
        {
          title: 'Pensez à bien préparer vos interventions orales',
          description: [
            'Dans certains cas une préparation de votre intervention orale est nécessaire : entretien d’embauche, rendez-vous avec un potentiel partenaire financier… Entraînez-vous à parler ni trop vite ni trop lentement, suffisamment fort et avec une bonne élocution. Pour transmettre efficacement votre message, pensez aussi à adapter le vocabulaire utilisé en fonction de votre interlocuteur. Écrivez-vous l’objectif de votre communication et à qui vous vous adressez. Répétez votre intervention pour prendre de l’assurance. Ajoutez du rythme, de l’émotion, afin de rendre votre communication plus vivante.',
            'Quand vous maîtriserez déjà bien l’art de la communication, vous pourrez éventuellement aller plus loin en imitant certaines particularités comportementales et linguistiques de votre interlocuteur, dans le cas d’un tête à tête. Ce mimétisme est utilisé par les experts de la communication pour convaincre. <br/><br/> Travaillez également votre communication non verbale, c’est-à-dire votre posture, vos gestes, votre regard, votre sourire. Pour capter l’attention et être écouté, le langage corporel est encore plus important que les mots.',
          ],
        },
      ],
      listEmploi1: [
        'Direction général,',
        'Journalisme,',
        'Communication,',
        'Consulting,',
        'Big Data,',
        'Management',
      ],
    },
    {
      key: locale.timeManagement,
      value: resultToShow?.attributes?.time_management || resultToShow?.time_management,
      color: '#6C4D95',
      img: 'carte_gestion_temps.png',
      colorSecondary: '#B9A5CD',
      citation:
        '« Nous ne manquons pas de temps, mais nous en avons beaucoup dont nous ne savons pas tirer profit. » <br/> <b>Sénèque</b>',
      title: 'Comment développer vos capacités à mieux gérer votre temps ?',
      text1:
        'Le temps est la ressource la plus rare du XXIe siècle. Et le temps, c’est de l’argent ! Pour gagner en efficacité et en performance, un(e) salarié(e) doit avoir la capacité de bien gérer son temps. Cela signifie qu’il (elle) doit être capable de bien s’organiser pour traiter le plus grand nombre de tâches possibles tout en traitant les urgences et les priorités. Il (Elle) doit donc être capable d’identifier par lui-même (elle-même) les actions prioritaires tout en communiquant avec ses collègues et sa hiérarchie ou tout(e) autre interlocuteur (trice) sur la manière de conduire ses actions.',
      text2: '',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Commencez par prendre l’habitude d’anticiper',
          description: [
            'Si vous avez une présentation orale ou un entretien important, anticipez cet événement. La veille, préparez la tenue que vous allez porter et les documents à prendre avec vous. Recherchez à l’avance le meilleur moyen de vous rendre à votre rendez-vous, calculez le temps nécessaire… Si vous utilisez votre voiture, assurez-vous d’avoir suffisamment de carburant, pour éviter de devoir vous arrêter à une station-service ce jour-là. À ce propos, n’attendez jamais la dernière minute pour mettre du carburant dans votre véhicule. D’une part, il est fortement déconseillé de rouler avec un réservoir presque vide. D’autre part, au moment où vous aurez absolument besoin de remettre du carburant, vous ne vous trouverez pas forcément à côté d’une station-service, ce qui vous obligera à faire un détour, donc à perdre du temps. Et cela générera du stress ! <br/><br/> De même, en prévision d’un voyage ou d’un déplacement professionnel, ne préparez pas votre valise le jour de votre départ, mais la veille, si possible dans la journée, sans précipitation, de façon à ne rien oublier. Cela vous évitera aussi de vous mettre en retard au moment de partir. <br/><br/> Afin de ne rien oublier au supermarché, et éviter de devoir y retourner trop souvent, le mieux est de prendre l’habitude de partir avec une liste de courses conséquente. Pour l’élaborer, notez sur une feuille dédiée le nom des produits dès que vous vous rendez compte qu’il vous manque quelque chose.',
            'La veille des courses, allez dans chaque pièce de votre logement (cuisine et salle de bain notamment), ouvrez les placards, et complétez cette liste. Si vous ne vivez pas seul, demandez aux autres membres du foyer leurs besoins. Organisez cette liste en regroupant les produits par catégorie (produits ménagers, produits frais, produits congelés…). Cela vous fera gagner du temps une fois dans le magasin. Vous pouvez également faire le choix de commander vos courses en ligne. Même dans ce cas-là, gardez l’habitude de faire votre liste de courses pour ne rien oublier. <br/><br/> Pour gagner du temps dans la préparation de vos repas, la solution n’est pas de manger du surgelé ou de commander systématiquement des pizzas ! Mais prenez l’habitude de cuisiner pour deux repas (pour quatre si vous êtes deux par exemple). Vous cuisinerez ainsi une fois sur deux seulement. Et vous alternez : vous ne mangez pas la même chose au repas suivant, mais à celui d’après. Pour les plats très longs à cuisiner, voyez plus grand, et congelez-en une partie. Vous pourrez ainsi en profiter une autre fois, bien plus tard, sans repasser du temps à la préparation et à la cuisson.',
          ],
        },
        {
          title: 'Essayez de vous organiser en priorisant les tâches à accomplir',
          description: [
            'Mieux s’organiser est le deuxième point clef pour une bonne gestion du temps. Planifier les différentes tâches sur un agenda, ranger ses documents et faire du tri sont des habitudes à prendre pour mieux gérer son temps, donc être à la fois plus efficace et plus serein. Pour gagner du temps, il est important que votre bureau soit rangé de façon ergonomique et logique pour vous. Votre agenda doit être bien sûr alimenté au fur et à mesure de l’identification de vos tâches à accomplir, mais aussi consulté quotidiennement. <br/><br/> Veillez à noter toutes vos tâches importantes, vos rendez-vous, vos différentes activités, les événements auxquels vous souhaitez participer… Précisez à chaque fois l’heure exacte et le lieu. Utilisez une couleur différente pour les points prioritaires. Avant d’inscrire une tâche à accomplir, analysez le degré d’urgence et d’importance. Si ce n’est pas important et que votre journée est déjà chargée, reportez-la à un autre jour. Si, au contraire, c’est urgent, n’hésitez pas à décaler une activité moins importante pour l’insérer à la place. Pour les tâches qui demandent beaucoup d’investissement, fixez-vous une limite de temps afin de canaliser votre énergie. Vous découvrirez que vous allez vous adapter pour réaliser naturellement ces tâches dans le temps imparti. Dans tous les cas, vous finirez plus vite que sans fixer d’échéance. <br/><br/> Vous devez prévoir davantage de temps pour les choses importantes pour vous, que ce soient vos objectifs de travail ou vos activités dans votre vie privée. Le but n’est pas d’en faire le plus possible dans une journée, mais de faire les bons choix. Pour ne pas vous laisser submerger, il est également primordial de savoir dire non quand, objectivement, vous n’avez pas le temps d’ajouter une mission dans votre journée déjà bien remplie.',
            'Ne réalisez, autant que possible, qu’une seule tâche à la fois. Vous serez beaucoup plus efficace en finissant chaque tâche avant de passer à une autre. Éviter de se disperser représente un bon moyen d’améliorer votre gestion du temps. <br/><br/> Dans votre agenda, si vous avez noté plusieurs choses à faire dans la journée, à des endroits différents, optimisez vos déplacements pour ne pas perdre de temps. Vous pouvez utiliser par exemple <i>Google Maps</i> et l’option itinéraire, en indiquant votre moyen de déplacement et les différentes adresses. Vous trouverez ainsi l’ordre dans lequel vous devez procéder pour une gestion optimale de votre temps. <br/><br/> Si vous organisez vous-même un week-end ou des vacances, préparez une feuille (ou un fichier accessible sur un <i>Drive</i>) dédiée à la préparation. Prévoyez une rubrique avec les choses à emporter, avec une couleur différente pour les produits que vous n’avez pas encore chez vous (crème solaire le cas échéant…) donc à acheter avant votre départ. Une autre rubrique indique les choses à faire : vaccins, visa, réservation d’un véhicule… <br/><br/> Outre le fait que ces bonnes habitudes permettent de mieux gérer votre temps, notez également que la plupart vous font aussi faire des économies (baisse de votre consommation de carburant, en diminuant le nombre de kilomètres parcourus ; baisse de votre consommation d’électricité/gaz, en cuisinant de manière plus optimisée) et cela contribue, par la même occasion, à diminuer votre empreinte écologique.',
          ],
        },
      ],
      listEmploi1: [
        'Logistique & transport,',
        'Production industrielle,',
        'Journalisme,',
        'Métiers du bâtiment,',
        'Entrepreneuriat,',
        'Management',
      ],
      opacity: true,
    },
    {
      key: locale.stressManagement,
      value: resultToShow?.attributes?.stress_management || resultToShow?.stress_management,
      color: '#F96482',
      img: 'carte_gestion_stress.png',
      colorSecondary: '#FFAEC1',
      citation:
        '« Le sourire est un anti-stress qui orne notre visage, atténue les conflits et soulage les cœurs souffrants. » <br/> <b>Mofaddel Abderrahim</b>',
      title: 'Comment améliorer votre gestion du stress ?',
      text1:
        'Le stress positif n’existe pas, sauf s’il est ponctuel. Toute personne qui entre en état de stress de façon chronique va voir ses performances (physiques et cognitives) diminuer peu à peu. Pour prévenir le stress, le(a) salarié(e) doit maîtriser un certain nombre de techniques lui permettant de réguler par lui-même (elle-même) son état physiologique (autohypnose, méditation, cohérence cardiaque, etc.). La prévention du stress passe également par une bonne hygiène de vie (alimentation, sommeil, activité physique, etc.) qui favorise l’équilibre intérieur.',
      text2:
        'De nombreuses méthodes permettent d’améliorer sa gestion du stress. Certains outils procurent des effets immédiats, notamment ceux axés sur le rééquilibre de l’hygiène de vie. D’autres apportent des bénéfices sur le moyen et le long terme. C’est le cas de tout travail de fond comportemental ou l’apprentissage de techniques régulant le stress. Seule la pratique régulière permet d’en apprécier pleinement les effets.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Commencez par avoir une bonne hygiène de vie',
          description: [
            'Une bonne hygiène de vie comprend notamment le fait de bien manger et bien dormir. Un manque de magnésium par exemple vous rendra irritable, nerveux. Mangez donc sans sauter de repas et de façon équilibrée : fruits, légumes et féculents chaque jour, sans oublier une source de protéines (viande, poisson, œuf ou légumineuses riches en protéines végétales). Limitez la consommation d’excitants (cigarettes, alcool, café…) et buvez suffisamment d’eau. Afin de ne pas nuire au bon fonctionnement de votre horloge biologique, éteignez les écrans, en particulier ceux riches en lumière ʺbleueʺ (smartphones, tablettes…), bien avant votre coucher, et ce jusqu’au lendemain.<br/><br/> L’activité physique participe également à une bonne hygiène de vie. Les endorphines libérées pendant une séance de sport vous aident à vous détendre. Ce sera encore plus bénéfique s’il s’agit d’une activité en extérieur. La lumière naturelle et l’exposition au soleil entraînent en effet la sécrétion de vitamine D et de mélatonine, ayant un effet positif sur l’humeur et le bon fonctionnement de votre horloge biologique. <br/><br/> Savoir se détendre contribue également à un bon équilibre psychologique et donc à une meilleure gestion du stress. Réservez-vous quotidiennement un moment rien qu’à vous pour vous relaxer. C’est vous qui vous connaissez le mieux, donc c’est à vous de choisir des solutions anti-stress qui vous correspondent.',
            'Et vous pouvez varier les plaisirs : vous offrir une séance de massage, faire un puzzle, colorier un mandala, chanter, écouter une playlist personnelle de vos musiques préférées en fermant les yeux… <br/><br/> Si, au moment où vous en avez besoin, vous n’avez pas à disposition de playlist personnelle avec des musiques qui vous détendent, sachez que vous pouvez trouver en ligne des enregistrements dits ASMR de bruits familiers et apaisants : crépitements d’un feu, ronronnement d’un chat, vagues de l’océan… <br/> Toutes ces activités ont en commun de vous permettre de vous recentrer sur vous-même. Cela aide à lâcher prise, prendre du recul et relativiser les choses qui vous agacent. <br/><br/> D’autres personnes préféreront simplement se ressourcer en s’asseyant contre un arbre. Les jambes allongées, il suffit de fermer les yeux, écouter le bruit du vent dans les feuilles, ressentir le souffle léger sur votre peau, humer la nature… <br/><br/> N’oubliez pas que rire constitue aussi un bon anti-stress. Histoires drôles, spectacles humoristiques d’un comédien que vous affectionnez… À consommer sans modération.',
          ],
        },
        {
          title: 'Pratiquez la communication non violente',
          description: [
            'La pratique de la communication non violente représente une bonne méthode de gestion du stress et permet d’entretenir de bonnes relations avec les autres. Il s’agit d’extérioriser son ressenti en le verbalisant positivement. La communication non violente vous aide à maintenir votre qualité d’écoute, avec vous-même et avec autrui. Une interaction bienveillante est facilitée. Ce mode de communication constructif favorise une coopération harmonieuse et peut éviter d’entrer en conflit. Cela consiste à parler de manière bienveillante, sans faire de reproches ni donner de conseils, sans jugement (la formule « je souhaiterais… » est préférable à « vous devriez… »). Garder des pensées négatives en vous ne fait qu’augmenter votre stress. Parler est une façon d’extérioriser. Il s’agit d’exprimer objectivement votre ressenti, vos émotions, vos besoins et souhaits. Si l’autre se sent agressé ou blessé, le risque qu’il soit sur la défensive est important, ce qui n’augure rien de bon pour votre relation. <br/><br/> La communication non violente fait apparaître quatre étapes : <ul> <li>L’observation, c’est-à-dire la formulation des faits de façon objective, sans jugement.</li> <li>L’expression de vos émotions, vos sentiments (dites simplement ce que vous ressentez).</li> <li>L’expression de vos besoins (directement liés aux sentiments identifiés précédemment).</li> <li>La formulation de votre demande, vos souhaits, de manière bienveillante, sans exiger ou menacer. Vous restez à l’écoute de votre interlocuteur. Le dialogue est ainsi facilité et calme, et une solution trouvée ensemble en ressort.</li></ul>',
            'Cette méthode n’est pas applicable du jour au lendemain. C’est un savoir-être qui s’acquiert avec le temps, et après de nombreux exercices. Mieux vaut s’entraîner au début sur des situations qui ne sont pas particulièrement stressantes, et dont l’enjeu est mineur. Attention, dans les cas où une situation vous a vraiment énervé, mieux vaut attendre quelques minutes le temps de vous calmer (sortir prendre l’air ou boire un verre d’eau), avant de communiquer votre ressenti à votre interlocuteur, si vous voulez être sûr d’échanger de façon non violente. <br/><br/> Quand ce n’est pas une personne qui vous stresse, mais une situation, il est important d’avoir quelqu’un à qui vous confier. Entourez-vous de personnes positives, et parlez avec vos proches de vos doutes ou craintes afin de les extérioriser. Cela vous aidera à mieux gérer votre stress.',
          ],
        },
        {
          title: 'Développez vos capacités physiques de régulation du stress',
          description: [
            'L’approche corporelle utilise des techniques de régulation du stress : respiration, relaxation (sophrologie), méditation, autohypnose… Le stress constitue un état physiologique qui peut se traduire en tant que tel par des symptômes spécifiques : sueur, augmentation du rythme cardiaque, modification de la voix ou bégaiement… La respiration est la méthode de régulation la plus simple à mettre en œuvre, et les bienfaits sur l’état émotionnel sont scientifiquement prouvés. Encore faut-il savoir comment respirer.',
            'La base est d’inspirer par le nez en gonflant le ventre et d’expirer par la bouche en rentrant le ventre, doucement, sans ouvrir trop la bouche. Imaginez alors que s’échappent de votre bouche tous vos soucis ou angoisses. Pour mieux ressentir cette respiration abdominale, il est conseillé de placer une main à plat sur le ventre, en dessous du nombril. Quand cette partie est maîtrisée, de nombreux exercices de respiration antistress plus précis peuvent être pratiqués. Le yoga est un outil anti-stress basé sur un ensemble de postures et d’exercices de respiration.',
          ],
        },
      ],
      listEmploi1: [
        'Police, armée, pompiers,',
        'Logistiques & transport,',
        'Entrepreneuriat,',
        'Services administratifs,',
        'Management',
      ],
      opacity: true,
    },
    {
      key: locale.creativity,
      value: resultToShow?.attributes?.creativity || resultToShow?.creativity,
      color: '#FF7B81',
      img: 'carte_creativite.png',
      colorSecondary: '#834144',
      citation:
        '« Il faut avoir une part de délire, c’est la poésie, c’est l’incertitude, c’est l’hésitation, c’est le trouble, et c’est la source de la créativité. » <br/> <b>Boris Cyrulnik </b>',
      title: 'Comment développer votre créativité ?',
      text1:
        'Un(e) salarié(e) créatif(ve) est un(e) salarié(e) qui sait trouver des <b>solutions innovantes</b> à des problèmes difficiles. C’est aussi une personne qui peut créer de <b>nouvelles stratégies</b> pour inventer de nouveaux produits, de nouvelles formes d’organisation, de nouvelles attitudes managériales. <br/><br/> Dans un monde où les changements sont de plus en plus intenses et fréquents, la créativité est une aptitude fondamentale et une qualité centrale dans <b>une équipe qui sera ainsi plus résistante aux aléas.</b> <br/><br/> « Si je suis créatif(ve), quand je rencontre un problème, je peux réagir différemment ! »',
      text2: '',
      titleAd: 'Le jeu du dictionnaire',
      descriptionAd:
        'Pour stimuler la créativité, commençons par le jeu du dictionnaire, car il ne nécessite pas de matériel particulier. Un premier joueur, appelé le lecteur, lit un mot du dictionnaire peu connu, sans l’épeler. Les autres joueurs doivent écrire sur leur papier une définition qui leur semble crédible. <br/> Le lecteur récupère ensuite les papiers, les mélange, lit toutes les définitions, en leur attribuant un numéro et en incluant celle du dictionnaire. Les joueurs ayant retrouvé la bonne définition (celle du dictionnaire) marquent un point et reçoivent un point supplémentaire par personne ayant voté pour leur définition inventée. L’invention d’une définition crédible, même si elle est fausse, fait appel à la créativité.',
      listeAccordeon: [
        {
          title: 'Commencez par vous entraîner auprès des enfants',
          description: [
            'Les enfants sont un public à privilégier si vous souhaitez développer votre créativité. Vous avez des enfants vous-même ou dans votre entourage proche… N’hésitez pas à inventer pour eux quelques charades ou leur dessiner des rébus, en fonction de leur âge et de ce qu’ils préfèrent. C’est un bon exercice pour vous, et ils seront ravis.',
            'Toujours avec le même public d’enfants, vous pouvez vous entraîner à l’origami en concevant pour eux un animal en papier (uniquement par pliages). S’ils trouvent rapidement de quel animal il s’agit, vous gagnez votre défi !',
          ],
        },
        {
          title: 'Essayez-vous à l’écriture ou à la poésie',
          description: [
            'Pensez à une personne que vous aimez, et écrivez-lui un poème. Pour augmenter la difficulté, définissez à l’avance le nombre de strophes, de vers par strophe, et le type de vers éventuellement. N’oubliez pas les rimes ! <br/><br/> Un autre exercice consiste à demander à des personnes de votre entourage dix mots en tout, ou à prendre ces mots au hasard en ouvrant le dictionnaire, et créer un texte de quelques lignes contenant l’ensemble de ces mots au moins une fois.',
            'Pour que le défi soit réussi, votre texte doit bien sûr avoir du sens. Vous pouvez également vous lancer dans l’écriture d’une nouvelle, quel que soit le style, l’important étant la cohérence du texte et une chute inattendue. Soyez créatif !',
          ],
        },
        {
          title: 'Jouez et jouez encore pour développer votre créativité',
          description: [
            'Le jeu n’est pas réservé aux enfants et présente, chez les enfants comme chez les adultes, de nombreux intérêts, dont celui de développer la créativité. <br/><br/> L’amusement est un bon moyen de retrouver ce qui a été trop souvent enfoui par nos responsabilités d’adulte, comme la légèreté et la spontanéité. Souvent les jeux permettent d’oser faire des choses originales sans peur des conséquences, en faisant semblant. Se distraire est même essentiel à notre équilibre psychique et permet de conserver sa joie de vivre.',
            'Des jeux de société nous transportent parfois dans un univers différent, et nous plongent ainsi dans une démarche créative (jeux très immersifs comme <i>Assassin’s Creed Brotherhood of Venice, Agricola, Terraforming Mars,</i> etc.). D’autres jeux de société demandent d’inventer des histoires (<i>Speech, Il était une fois…</i>), des noms (<i>Krazy wordz</i>), des définitions (<i>Kemozako</i>), des représentations schématiques (<i>Imagine, Pix</i>), etc. Tous ces jeux favorisent la créativité. Choisissez ceux qui vous plaisent le plus (mécanique de jeu, niveau de difficulté, durée d’une partie…) et amusez-vous entre amis ou en famille ! <br/><br/> Le jeu de rôle est également recommandé pour développer sa créativité. Dans un jeu de rôle, vous interprétez un personnage de façon totalement improvisée, en laissant parler votre imagination, que ce soit autour d’une table ou lors d’un jeu de rôle grandeur nature. <br/><br/> D’autres activités de loisirs conviennent parfaitement. Ainsi l’improvisation théâtrale apprend à lâcher prise et fait appel à la créativité ! C’est le cas aussi du dessin, de la peinture, la sculpture, le bricolage, l’écriture…',
          ],
        },
        {
          title: 'Pensez à nourrir votre créativité',
          description: [
            'Pour vous enrichir de nouvelles idées et informations, lire régulièrement est indispensable. Diversifiez les sujets afin de développer plus facilement votre créativité. N’hésitez pas à aller vers des thèmes qui vous sont inconnus ou de la science-fiction.',
            'Pour nourrir votre imaginaire, vous pouvez également vous rendre dans des galeries d’art, des musées, assister à des conférences… Faites de nouvelles rencontres pour avoir des sujets de conversations différents. <br/><br/> Surtout, fuyez la routine !',
          ],
        },
      ],
      listEmploi1: [
        'Marketing,',
        'Arts & Spectacles,',
        'Architecture,',
        'Consulting,',
        'Entrepreneuriat',
      ],
    },
    {
      key: locale.entrepreneurialSpirit,
      value:
        resultToShow?.attributes?.entrepreneurial_spirit || resultToShow?.entrepreneurial_spirit,
      color: '#0079DE',
      img: 'carte_esprit_entreprendre.png',
      colorSecondary: '#FFAEC1',
      citation:
        '« Dites au monde ce que vous comptez faire, mais d’abord montrez-le. » <br/> <b>Napoléon Hill</b>',
      title: 'Comment développer votre esprit d’entreprendre ?',
      text1:
        'L’esprit d’entreprendre peut se définir comme étant une attitude pro-active orientée vers la défense des intérêts de l’organisation. L’esprit d’entreprendre se caractérise également par la capacité à agir sans rétribution immédiate. La personne investit du temps et de l’énergie afin d’acquérir de nouvelles compétences ou aptitudes dont elle sait qu’elles lui seront utiles dans la suite de sa carrière, sans toutefois avoir la certitude absolue de leur utilité. <br/> Avoir l’esprit d’entreprendre, c’est être prêt(e) à investir sans être certain(e) d’obtenir un retour sur investissement.',
      text2: [
        'L’esprit d’entreprendre se caractérise avant tout par la proactivité. Cette qualité peut se développer si on prend conscience de ce que cela signifie. Être proactif, c’est réaliser des actions par anticipation de ses besoins. La proactivité nécessite une réflexion en amont, puis un investissement en temps et en énergie. Pour cela, il faut savoir se projeter, mais aussi savoir prendre du recul sur ses propres compétences, connaître ses limites. Cela permet de reconnaître plus facilement des opportunités quand elles se présentent et les saisir. <br/><br/> Pour développer une attitude proactive, la première chose à faire est l’analyse de vos axes de développement possibles, à condition d’avoir des objectifs clairs et bien définis. Votre intelligence émotionnelle vous permettra de mieux analyser vos besoins et vos aspirations (voir Soft skill n°3). Demandez-vous alors quelles compétences pourraient vous servir dans votre vie professionnelle et votre vie personnelle. Cela peut concerner l’acquisition de nouvelles connaissances, d’une compétence technique (la maîtrise d’un logiciel par exemple) ou le développement d’un savoir-être (gestion de conflits par exemple). Le rythme d’une formation par an pour commencer constitue un bon début. Cultiver votre niveau d’anglais, ou vous perfectionner, fait aussi partie de l’esprit entrepreneurial. Vous pouvez par exemple écouter de temps en temps la BBC ou échanger en anglais à l’occasion de cafés des langues près de chez vous. <br/><br/> Cherchez également les conférences (en ligne ou proches de chez vous) en lien avec vos centres d’intérêt ou votre activité professionnelle, et notez les dates importantes sur votre agenda, afin de ne pas passer à côté d’une occasion de progresser. Afin de vous tenir informé des actualités de votre secteur professionnel, réservez-vous une heure par semaine pour sélectionner des articles sur Internet et les lire. Si vous avez un compte professionnel sur LinkedIn, des articles peuvent vous être suggérés.',
        'Pour élargir vos opportunités d’évolution, développez votre réseau professionnel. Au sein de réseaux sociaux en ligne, rejoignez des groupes proches de votre activité professionnelle ou votre projet professionnel. N’hésitez pas à échanger via des forums, lors de rencontres dans le cadre d’événements dédiés (apéritifs, déjeuners, etc.), ou dans des salons professionnels en lien avec votre domaine d’activité. <br/><br/> Pour développer l’esprit d’entreprendre, il faut donc être à la fois dynamique et ouvert d’esprit. Seules ces conditions permettent de saisir les opportunités qui s’offrent à vous. Il s’agit d’aller vers les autres, et de partager vos passions et ambitions. Le développement de votre esprit d’entreprendre vous poussera à agir sans peur, avec détermination. Vous vous surpasserez pour réussir, que ce soit sur le plan professionnel ou privé. <br/><br/> Une autre composante de l’esprit d’entreprendre est une certaine attitude face à la vie. Les personnes qui ont l’esprit d’entreprendre savent qu’on ne récolte pas les fruits de ses actions de façon immédiate. Elles savent donc « miser » et faire des paris sur elles et sur l’avenir. Cela se répercutera dans leur comportement professionnel. Ces personnes seront ainsi capables de faire des heures supplémentaires sans demander à être payées en retour ou s’investir dans des projets qui a priori n’ont pas un intérêt direct pour elles. <br/><br/> En faisant cela, elles développeront de nouvelles connaissances et de nouvelles compétences. Elles se créeront un réseau. Cet investissement, un jour ou l’autre, finira toujours par payer d’une manière ou d’une autre. Dans l’un de ses ouvrages célèbres, Philippe Gabilliet (2016) explique comment l’esprit d’entreprendre est à l’origine de ce que beaucoup appellent la chance. Pour Philippe Gabilliet, la chance n’a rien à voir avec la bonne fortune. Il s’agit plutôt d’une aptitude à se créer des opportunités et les saisir, ce que l’on pourrait résumer par l’esprit d’entreprendre.',
      ],
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [],
      listEmploi1: [
        'Entrepreneuriat,',
        'Direction générale,',
        'Management,',
        'Tous métiers dans : <br/> environnement Start-Up, <br/> environnement TPE',
      ],
      opacity: true,
      useGrid: true,
    },
    {
      key: locale.daring,
      value: resultToShow?.attributes?.daring || resultToShow?.daring,
      color: '#FEA33A',
      img: 'carte_audace.png',
      colorSecondary: '#9D6524',
      citation:
        '« Donnez un grain d’audace au timide, il deviendra roi. » <br/> <b>Proverbe japonais</b>',
      title: 'Comment développer votre audace ?',
      text1:
        'L’audace, c’est la capacité à « sortir du cadre » à la fois pour proposer de nouvelles solutions, mais aussi pour se mettre en avant et porter ses idées. L’audace, c’est la capacité à prendre des risques pour aller capter des opportunités difficiles à obtenir dans d’autres circonstances. <br/> L’audacieux(se) n’hésitera pas à se lancer dans des projets difficiles, à l’issue incertaine, mais qui à terme pourraient rapporter gros, à lui (elle) ou à son employeur. <br/> L’audace est donc une qualité essentielle pour gravir les échelons dans une organisation.',
      text2:
        'Pour vous entraîner à faire preuve de davantage d’audace, il existe quelques méthodes simples. Elles visent d’une part à capter l’attention d’autrui plus facilement et d’autre part à relever de nouveaux challenges.',
      titleAd: 'L’histoire des deux joueurs de tennis',
      descriptionAd:
        'Dans son livre, les vertus de l’échec, Charles Pépin raconte l’histoire d’un jeune Espagnol âgé de 13 ans qui vient de perdre en ½ finale d’un tournoi de tennis, face au prodige français de l’époque, âgé de 13 ans également, Richard Gasquet. Richard Gasquet est alors vu comme « le petit Mozart du tennis français », car tout lui réussit. Il domine tous ses adversaires.<br/><br/> Il semble évident à tous les commentateurs qu’il va devenir un grand champion. Une personne qui réussit doit logiquement continuer à réussir. Le jeune Espagnol a fait quant à lui l’expérience de nombreux échecs. Malgré ses défaites répétées, il continue d’aller de l’avant, de travailler ses faiblesses, de progresser. Et il doit travailler très dur pour cela.<br/><br/> Ce match précis, qui se solde par une nouvelle défaite, sera décrit plus tard par le jeune Espagnol comme le point de départ de sa réussite future. Ce jeune Espagnol qui vient de perdre s’appelle Rafael Nadal. L’histoire montrera que c’est lui, et non Gasquet, qui deviendra un grand champion, en devenant n°1 mondial et en remportant plusieurs fois Roland-Garros. <br/><br/> Pour Charles Pépin, il faut se hâter d’aller chercher l’échec, car celui-ci nous prépare toujours à une réussite future. Bien sûr, il faut réussir aussi parfois, mais c’est en allant chercher ses limites, qu’on les découvre. Chaque échec est un précieux enseignement. Il ne faut donc pas le craindre, mais essayer de s’en approcher. Un échec a toujours quelque chose à dire…',
      listeAccordeon: [
        {
          title: 'Commencez par essayer de capter l’attention d’autrui',
          description: [
            'Pour capter l’attention, essayez tout d’abord, lors de la prochaine réunion (travail et/ou famille) de prendre la parole et de proposer une idée. Puis réitérez l’exercice dès que l’occasion se présente. <br/><br/> Vous pouvez également appeler une émission radio pour participer à un jeu en direct ou encore, de temps en temps, faire une blague ou deux devant quelques collègues pendant la pause, ou avec des proches. Le tout est de vous mettre en avant, de vous faire entendre.',
            'Pour aller plus loin dans l’audace, mettez-vous au défi de porter un toast. Les occasions sont multiples : anniversaire, mariage, crémaillère… Levez-vous, remerciez les personnes présentes, dites le nom de la personne pour qui vous levez votre verre et pourquoi, puis invitez tout le monde à lever son verre à son tour. <br/><br/> Un autre moyen de capter l’attention est d’applaudir dans une salle de cinéma, à l’apparition du générique de fin, si vous avez apprécié le film. Vous faites connaître ainsi votre avis positif à tous.',
          ],
        },
        {
          title: 'Tentez de relever de nouveaux challenges',
          description: [
            'Pour développer votre audace, il est essentiel de relever de nouveaux challenges. Cela peut être de porter une couleur que vous ne portez jamais, ou d’oser ouvertement faire preuve d’excentricité… Le tout est d’oser quelque chose de différent. <br/><br/> Si vous sentez que vous êtes à l’aise dans les exercices précédents, vous pouvez tenter des défis plus difficiles. Et si vous vous invitiez à une soirée ! Un soir, vous entendez de la musique chez des voisins qui reçoivent des convives.',
            'Le challenge consiste à aller sonner chez eux, et expliquer que vous avez envie de faire la fête vous aussi, mais que vos amis ne sont pas disponibles. Arrivez avec une bouteille de vin ou des chocolats, cela peut aider ! <br/><br/> Repoussez vos propres limites, acceptez de vous lancer dans des défis qui vous feront sortir de votre zone de confort…',
          ],
        },
        {
          title: 'Allez chercher l’échec',
          description: [
            'Le principe des audacieux est qu’ils vont dépasser leurs limites jusqu’à trouver l’échec. La plupart des gens cherchent uniquement à réussir. Ils ont peur d’échouer. Mais l’échec aussi possède certaines vertus. Charles Pépin a écrit un livre où il développe le principe consistant à chercher l’échec. <br/> Si vous vous lancez dans un challenge et que vous allez au bout de vos idées jusqu’à trouver l’échec, alors vous allez connaître vos limites et vous allez découvrir de nouvelles idées, de nouveaux enseignements qui vous serviront à réussir plus tard. <br/><br/> Si vous avez déjà fait du catamaran, c’est ce qui se passe lorsque vous allez trouver la limite de la résistance du bateau face au vent. À un moment donné, vous allez chavirer parce que vous serez allé au-delà de cette limite… Mais, en plus de prendre un bon bain, vous aurez appris à reconnaître les signes d’un bateau qui chavire. Vous connaîtrez toute la puissance de votre bateau et aurez découvert sa vitesse maximum. Vous aurez aussi compris comment vous réagissez dans cette situation. Vous pourrez corriger vos comportements et les réglages, et la prochaine fois sera meilleure.',
            '',
          ],
        },
      ],
      listEmploi1: [
        'Entrepreneuriat,',
        'Service commercial,',
        'R&D, innovation,',
        'Marketing,',
        'Communication,',
        'Journalisme',
      ],
    },
    {
      key: locale.motivation,
      value: resultToShow?.attributes?.motivation || resultToShow?.motivation,
      color: '#E335BE',
      img: 'carte_motivation.png',
      colorSecondary: '#FF95E3',
      citation:
        '« Le succès c’est d’aller d’échec en échec sans perdre son enthousiasme. » <br/> <b>Winston Churchill</b>',
      title: 'Comment développer votre motivation ?',
      text1:
        'La motivation est la capacité à trouver ou produire la quantité d’énergie nécessaire à la mise en œuvre d’une action. <br/> La motivation est un processus essentiellement interne car elle repose sur une représentation de la situation et cette représentation peut être modifiée. Idem pour les gens qui nous entourent. Les encouragements, la reconnaissance, l’esprit d’équipe, l’émulation sont autant de moyens de créer de la motivation. Les personnes qui sont motivées et qui savent insuffler de la motivation autour d’elles sont les leaders de l’organisation.',
      text2:
        'Pour vous entraîner à faire preuve de davantage d’audace, il existe quelques méthodes simples. Elles visent d’une part à capter l’attention d’autrui plus facilement et d’autre part à relever de nouveaux challenges.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Luttez contre la procrastination et augmentez votre niveau de motivation',
          description: [
            'La procrastination est une tendance à remettre systématiquement une action à plus tard. Cette attitude entraîne du retard dans les tâches à accomplir, mais aussi un jugement social, voire une stigmatisation, liée au regard des autres. Le procrastinateur a du mal à se mettre au travail, à commencer une activité… À la place, il fera tout autre chose, tout sauf la tâche qui le bloque ou ne lui procure pas de plaisir. Au lieu de s’en débarrasser le plus rapidement possible, un procrastinateur reporte sans cesse des actions pourtant prioritaires, pour faire des activités de moindre importance à la place. Une des causes de la procrastination est le manque d’estime de soi. L’incertitude quant à ses capacités face à une situation constitue dans ce cas-là un obstacle à l’action. La procrastination peut être également due à un manque de concentration et/ou un manque de motivation. Trois points se révèlent donc primordiaux pour lutter contre la procrastination : stimuler votre confiance en vous (voir <i>Soft skill n°2</i>), ne pas vous disperser (voir <i>Soft skill n°13</i>) et rester motivé. <br/><br/> Pour rester motivé, certains outils sont incontournables. Il faut commencer par définir clairement ses objectifs. Cela donne une direction. L’objectif rend enthousiaste à l’idée de progresser dans la réalisation d’une action. Cela déclenche une image mentale motivante pour aller de l’avant. Si vous ressentez que votre motivation diminue à faire une action donnée, visualisez son objectif final, c’est-à-dire un objectif plus large. Cela redonnera du sens aux étapes intermédiaires nécessaires. Établissez vos objectifs en tenant compte bien sûr de vos forces et de vos ressources. Si l’objectif dépasse vos capacités, il vous sera impossible d’être motivé à l’atteindre, et cela engendrera un stress inutile. À l’inverse, la motivation augmente quand on atteint ses objectifs : c’est la gratification personnelle. <br/><br/> Une situation peut vous bloquer totalement. Par exemple, vous ne parvenez pas à prendre une décision. Plutôt que de tourner en rond, il peut être salvateur de faire une pause. Pour rompre une boucle de pensée négative qui vous empêche d’avancer, vous pouvez sortir vous balader, vous préparer votre déjeuner, etc.',
            'Là, la procrastination est volontaire, et bénéfique si elle est contrôlée. Accordez-vous une distraction d’une demi-heure au maximum. Votre état d’esprit aura changé à votre retour, et votre motivation sera stimulée. Vous serez également plus détendu, c’est plus facile de trouver des solutions dans ces conditions. Et n’ayez pas peur de commettre des erreurs. Se motiver, c’est vouloir se surpasser, célébrer ses victoires, mais aussi accepter ses propres erreurs. Faire des erreurs permet d’apprendre et évoluer. Les erreurs ne doivent pas être une source de découragement, mais d’amélioration. <br/><br/> Votre espace professionnel représente un point important dans la représentation que vous vous faites de votre travail. Optimisez donc la place, la luminosité… Cela stimulera votre motivation. Recherchez des images inspirantes pour vous, source de motivation, et créez un tableau personnel en agençant ces différentes images. Posez ce tableau sur votre bureau et chez vous, de façon à ce qu’il vous accompagne tous les jours et vous redonne de l’énergie. <br/><br/> N’hésitez pas également à échanger avec des personnes qui ont atteint leurs objectifs et qui vous inspirent. C’est toujours particulièrement stimulant. Élargir son réseau professionnel et personnel représente un excellent moyen de se motiver. En outre, s’entourer de personnes positives apporte davantage de sérénité. Au sein des réseaux sociaux en ligne, vous pouvez ainsi rejoindre des groupes proches de votre projet ou activité professionnelle. Demandez à être connecté avec de nouvelles personnes que vous avez identifiées comme inspirantes. Faites systématiquement un message personnalisé court pour vous présenter. Rebondissez sur une publication où vous avez interagi ou un centre d’intérêt commun, et proposez un échange, ou une rencontre autour d’un café par exemple. Vous serez surpris de voir que c’est souvent accepté. Les conférences ou événements liés à votre projet ou activité représentent un autre moyen de rencontrer des personnes d’intérêt. Le cadre privé permet aussi de parler avec de nouvelles personnes : mariage, anniversaire, sortie, rencontre sportive… Soyez à l’écoute, et ne passez pas à côté d’une personne qui peut contribuer à développer votre motivation, par son soutien et l’image positive qu’elle vous renvoie.',
          ],
        },
        {
          title: 'Motivez d’autres personnes, transmettez votre énergie',
          description: [
            'Pour motiver d’autres personnes, il est important de définir clairement les missions de chacun et les objectifs, répartir les tâches de façon équitable, valoriser les compétences individuelles et reconnaître le travail accompli. Cela s’applique à tous les contextes : équipe de sport, équipe de travail, partenaires dans un jeu collaboratif, travaux en famille à la maison… <br/><br/> Pour motiver les personnes qui vous entourent, vous devez être en mesure de citer au moins un point fort pour chaque individu. Prenez du recul et analysez les qualités de chacun. Cela vous aidera forcément à leur transmettre de l’énergie. Montrer tout simplement du respect à ces personnes vous permet aussi de les motiver plus facilement. La politesse reste essentielle : dire bonjour le matin, ne jamais couper la parole… Cela passe aussi par des encouragements, des remerciements et/ou des compliments le cas échéant. Ces mots font toujours du bien aux destinataires.',
            'Pour maintenir une motivation optimale au travail, lorsque vous devez faire un retour négatif sur une tâche, ne condamnez pas votre collaborateur, et, surtout, ne le rabaissez pas. Vous devez expliquer les choses qui ne vont pas et recueillir son avis. Indiquez-lui des possibilités pour résoudre le problème. Vous vous montrez ainsi disponible dans les moments difficiles, ce qui est très efficace pour mener à bien des objectifs. <br/><br/> Enfin, sachez vous remettre en question et soyez conscient de vos forces et de vos limites. Montrez que vous cherchez à vous améliorer, en suivant des formations par exemple. Vous devez être une source d’inspiration pour vos collaborateurs, les influencer de façon positive. Cela développera à la fois votre propre motivation et votre faculté à transmettre votre énergie.',
          ],
        },
      ],
      listEmploi1: [
        'Entrepreneuriat,',
        'Direction générale,',
        'Management,',
        'Conduite de projets,',
        'Enseignement,',
        'Formation & insertion',
      ],
      opacity: 'true',
    },
    {
      key: locale.vision,
      value: resultToShow?.attributes?.vision || resultToShow?.vision,
      color: '#A9B0FB',
      img: 'carte_vision.png',
      colorSecondary: '#5C619D',
      citation:
        '« Plus on prend de la hauteur et plus on voit loin. » <br/> <b>Proverbe chinois</b>',
      title: 'Comment développer une meilleure vision ?',
      text1:
        'La vision peut se définir comme la capacité à prendre de la hauteur par rapport à une situation donnée. Il s’agit de la faculté à « zoomer » pour voir les problèmes en détail pour ensuite « dézoomer » et observer les choses au sein d’un ensemble beaucoup plus large. Cette capacité de « zoom-dézoom » permet à la fois d’être efficace et performant(e) dans le détail et d’être efficace et performant(e) pour gérer des situations plus globales, sans s’arrêter sur des problèmes mineurs et acquérir une vision stratégique.',
      text2:
        'Le sens de l’observation peut être facilement amélioré grâce à des jeux et des challenges ludiques. Pour développer une meilleure vision, il faut également apprendre à voir le monde qui nous entoure sous un angle différent, donc développer sa plasticité cérébrale.',
      titleAd: 'Exercice d’observation « Où est le Panda ?* »',
      descriptionAd:
        '<i>**Rendez-vous en bas de cette page pour voir la réponse, si vous ne trouvez pas le panda !</i>',
      imgAd: 'bonhommes_neige.png',
      listeAccordeon: [
        {
          title: 'Entraînez-vous à devenir un fin observateur',
          description: [
            'Vous trouverez facilement dans des magazines ou sur Internet des jeux d’observation à partir d’une image. Il s’agit de retrouver Charlie, ou plusieurs personnages cachés, ou dix erreurs… Des jeux d’observation à partir d’un texte entraîneront votre vision d’une façon différente. L’objectif peut être de retrouver un message caché (en prenant un mot par ligne par exemple), ou de retrouver des fautes dans le texte…',
            'Il existe également des jeux de société basés sur l’observation de cartes. Ces jeux conviennent à la fois aux enfants et aux adultes. Vous pouvez donc jouer en famille. Dans le Dobble par exemple, il faut retrouver deux objets en commun entre deux cartes avant vos adversaires. Dans Twin it, vous devez réunir deux cartes aux motifs strictement identiques, là aussi le plus rapidement possible. <br/><br/> Dans d’autres jeux, c’est l’observation attentive des comportements autour de vous qui est requise. Vous avez peut-être déjà joué étant plus jeune à un jeu de cartes en binôme appelé Kems. Dans ce jeu, vous devez, tout en essayant de réunir quatre cartes de valeur identique, repérer si un autre binôme n’a pas déjà réussi, et identifier leur signe. Ce jeu vous entraîne à observer le comportement des autres joueurs. C’est aussi essentiel dans le jeu Wink, où l’on communique avec son binôme en lui faisant un clin d’œil. <br/><br/> Pour améliorer votre vision, vous devez également vous entraîner à observer votre environnement. Pour occuper les enfants pendant les longs trajets en voiture, on leur propose parfois le jeu suivant : être le premier à voir une voiture jaune, une vache, le clocher d’une église… Donnez-vous ce genre de challenges en solo en allant travailler le matin : voir cinq personnes qui portent des lunettes, voir cinq sacs rouges… <br/><br/> Quand vous partez en vacances, prenez le temps de vous poser à un moment de la journée et notez sur un carnet de voyage ou un journal de bord ce que vous observez autour de vous. Vous êtes libre d’écrire ce que vous voulez : ce que les gens mangent, comment ils sont habillés, le nombre d’oiseaux dans le ciel, les sons… Cette habitude à prendre renforcera vos talents d’observateur. <br/><br/> <i>*Librement inspiré du visuel de Gergely Dudás – Dudolf **Réponse : À droite, dans la 7e rangée en partant du bas.<i>',
          ],
        },
        {
          title: 'Changez votre regard sur les gens et sur les choses',
          description: [
            'Plusieurs méthodes existent pour s’entraîner à changer son regard. Vous pouvez par exemple en découvrant un nouveau bâtiment essayer de trouver les éléments communs avec d’autres que vous connaissez bien, plutôt que de ne voir que la nouveauté. Alternez avec l’exercice inverse qui consiste à distinguer des éléments nouveaux quand vous passerez devant un bâtiment que vous avez déjà vu. Observez-le dans sa globalité et plus en détail. Vous pourriez être surpris de découvrir tout ce que vous n’aviez jamais remarqué jusqu’alors ! Prenez le temps d’observer le monde qui vous entoure sous un angle différent. <br/><br/> Certains loisirs sont également indiqués pour améliorer votre vision. Ainsi un stage d’initiation à la photographie vous apprendra à cadrer, à observer pour trouver la meilleure perspective, à prendre le temps de vous placer… Un bon photographe, par sa vision développée, sait en outre capter l’instant unique quand il s’agit d’un portrait, d’un sujet en mouvement ou d’une scène d’action. Et il n’est jamais trop tard non plus pour apprendre à observer le ciel. À la nuit tombée, essayez de distinguer par exemple la Grande Ourse ou Vénus (appelée aussi étoile du Berger). La peinture et la décoration font aussi appel au sens de l’observation. Ces activités artistiques invitent à remarquer l’impact de la lumière, les différentes teintes… <br/><br/> Pour développer une vision plus globale des choses, amusez-vous à essayer de prédire l’avenir. Demandez-vous ce que va devenir tel ou tel quartier de votre ville, qui sera élu aux prochaines élections, quels seront les choix de carrière d’un collègue, etc.',
            'Essayez d’anticiper l’avenir est une manière de développer sa profondeur de vision. Cela permet d’essayer de voir plus loin que les apparences. <br/><br/> Apprenez également à prendre de la hauteur et à relativiser. Pour cela, l’histoire, ou l’anthropologie, peuvent être très intéressantes. Lire des romans historiques permet de voir comment d’autres personnes vivaient à une époque différente. L’anthropologie permet de savoir comment d’autres peuples vivent. Cela permet de changer son regard sur les choses. <br/><br/> Le documentaire Exploration inversée qui met en scène deux Papous visitant la France est particulièrement inspirant et permet de revisiter les habitudes nationales grâce à des yeux nouveaux. <br/><br/> Intéressez-vous à toutes les personnes qui ont des opinions atypiques sur le fonctionnement de la société ou des choses. L’opinion de ces personnes vous permettra d’enrichir votre vision et de prendre l’habitude de questionner ce que vous considérez comme étant la vérité. Enfin, vous pouvez lire des ouvrages d’anticipation ou de science-fiction.',
          ],
        },
      ],
      listEmploi1: [
        'Direction générale,',
        'Management,',
        'Consulting,',
        'Recherche,',
        'Métiers de la politique,',
        'Journalisme',
      ],
    },
    {
      key: locale.presence,
      value: resultToShow?.attributes?.presence || resultToShow?.presence,
      color: '#FF6F49',
      img: 'carte_presence.png',
      colorSecondary: '#FFB3A0',
      citation:
        '« Ne demeure pas dans le passé, ne rêve pas du futur, concentre ton esprit sur le moment présent. » <br/> <b>Bouddha</b>',
      title: 'Comment développer votre présence ?',
      text1:
        'La présence peut se définir comme la capacité à être présent(e) physiquement et mentalement dans son activité. Il s’agit d’une capacité de concentration et de focalisation. Nombreuses sont les occasions d’être diverti(e) lorsque l’on travaille. On peut être accaparé(e) par des difficultés personnelles, des envies, des désirs ou des frustrations. La présence est la capacité à « être là », à pouvoir travailler tout en étant à 100% concentré(e) sur son travail et ses objectifs. Cette concentration permet d’atteindre un haut niveau d’efficacité et de performance.',
      text2:
        'Pour développer votre présence, certaines activités sont recommandées, ainsi que des exercices de visualisation en pleine conscience et/ou de méditation.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Pratiquez des activités qui améliorent votre concentration',
          description: [
            'La pratique d’une activité manuelle vous oblige à rester focalisé sur votre tâche. Cela permet de vous recentrer. Vous avez plusieurs possibilités, en fonction de vos goûts : dessin, peinture, poterie, tricot, etc. <br/><br/> Le jardinage est un bon choix, car la reconnexion avec la nature représente un bénéfice supplémentaire. Si vous n’avez pas de jardin chez vous, sachez qu’il existe de plus en plus de jardins collectifs. Des particuliers proposent également d’entretenir leur jardin paysager et d’en profiter gratuitement quelques jours par mois en échange, ou d’entretenir leur jardin potager et de partager la récolte. <br/><br/> Certains sports sont également adaptés pour améliorer sa concentration, avec en tête de liste le yoga. Très éloigné du yoga en apparence, <i>l’aquabike</i> consiste à faire du vélo dans une piscine. En plus d’un renforcement musculaire et d’un travail cardiovasculaire efficace, cette activité ludique vous permet aussi de vous recentrer sur votre corps et les exercices à faire. Le Swiss Ball, un gros ballon souple, est un outil de fitness qui permet notamment d’améliorer la posture et de renforcer les muscles abdominaux et dorsaux. L’instabilité du ballon oblige en outre à rester concentré pour garder l’équilibre, ce qui développe l’ancrage dans le moment présent.',
            'De façon générale, les sports demandant de l’équilibre (<i>slackline, paddle</i>, escalade, gymnastique, etc.) ou de l’adresse (golf, tir à l’arc, billard, etc.) exigent de la concentration pour progresser. Ces sports sont donc également recommandés. La danse de salon représente aussi un excellent exercice. En effet, pour rester dans le rythme et suivre votre partenaire, mieux vaut être concentré. Choisissez le rythme qui vous plaît le plus : salsa, bachata, rock… <br/><br/> Si vous aimez les jeux vidéo, sachez que certains nécessitent une intense concentration pour être réactif et pouvoir franchir le plus de paliers possible. C’est le moment de tester vos réflexes !<br/><br/> Regarder des films en VO est également un moyen de développer votre niveau de concentration. Prenons le cas où l’anglais est la langue étrangère que vous maîtrisez le mieux. Vous devez quand même rester suffisamment concentré pour comprendre des films américains en VO et les apprécier. Pour développer encore davantage votre présence, regardez-les avec les sous-titres en anglais (au lieu des sous-titres en français), voire sans sous-titres, en fonction de votre niveau de langue.',
          ],
        },
        {
          title:
            'Réalisez des exercices de visualisation en pleine conscience pour vous entraîner à vous focaliser',
          description: [
            'Les exercices de visualisation en pleine conscience vous apprennent à vous focaliser sur vos ressentis. Ces exercices mobilisent vos cinq sens et votre mémoire. Le premier consiste à regarder une image que vous aimez puis à fermer les yeux. Vous devez alors vous représenter mentalement cette image : formes, couleurs… Écoutez également une musique, puis retrouvez l’air et les paroles dans le silence. Faites de même avec un parfum : sentez-le puis éloignez-vous et essayez de vous rappeler l’odeur.',
            'Mangez un aliment en vous concentrant sur les goûts et les sensations puis retrouvez-les mentalement. Enfin, les yeux fermés, touchez différentes matières : cuir, verre, bois… Puis concentrez-vous et retrouvez mentalement les sensations que vous avez éprouvées au contact de ces matériaux. <br/><br/> En variant ces exercices et en pratiquant régulièrement, vous développerez votre capacité à vous focaliser sur votre activité.',
          ],
        },
        {
          title: 'Pratiquez la méditation',
          description: [
            'La méditation permet d’apprendre à focaliser son attention sur un point précis le plus longtemps possible et développe ainsi l’ancrage dans le présent. Il s’agit de se concentrer sur sa respiration. Le principe est de diriger votre esprit vers une idée unique, sans jamais dériver. Durant votre séance de méditation, si vous vous éloignez de votre point de focalisation, revenez-y systématiquement. Ne laissez aucun répit à votre esprit. Ne luttez pas contre le flot de pensées qui surgit, mais recentrez-vous sur votre respiration. Vous pouvez également utiliser un mantra pour ne pas vous laisser submerger, ou pratiquer la méditation en pleine conscience, c’est-à-dire laisser venir vos sensations et pensées et les observer avec détachement, sans jugement.',
            'Après un certain entraînement, vous serez ainsi en mesure de vous observer en train de penser. La pratique de la méditation exige de la persévérance et de la patience. Notre esprit n’est pas toujours enclin à se concentrer, mais l’instauration d’une routine est nécessaire : pratiquer quotidiennement avant de commencer sa journée par exemple. Avec le temps, la durée de la méditation s’allonge naturellement. Ne vous imposez pas plus de dix minutes au début. Il ne faut pas aller trop vite, pour ne pas générer un blocage. La méditation améliore la capacité à se concentrer. Elle transforme également notre rapport à nos problèmes, en facilitant l’acceptation et le lâcher-prise. La position assise en tailleur est conseillée, de préférence pieds nus, et en gardant le dos bien droit, les yeux fermés ou à demi clos.',
          ],
        },
      ],
      listEmploi1: [
        'Métiers répétitifs,',
        'Transports,',
        ' Métiers de la sécurité,',
        'Santé,',
        'Psychologie,',
        'Management',
      ],
      opacity: 'true',
    },
    {
      key: locale.collectiveSense,
      value: resultToShow?.attributes?.collective_sense || resultToShow?.collective_sense,
      color: '#000C7D',
      img: 'carte_sens_du_collectif.png',
      colorSecondary: '#7F86C2',
      citation:
        '« On a intérêt au bonheur des autres, on a intérêt à ce que les autres ne soient pas malades, on a intérêt au succès des autres parce que nous sommes une équipe collective. » <br/> <b>Jacques Attali</b>',
      title: 'Comment développer votre sens du collectif ?',
      text1:
        'Le sens du collectif est la capacité à considérer son travail comme une contribution à un ensemble plus vaste et plus important que constitue une équipe. Avoir le sens du collectif, c’est être capable de se substituer aux autres quand ils sont défaillants pour assurer la réussite de l’ensemble. <br/> C’est agir en mettant en avant l’intérêt collectif devant son intérêt personnel et cela touche à des sujets aussi sensibles que l’avancement de la carrière ou de la rémunération. <br/> Chacun contribue à un ensemble en équilibre.',
      text2:
        'Pour développer son sens du collectif, il faut avant tout se montrer solidaire et prêt à aider les autres, vous intéresser à eux, les écouter.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Mettez tous les moyens de votre côté pour pouvoir aider les autres',
          description: [
            'Votre sens de l’écoute et votre sens de l’observation sont vos meilleurs alliés pour vous donner les moyens d’aider les autres : repérer les difficultés de certaines personnes, comprendre comment vous pourriez intervenir… <br/><br/> Au cas où l’aide à apporter consiste à donner les premiers secours, que ce soit dans le cadre professionnel ou privé, il est très intéressant de passer et d’obtenir le brevet de secouriste. Cela vous rendra plus confiant lors d’une éventuelle intervention et vous incitera à proposer votre aide.',
            'Si vous travaillez, vous pouvez suivre la formation pour devenir sauveteur secouriste du travail (SST) dans le cadre de la formation continue. Le certificat délivré (à condition de réussir vos évaluations) donne l’équivalence au brevet de secouriste, appelé aujourd’hui PSC 1 (prévention et secours civiques de niveau 1).',
          ],
        },
        {
          title: 'Donnez du temps pour les autres',
          description: [
            'Plusieurs moyens sont à votre disposition pour donner de votre temps pour les autres. L’investissement peut être parfois très limité, et avoir pourtant des effets particulièrement positifs sur votre entourage. Prenons le cas de votre lieu d’habitation et l’ensemble de vos voisins. Afin de créer du lien social entre vos voisins, une bonne méthode consiste à organiser un repas partagé. Affichez une feuille avec la date, l’heure et le lieu de l’événement. Cela peut être dans la cour de votre immeuble ou dans un jardin public proche de votre rue. Pour avoir plus de succès, votre prospectus doit de préférence inviter les personnes intéressées à s’inscrire en indiquant leur nom et ce qu’ils pensent apporter (boissons, dessert, tarte salée…). Une fois les premières personnes inscrites, c’est l’effet boule de neige, et les résidents plus méfiants se laissent tenter. Les bénéfices de ce style d’événement sont multiples, notamment : faire connaissance, encourager l’entraide entre voisins, créer un climat de confiance et de bon voisinage. <br/><br/> Pour développer votre sens du collectif, vous pouvez également favoriser d’autres rencontres entre des personnes, pour leur intérêt, qu’il soit d’ordre professionnel ou privé. Il peut s’agir de recommander un professionnel à un potentiel recruteur, de présenter l’un à l’autre deux célibataires en recherche de l’âme sœur…',
            'Le sens du collectif s’entretient aussi en soutenant une cause qui vous est chère : égalité des sexes, protection de l’environnement, défense des animaux… Vous pouvez apporter votre soutien de différentes façons : participer à une manifestation pacifique, signer une pétition, partager votre opinion sur les réseaux sociaux… Si vous souhaitez donner davantage de temps et d’énergie, vous pouvez développer votre sens du collectif en vous impliquant dans une association. Il peut s’agir d’une association de loisirs dont vous êtes adhérent (sport, jeux…) ou d’une association d’utilité publique. Dans les deux cas, vous pouvez devenir bénévole, et ainsi participer à des actions spécifiques et/ou faire partie du bureau (rôle de trésorier…). <br/><br/> Si vous avez entre 18 et 70 ans et pesez plus de 50 kg, vous pouvez vous proposer pour donner votre sang. Un entretien préalable validera votre aptitude ou pas. Cet acte généreux et solidaire permet de sauver des vies.',
          ],
        },
        {
          title: 'Donnez de l’argent',
          description: [
            'Le soutien d’une cause peut être également financier, que ce soit régulier ou ponctuel. Vous avez aussi la possibilité d’ouvrir une cagnotte en ligne pour une cause qui a de l’importance à vos yeux, et de partager cette initiative sur les réseaux sociaux.',
            'C’est une façon efficace de donner davantage de moyens à une association. Les dons sont sécurisés, et anonymes si les contributeurs le souhaitent.',
          ],
        },
      ],
      listEmploi1: [
        'Industrie,',
        'Bâtiment,',
        'Commerce,',
        'Administratif,',
        'Enseignement,',
        'Santé',
      ],
      opacity: 'true',
    },
    {
      key: locale.curiousity,
      value: resultToShow?.attributes?.curiousity || resultToShow?.curiousity,
      color: '#EC343A',
      img: 'carte_curiosite.png',
      colorSecondary: '#FF949B',
      citation: '« On ne force pas une curiosité, on l’éveille. » <br/> <b>Daniel Pennac</b>',
      title: 'Comment éveiller votre curiosité ?',
      text1:
        'La curiosité permet d’apprendre de nouvelles choses, mais aussi d’apprendre des autres et de soi. La curiosité, c’est l’art de s’intéresser à ce qui se passe en soi et autour de soi. <br/> Cet intérêt crée du lien avec de nouvelles connaissances et de nouvelles personnes. La curiosité est ce qui permet donc dans l’organisation de contribuer à une compétence globale par la connaissance respective des individus entre eux, de leurs problématiques, de leurs besoins etc. <br/> La curiosité se caractérise par une connaissance des enjeux de chacun.',
      text2:
        'La curiosité existe chez chacun d’entre nous, et s’exprime pleinement durant l’enfance. L’enfant aime découvrir, explorer, poser des questions… Malheureusement, avec l’âge, la curiosité s’estompe, voire s’endort profondément. En effet, consciemment ou inconsciemment, certains se disent qu’ils connaissent déjà tout et d’autres qu’ils n’ont pas besoin d’en savoir davantage ou de connaître autre chose. Or, comme vu précédemment, la curiosité, loin d’être un défaut, constitue un vrai allié pour s’épanouir dans la vie. Bonne nouvelle, de nombreux moyens permettent d’éveiller sa curiosité et de s’émerveiller de nouveau !.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title: 'Apprenez à mieux vous connaître et à mieux connaître les autres',
          description: [
            'La curiosité inclut le fait d’apprendre à bien se connaître soi-même. Pour mieux vous connaître, évaluer vos soft skills constitue un bon début. Le test Harmony proposé par Orient’Action® est à votre disposition en ligne pour cela. <br/><br/> Des jeux favorisent également la connaissance de soi. Ainsi le portrait chinois est un moyen ludique de mettre en évidence certains aspects de sa personnalité, ses goûts et préférences, à l’aide d’un questionnaire, inspiré de celui créé par l’écrivain Marcel Proust à la fin du XIXe siècle : « Le principal trait de mon caractère ? La qualité que je préfère chez un homme ?… ».',
            'Les questionnaires d’un portrait chinois sont néanmoins formulés différemment, car basés sur l’analogie entre vous-même et un objet, un élément, une personne… Cela donne des phrases à compléter du type : « Si j’étais un animal, je serais… Si j’étais un plat, je serais… Si j’étais un chanteur, je serais…». N’hésitez pas à répondre vous-même à l’un de ces questionnaires. <br/><br/> Certains jeux de société sont indiqués pour en apprendre davantage sur votre entourage : <i>Gift Trap, Compatibility, Sandwich…</i>',
          ],
        },
        {
          title: 'Intéressez-vous à votre environnement ',
          description: [
            'Pour développer sa curiosité, il faut aussi s’intéresser à son environnement. Intervenir ponctuellement ou régulièrement dans une association d’utilité publique représente un bon moyen de savoir ce qui se passe près de chez vous et d’apprendre des autres. Choisissez-en une pas trop loin de chez vous, et dont la raison d’être vous touche : banque alimentaire, maraudes auprès des sans-abris, lutte contre l’illettrisme, SPA (société protectrice des animaux)… <br/> Et proposez votre aide. <br/><br/> Afin de connaître les projets d’aménagement de votre quartier ou votre commune, vous pouvez par exemple assister à une réunion locale d’informations. Allez également au forum des associations (en septembre en général) pour découvrir ou mieux connaître les activités proposées près de chez vous. Ces habitudes à prendre développent la curiosité. <br/><br/> Il est parfois possible de participer à un projet artistique ou culturel, même si cela ne correspond pas à votre domaine professionnel.',
            'Des films ou des courts-métrages tournés dans votre région ou des spectacles basés sur une reconstitution historique (époque médiévale par exemple) peuvent avoir besoin de figurants… <br/><br/> Pour vous entraîner à développer votre curiosité, vous pouvez aussi vous intéresser à la nature autour de vous, par exemple en apprenant à reconnaître les oiseaux que vous voyez près de chez vous et éventuellement leur cri. Recherchez aussi le nom des arbres ou fleurs que vous croisez le plus souvent, et essayez de mémoriser leur parfum. <br/><br/> Ayez toujours un bloc-notes sur vous pour inscrire une idée ou une question que vous approfondirez plus tard. <br/> Cette attitude est extrêmement bénéfique pour développer votre curiosité.',
          ],
        },
        {
          title: 'Sortez des sentiers battus',
          description: [
            'Rencontres, lieux et expériences insolites sont des moyens complémentaires et indispensables pour développer votre curiosité. Ouvrez-vous à une culture différente en discutant avec un nomade lors d’un voyage, un chamane, une voyante… Vous pouvez aussi faire un stage dans un milieu professionnel méconnu de vous. <br/> Des professionnels passionnés sont souvent ravis de partager quelques jours avec un stagiaire et de l’initier à leur métier. Alors pourquoi pas une semaine dans une boulangerie ou avec des pompiers… <br/><br/> Tout au long de l’année, des organismes proposent des cours pour débutants, afin de tester une activité. C’est l’occasion pour ceux qui souhaitent développer leur curiosité d’aller vers l’inconnu, l’insolite : danses folkloriques, capoeira, <i>kin-ball</i>, pôle dance, tissu aérien… <br/><br/> Pour échanger votre maison ou votre appartement pendant les vacances, plusieurs sites Internet sécurisés existent. <br/> Ce type de séjour permet de découvrir une autre région ou un autre pays, mais aussi le lieu de vie d’une autre personne ou d’une autre famille. Cela constitue une expérience idéale pour élargir votre ouverture d’esprit.',
            'Pour développer votre curiosité, partez du principe que tout est intéressant, il faut juste prendre le temps de s’y intéresser. Évitez de jouer les blasés et de qualifier quelque chose d’ennuyeux d’emblée. Considérez au contraire que toute expérience représente une opportunité d’apprendre, et que vous pourriez passer à côté d’un monde passionnant si vous ne cherchez pas à en savoir plus. Pour réveiller votre curiosité, vous devez voir le fait d’apprendre comme quelque chose d’amusant. Retrouvez l’excitation de découvrir par vous-même de multiples univers (à travers des lectures, des conférences…), le plaisir d’être surpris, voire ébloui.',
          ],
        },
      ],
      listEmploi1: [
        'Architecture,',
        'Consulting,',
        'Entreprenariat,',
        'Marketing,',
        'Design,',
        'Arts et spectacles',
      ],
      opacity: 'true',
    },
    {
      key: locale.criticalMind,
      value: resultToShow?.attributes?.critical_mind || resultToShow?.critical_mind,
      color: '#F0CC42 ',
      img: 'carte_esprit_critique.png',
      colorSecondary: '#8D7725',
      citation:
        '« L’esprit de critique sert à s’enorgueillir ; l’esprit critique sert à s’élever. » <br/> <b>Corinne Ghiridlian-hofmann</b>',
      title: 'Comment développer votre esprit critique ?',
      text1:
        'L’esprit critique n’est pas un esprit qui s’exerce en permanence à critiquer et à dénigrer. L’esprit critique est la faculté à prendre du recul par rapport à ce qui se passe en nous et autour de nous, afin de distinguer le vrai du faux, l’éphémère du permanent, l’important du futile. Dans un monde saturé par le changement, les apparences et la contradiction, l’esprit critique permet de prendre le recul nécessaire et d’ainsi prendre les bonnes décisions sans se laisser dicter sa conduite par les cas particuliers. L’esprit critique permet de distinguer la vague de la mousse.',
      text2:
        'Pour développer son esprit critique, il faut apprendre à douter raisonnablement des informations qui nous arrivent, faire preuve de bon sens et être capable aussi de se remettre en question. Plusieurs habitudes à prendre permettent d’y parvenir.',
      titleAd: '',
      descriptionAd: '',
      listeAccordeon: [
        {
          title:
            'Maniez l’art du doute : cherchez à en savoir davantage, comparez, vérifiez, prenez du recul',
          description: [
            'Douter raisonnablement est la première attitude à adopter pour développer son esprit critique. Quand on vous fait une réponse qui vous paraît courte ou floue, vous devez demander à votre interlocuteur davantage d’informations. Cela vous permettra de mieux juger de la sincérité de ses propos. Maniez l’art du doute, en vous montrant simplement intéressé. <br/><br/> Comparer différentes propositions avant de prendre une décision représente également une bonne habitude à prendre. Ainsi, même si vous êtes séduit par la proposition d’un professionnel pour des travaux (réparation, rénovation, agrandissement…), demandez toujours deux devis ailleurs, afin de faire un choix avec le plus d’éléments possible. Avant de signer un contrat, il est rare que l’on en lise l’intégralité. C’est une des raisons pour lesquelles un délai de rétractation (sept jours minimum) existe.',
            'Pendant ce délai, relisez systématiquement les points primordiaux attentivement, afin de vérifier l’absence d’un risque important pour vous. <br/><br/> Nul besoin d’être journaliste pour vérifier ses sources. Quand vous lisez une information sur Internet, notamment sur les réseaux sociaux, prenez l’habitude de vérifier sa véracité. Les fausses informations sont malheureusement plus vite propagées que les vraies… <br/><br/> L’humour permet de prendre du recul sur une situation donnée. L’autodérision, en particulier, vous aidera à ne pas noircir le tableau, à relativiser, donc à développer votre esprit critique.',
          ],
        },
        {
          title: 'Faites preuve de bon sens, ne vous fiez pas aux apparences',
          description: [
            'Pour garder un esprit critique, il faut également savoir faire preuve de bon sens en toutes occasions. Des personnes sûres d’elles, et qui attirent les foules malgré des théories délirantes, peuvent nous induire en erreur. Rester rationnel évite de se laisser influencer et permet de redescendre rapidement sur terre. <br/><br/> Pour développer son sens critique, il faut en outre partir du principe que l’on ne peut pas donner un avis sur un lieu ou un événement sans l’avoir testé. Cela paraît évident, mais nous sommes pourtant nombreux à le faire sans même nous en rendre compte.',
            'Jugez donc toujours par vous-même et en connaissance de cause, ne vous fiez pas aux apparences ! Soyez objectif et ne construisez pas votre opinion sur l’image que vous pouvez avoir de quelque chose. Cela fonctionne aussi pour les personnes. Empêchez-vous par exemple de regarder d’une certaine façon les personnes qui conduisent une voiture haut de gamme ou au contraire qui ne vaut plus rien. Il n’est pas rationnel d’associer un véhicule donné à une certaine classe sociale. Une voiture de luxe n’est pas forcément signe de richesse : le propriétaire peut aussi avoir cumulé plusieurs emplois pour s’offrir son péché mignon…',
          ],
        },
        {
          title:
            'Soyez critique vis-à-vis de vous-même : remettez-vous en question, élargissez vos horizons',
          description: [
            'Pour être critique vis-à-vis de vous-même, vous devez accepter le fait que certaines choses que vous croyez sont peut-être fausses. Seule cette condition permet de se remettre en question et de changer d’avis, d’apprendre, d’évoluer dans le bon sens. Votre ignorance de certains éléments ou votre humeur du moment peuvent fausser votre jugement. Faites aussi l’effort d’avoir un esprit plus ouvert en vous confrontant à des situations que vous évitiez jusqu’à présent. <br/><br/> Dans le même ordre d’idée, pour développer son esprit critique, il faut éviter de faire des généralisations, de penser de manière binaire… Un très bon exercice pour cela consiste à jouer au « ni oui ni non ».',
            'Vous y avez peut-être joué quand vous étiez enfant : le premier qui dit oui ou non perd la partie. Pour rendre l’exercice plus intéressant, interdisez également les mots toujours et jamais, et entraînez-vous à répondre de la manière suivante : « c’est vrai si… » ou « uniquement à condition de… ». <br/><br/> Essayez d’élargir vos horizons en pratiquant de nouvelles activités, en découvrant de nouveaux lieux, en rencontrant de nouvelles personnes. Plus vous multipliez vos expériences de vie, plus vous développez votre esprit critique. Voyager permet de vous ouvrir encore davantage, en particulier si votre destination vous invite à découvrir une autre façon de vivre, une autre culture.',
          ],
        },
      ],
      listEmploi1: [
        'Police et justice,',
        'Communication,',
        'R&D,',
        'Métiers de la politique,',
        'Journalisme,',
        'Management',
      ],
    },
  ].sort((a, b) => b.value - a.value);
};
export const dataPreference: any = {
  social: {
    color: '#A9B0FB',
    secondColor: '#5C619D',
    interaction_social: {
      img: 'page_interaction.png',
      text1:
        'Vous avez une préférence pour l’« Interaction ». Cela signifie que vous êtes heureux et performant quand vous êtes en relation et interagissez avec une multitude de personnes. <br/> Vous puisez votre énergie dans les relations avec les autres. Vous en avez besoin pour être créatif, motivé, performant. <br/> Si les arbres ont besoin de soleil pour grandir, vous avez besoin de relations pour vous épanouir.',
      text2:
        'Vous préférez les personnes ouvertes et spontanées avec qui vous pouvez discuter, négocier, rire, etc. Pour vous, être en relation (même avec des inconnu(e)s est presque toujours un plaisir !',
      list1: [
        'Sortir dans des lieux où « ça bouge », où « il y a du monde »,',
        'Aller à des concerts, danser, faire des blagues, inviter et être invité(e) à dîner chez des ami(e)s ou à des évènements,',
        'Rencontrer de nouvelles personnes !',
      ],
      list2: [
        'La solitude et les environnements trop calmes.',
        'Rester trop souvent « à la maison ».',
        'Les discussions trop profondes.',
        'Les silences dans les conversations.',
        'Le manque de spontanéité et de communication au sein d’une équipe.',
      ],
    },
    reflexion_social: {
      img: 'page_reflexion.png',
      text1:
        'Vous avez une préférence pour « la réflexion ». Cela signifie que vous êtes épanoui(e) quand vous êtes seul(e), en petit groupe et plutôt avec des personnes que vous connaissez bien. Vous puisez votre énergie dans votre monde intérieur, dans vos sensations et vos réflexions. <br/> Les arbres 🌳 ont besoin de soleil ☀️ pour grandir, vous avez besoin de temps de solitude pour vous épanouir !',
      text2:
        'Vous préférez établir des relations basées sur la confiance, avec des personnes qui partagent les mêmes valeurs et la même manière de penser. Vous aspirez à avoir des relations durables et profondes.',
      list1: [
        'Travailler dans une ambiance calme pour pouvoir vous concentrer.',
        'Passer du temps avec vos proches et/ou des personnes qui partagent vos centres d’intérêts. Méditer, être concentré(e).',
      ],
      list2: [
        'Les grands groupes, les relations superficielles,',
        'Les réunions trop longues qu’elles soient professionnelles ou familiales,',
        'Les foules, les Open Space,',
        'Les conversations où l’on échange des banalités.',
      ],
    },
  },
  perceptual: {
    color: '#FEA33A',
    secondColor: '#9D6524',
    experience_perceptual: {
      img: 'page_experience.png',
      text1:
        'Vous avez une préférence pour l’« Expérience ». Cela signifie que vous êtes épanoui quand vous réalisez des tâches concrètes. Vous avez besoin de voir, de toucher, de sentir pour que les choses prennent sens. Cela signifie que vous vivez plutôt dans l’instant présent. Vous aimez optimiser ce qui existe déjà, plutôt qu’inventer ou innover. Vous préférez assurer des missions opérationnelles que gérer des projets.',
      text2:
        'Vous préférez interagir avec des personnes qui ont l’esprit pratique, qui vivent dans le moment présent, sans trop se projeter vers l’avenir. Vous appréciez les personnes concrètes.',
      list1: [
        'Qu’on vous confie des missions. Vous êtes un(e) bon(ne) capitaine !',
        'Pouvoir aller dans les détails. Optimiser ce qui existe déjà.',
        'Pouvoir « voir » le résultat concret de vos actions.',
      ],
      list2: [
        'La théorie, les concepts, les discussions trop intellectuelles ou trop utopiques,',
        'Les rêves irréalistes ou les projets infaisables,',
        'Le manque de précision,',
        'Le manque de détails,',
        'Les généralités et les approximations,',
        'La « visio ».',
      ],
    },
    imagination_perceptual: {
      img: 'page_imagination.png',
      text1:
        'Vous avez une préférence pour « l’imagination ». Cela signifie que vous êtes épanoui(e) quand vous pouvez vous adonner à des activités créatives, qui mobilisent vos capacités à concevoir, imaginer, inventer. Cela signifie que vous avez besoin d’évoluer dans des environnements en constante transformation et de pouvoir conduire de nombreux projet. Ce qui vous met dans le flow 🌊 : imaginer et créer le futur !',
      text2:
        'Vous préférez interagir avec des personnes qui sont ouvertes d’esprit, imaginatives et qui aiment parler de sujets avec une certaine hauteur de vue. Vous appréciez les personnes qui ont des projets et changent.',
      list1: [
        'Vous êtes stimulé(e) par le fait de pouvoir faire des projets,',
        'Vous aimez transformer votre environnement en fonction de ce que vous avez imaginé,',
        'Vous appréciez quand la « réalité » rejoint la « fiction ».',
      ],
      list2: [
        'Quand le monde qui vous entoure reste trop longtemps statique,',
        'Les personnes trop conformistes,',
        'Les détails,',
        'Les gens lents,',
        'Les discussions trop terre à terre. Le manque de créativité.',
      ],
    },
  },
  emotional: {
    color: '#2435BD',
    opacity: true,
    empathy_emotional: {
      img: 'page_empathie.png',
      text1:
        'Vous êtes une personne sensible à ce que vivent les autres personnes. Vous ressentez facilement leurs émotions et/ou leurs sentiments. Quand une personne est en difficulté, vous avez à cœur de lui venir en aide. Cette « sensibilité » peut vous faire mettre les intérêts d’autrui avant les vôtres. Vous pouvez être « le dindon 🐔 de la farce » ! Vous pouvez également vous épuiser à vouloir aider ou protéger des personnes en difficulté.',
      text2:
        'Vous appréciez d’interagir avec des personnes compréhensives et douces, qui essaient d’anticiper vos désirs et vos besoins, qui vous écoutent et cherchent à vous comprendre.',
      list1: [
        'Pouvoir aider les autres.',
        'Ressentir les émotions d’une autre personne.',
        'Essayez de la comprendre en l’observant, en ressentant, en entrant en « communion » avec elle.',
        'Faire preuve d’empathie.',
      ],
      list2: [
        'Les conflits.',
        'L’égoïsme.',
        'L’indifférence ou la froideur dans les prises de décision.',
        'Les gens qui n’aident pas les personnes en difficulté.',
        'Devoir prendre des décisions qui auront des conséquences néfastes sur autrui.',
      ],
    },
    rationality_emotional: {
      img: 'page_rationnalite.png',
      text1:
        'Vous avez une préférence pour la « Rationalité ». Cela signifie que vous êtes heureux et performant quand vous pouvez analyser objectivement les faits et prendre des décisions sur une base objective. Vous appréciez les échanges directs et dire la vérité quand cela est nécessaire. Vous ne craignez pas le conflit ou les désacccords, quand il s’agit de démontrer rationnellement que vous avez raison et que votre opinion est justifiée.',
      text2:
        'Vous préférez interagir avec des personnes qui sont elles aussi rationnelles, qui n’ont pas peur du débat ou de la confrontation d’idées. Vous avez besoin qu’elles soient transparentes et disent ce qu’elles pensent.',
      list1: [
        'Analyser les situations.',
        'Découvrir des « vérités ».',
        'Les chiffres.',
        'Débattre.',
        'Argumenter.',
        'Prendre des décisions.',
        'Les situations claires et « tranchées » sans clair-obscur.',
      ],
      list2: [
        'L’absence d’arguments pour fonder une décision.',
        'Les consensus « mous ».',
        'Les situations qui ne sont pas claires.',
        'Les gens trop émotifs qui ne savent pas ce qu’ils veulent et/ou qui ne disent pas ce qu’ils pensent.',
      ],
    },
  },
  behavioral: {
    color: '#FF6F49',
    opacity: true,
    observation_behavioral: {
      listText: true,
      img: 'page_observation.png',
      text1:
        'Vous avez une préférence pour la « contemplation ». Cela signifie que vous êtes heureux(se) et performant(e) quand vous avez du temps pour observer, ressentir et agir quand cela est nécessaire. Vous appréciez les moments passés à « ne rien faire » 🧘, juste à observer ce qui se passe. Vous aimez flâner 🚶‍♂️, profiter de l’instant présent, « carpe diem », sans pour autant poursuivre un but en particulier.',
      text2:
        'Vous appréciez les personnes qui prennent le temps de vivre et qui sont plutôt calmes et posées. Des relations douces et apaisées, voilà ce que vous recherchez.',
      list1:
        'Vous ne cherchez pas forcément à être stimulé(e). <br/> Au contraire, vous avez besoin de moments de paix et de sérénité pour pouvoir vous ressourcer, réfléchir ou prendre des décisions.',
      list2: [
        'Les personnes impatientes et toujours pressées.',
        'Les ambiances trop agitées.',
        'Les environnements stressants.',
        'Les personnes hyperactives qui sont de vraies « piles électriques ».',
      ],
    },
    action_behavioral: {
      img: 'page_action.png',
      text1:
        'Vous avez une préférence pour « l’Action ». Cela signifie que vous êtes heureux et performant quand vous avez u n maximum de choses à faire ! « Se reposer » est une expression qui ne fait pas partie de votre vocabulaire. <br/> Toujours une idée en tête, une responsabilité à assumer, une personne à voir, un projet à mener, etc. <br/> Vous êtes d’une nature très active, voire hyperactive !',
      text2:
        'Vous préférez les personnes qui savent ce qu’elles veulent et qui agissent pour satisfaire leurs désirs. Vous appréciez la compagnie de personnes qui pensent et agissent rapidement.',
      list1: [
        'Un(e) manager(euse) hyperactif(ve), qui vous fait confiance et vous donne toujours de nouvelles missions à réaliser.',
        'Un environnement où ça bouge, dans lequel il y a de l’intensité, où il y a tout à faire.',
      ],
      list2: [
        'Les « temps morts ».',
        'Rester à « ne rien faire ».',
        'Le manque de réactivité.',
        'Les personnes qui parlent beaucoup, mais n’agissent pas.',
        'L’indécision.',
        'L’immobilisme.',
        'Les procrastinateurs(trices).',
      ],
    },
  },
  environmental: {
    color: '#EC343A',
    opacity: true,
    organization_environmental: {
      img: 'page_organisation.png',
      text1:
        'Vous avez une préférence pour « l’organisation ». Cela signifie que vous êtes heureux(se) et performant(e) quand vous évoluez dans un environnement organisé et structuré. <br/> Cela signifie que vous avez besoin de repères clairs (horaires, missions, objectifs). Vous avez besoin d’avoir vos « routines » 🕐 et d’évoluer dans un environnement prévisible. La stabilité est indispensable pour vous.',
      text2:
        'Vous préférez les personnes fiables et prévisibles, qui respectent leurs engagements et les délais impartis. Vous appréciez également les personnes ordonnées et organisées.',
      list1: [
        'Organiser ou réorganiser.',
        'Les missions clairement définies.',
        'Les plans d’action bien préparés et bien cadrés (objectifs, moyens, délais).',
        'Des règles de fonctionnement stables et définies.',
      ],
      list2: [
        'Le désordre, les imprévus à répétition, tout ce qui est flou ou incertain.',
        'L’incertitude vous fait fuir !',
        'La désorganisation vous stresse !',
        'Le changement n’est pas votre « tasse de thé ».',
      ],
    },
    adaptation_environmental: {
      img: 'page_adaptation.png',
      text1:
        'Vous avez une préférence pour l’« Adaptation ». Cela signifie que vous êtes heureux et performant dans des environnements qui offrent un minimum de contraintes. <br/> Vous avez besoin de vous organiser en fonction de votre feeling et des opportunités du moment. Pour cette raison, vous n’appréciez pas les environnements trop rigides, avec trop de règles.',
      text2:
        'Vous préférez les personnes spontanées, avec de la fantaisie et une certaine liberté d’esprit. Les personnes trop conventionnelles ou trop conformistes vous fatiguent ou vous ennuient !',
      list1: [
        'Devoir vous adapter à des situations nouvelles.',
        'Gérer des imprévus et des urgences.',
        'Qu’il se « passe des choses » dans votre vie, des choses différentes, inattendues, avec une issue positive.',
      ],
      list2: [
        'La « routine ».',
        'Les journées qui se ressemblent.',
        'Les tâches répétitives.',
        'L’absence de nouveauté.',
        'Travailler toujours au même endroit sur les mêmes sujets.',
        'L’absence d’imprévus ou d’urgences à gérer.',
      ],
    },
  },
};

export const codePreference: any = {
  social: {
    interaction_social: 0,
    reflexion_social: 7,
  },
  perceptual: {
    experience_perceptual: 0,
    imagination_perceptual: 7,
  },
  emotional: {
    empathy_emotional: 7,
    rationality_emotional: 0,
  },
  behavioral: {
    observation_behavioral: 'BLEU',
    action_behavioral: 'ROUGE',
  },
  environmental: {
    organization_environmental: 0,
    adaptation_environmental: 7,
  },
};

export const codeProfil: any = {
  '7007BLEU': {
    label: 'LES OBSERVATEURS DU CONCRET',
    img: '7007BLEU.jpg',
    imgEn: 'en/7007BLEU.jpg',
    pdf: pdf_7007BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1sKNCLtZv3pyyM3zUUOi-5v7WTqm1HOJG/view',
    linkVis:
      'https://drive.google.com/file/d/1aWDPVuNgBfPwjYc3dHrxKohN5N926MdV/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/3CyALIF',
  },
  '7007ROUGE': {
    label: 'INVESTIGATEURS RÉALISTES',
    img: '7007ROUGE.jpg',
    imgEn: 'en/7007ROUGE.jpg',
    pdf: pdf_7007ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1tElYAd8Vk6RYJrTl5ZdH_gL18pXaWLiq/view',
    linkVis:
      'https://drive.google.com/file/d/1NL2UA6Tg6DLRWs1v6zNn_Hz6pM1vyAUj/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/fuIzyHU',
  },
  '7000BLEU': {
    label: 'LES RÉALISTES LOYAUX',
    img: '7000BLEU.jpg',
    imgEn: 'en/7000BLEU.jpg',
    pdf: pdf_7000BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1rMwEHkPhFyd_YFicjQHWlCm2hEV09TnL/view',
    linkVis:
      'https://drive.google.com/file/d/1NO6VUGGl_qpTSdcrhCe5XqhSEURyO6mr/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/4aQ6SJx',
  },
  '7000ROUGE': {
    label: 'LES PERFECTIONNISTES MÉTHODIQUES',
    img: '7000ROUGE.jpg',
    imgEn: 'en/7000ROUGE.jpg',
    pdf: pdf_7000ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1rI0IsezutsfrWZvkfYAmVhb41CNXOvqs/view',
    linkVis:
      'https://drive.google.com/file/d/1NOVhXmXaQpqcUWJSOACzI9MjBaGNBEoy/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/aeSIGZx',
  },
  '7077BLEU': {
    label: 'LES COOPÉRATIFS RÉFLÉCHIS',
    img: '7077BLEU.jpg',
    imgEn: 'en/7077BLEU.jpg',
    pdf: pdf_7077BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1s_awP2yE7Z4_aGfpz6toO2g5TKwzT3l2/view',
    linkVis:
      'https://drive.google.com/file/d/1NOdiTTgxJxqIoIEZzHujbpNjCaUAvRkC/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/3yoUdqb',
  },
  '7077ROUGE': {
    label: 'LES COOPÉRATIFS ENGAGÉS',
    img: '7077ROUGE.jpg',
    imgEn: 'en/7077ROUGE.jpg',
    pdf: pdf_7077ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1tMvQgcXyCQPb2-Itq6NvX8PZ3cvXrxOX/view',
    linkVis:
      'https://drive.google.com/file/d/1Z8wL-_EdfNsoLOY0_DvxNnWkm1mrk8bQ/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/6OabKm7',
  },
  '7070BLEU': {
    label: 'LES CONSCIENCIEUX PRÉCAUTIONNEUX',
    img: '7070BLEU.jpg',
    imgEn: 'en/7070BLEU.jpg',
    pdf: pdf_7070BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1tarzrBu9LzVcyEiAkz7DMVlTY8_F8LfR/view',
    linkVis:
      'https://drive.google.com/file/d/1Zf-tHvvkFTe9G_CD-Ugq1gh7pDoSgOR_/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/fJdbknj',
  },
  '7070ROUGE': {
    label: 'LES CONSCIENCIEUX DÉVOUÉS',
    img: '7070ROUGE.jpg',
    imgEn: 'en/7070ROUGE.jpg',
    pdf: pdf_7070ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1s2PkEey4Cit4f5sf-LX0fLOS05EHmeik/view',
    linkVis:
      'https://drive.google.com/file/d/1ZVMi2MdI38GkkuS9-WhpcvCAzinEUYT_/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/cV8gdyS',
  },
  '7707BLEU': {
    label: 'LES PENSEURS ÉCLAIRÉS',
    img: '7707BLEU.jpg',
    imgEn: 'en/7707BLEU.jpg',
    pdf: pdf_7707BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1r3dobA_2lu7xv1NSeXPPvFfRH4Je5YvJ/view',
    linkVis:
      'https://drive.google.com/file/d/1ZTPb-fYaKYtsWcrSflpb_15TZz1XzWSR/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/a3dj5JP',
  },
  '7707ROUGE': {
    label: 'LES INNOVATEURS ANALYTIQUES',
    img: '7707ROUGE.jpg',
    imgEn: 'en/7707ROUGE.jpg',
    pdf: pdf_7707ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1tXPT34bMvCnObul72Qgb66DDYPykuWFK/view',
    linkVis:
      'https://drive.google.com/file/d/1Zv1qCmtXlWPxLe_oReOckZm7LzNccYMk/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/1IfDtTm',
  },
  '7700BLEU': {
    label: 'LES INVENTIFS PRÉCAUTIONNEUX',
    img: '7700BLEU.jpg',
    imgEn: 'en/7700BLEU.jpg',
    pdf: pdf_7700BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1ri56_67byN_WZkGCVo19MbBs7maJLpvM/view',
    linkVis:
      'https://drive.google.com/file/d/1_jqgDQ66qDE-8oKcN8kgf8fgXbH-v9j5/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/hHyxRG4',
  },
  '7700ROUGE': {
    label: 'LES MODÉLISATEURS PERFECTIONNISTES',
    img: '7700ROUGE.jpg',
    imgEn: 'en/7700ROUGE.jpg',
    pdf: pdf_7700ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1tPqK8MuS0_04S7_PVT7aDsIws0VJl3ZO/view',
    linkVis:
      'https://drive.google.com/file/d/1_irRLNQieNipcs66YxGF-p_R6SUUwBkz/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/hS6coth',
  },
  '7777BLEU': {
    label: 'LES IMAGINATIFS DÉVOUÉS',
    img: '7777BLEU.jpg',
    imgEn: 'en/7777BLEU.jpg',
    pdf: pdf_7777BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1tKUh80-g52m-803blai9fUxKN2-kQuOP/view',
    linkVis:
      'https://drive.google.com/file/d/1_iiVKqKNCofJHMc0xZlQmaX_PqbufAJ4/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/ieWb1ki',
  },
  '7777ROUGE': {
    label: 'LES CRÉATIFS ENTREPRENANTSS',
    img: '7777ROUGE.jpg',
    imgEn: 'en/7777ROUGE.jpg',
    pdf: pdf_7777ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1rxeeHHHSQZSTyP7xtNmSh6yWxO9RTQt-/view',
    linkVis:
      'https://drive.google.com/file/d/1a0yk5wkxI1E7hQRiPyLrczIc1nOujgc-/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/idoihOQ',
  },
  '7770BLEU': {
    label: 'LES CRÉATIFS IMPLIQUÉS',
    img: '7770BLEU.jpg',
    imgEn: 'en/7770BLEU.jpg',
    pdf: pdf_7770BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1tu3K1g6Bj4Y847u9BOWi4td3srOgjX4f/view',
    linkVis: 'https://drive.google.com/file/d/1Hzo-5XvjHOPt_jaebn6ZMhQ_Z5zNvaxk/view',
    linkBuy: 'https://amzn.eu/d/4kKWpoT',
  },
  '7770ROUGE': {
    label: 'LES CRÉATIFS MÉTHODIQUES',
    img: '7770ROUGE.jpg',
    imgEn: 'en/7770ROUGE.jpg',
    pdf: pdf_7770ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1sdk70HCvwatZY0R8AIT71l933gyxfX9W/view',
    linkVis:
      'https://drive.google.com/file/d/1_tKX7Yrro9Fsh7npFZ30W9d79o7CmJub/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/f3KxHcK',
  },
  '0007BLEU': {
    label: 'LES RELATIONNELS LOYAUX',
    img: '0007BLEU.jpg',
    imgEn: 'en/0007BLEU.jpg',
    pdf: pdf_0007BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1t9tVN3T__kM3Zm39rVyb0gOuKKMGPqR-/view',
    linkVis:
      'https://drive.google.com/file/d/1a69xatGFDmMfax2SdfK5gok9gKVhHyS_/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/dLl4WFX',
  },
  '0007ROUGE': {
    label: 'LES RÉALISTES PASSIONNÉS',
    img: '0007ROUGE.jpg',
    imgEn: 'en/0007ROUGE.jpg',
    pdf: pdf_0007ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1ttdXv0EIy6M-v4gnq_yLCaNuTruVQi6R/view',
    linkVis:
      'https://drive.google.com/file/d/1a2iCDncTvbYgDl81ywY9nB2lH-0Z7P3w/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/62OGP7J',
  },
  '0000BLEU': {
    label: 'LES PRAGMATIQUES APPLIQUÉS',
    img: '0000BLEU.jpg',
    imgEn: 'en/0000BLEU.jpg',
    pdf: pdf_0000BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1u8YWt9SvceeC-30XRS_2s1RCDQBdELfO/view',
    linkVis:
      'https://drive.google.com/file/d/1a1IS8ghti1xf-hfggcz49dhsmCvJZW_a/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/fQ24jwA',
  },
  '0000ROUGE': {
    label: 'LES PRAGMATIQUES ORGANISÉS',
    img: '0000ROUGE.jpg',
    imgEn: 'en/0000ROUGE.jpg',
    pdf: pdf_0000ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1uErpeP0gM-GR5umQgHTq7FBZco2odMJh/view',
    linkVis:
      'https://drive.google.com/file/d/1a80odOYs1oYtG5y3ChXIeK_mIywm67It/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/b4ZDj8M',
  },
  '0077BLEU': {
    label: 'LES ENTHOUSIASTES PRUDENTS',
    img: '0077BLEU.jpg',
    imgEn: 'en/0077BLEU.jpg',
    pdf: pdf_0077BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1rFN9XWr213Zhp6kbp3FDOT9ilwWkgdRW/view?usp=sharing',
    linkVis: 'https://drive.google.com/open?id=19L89hqmTshW-4OvB_ALGls1KjRGSSCdD&usp=drive_fs',
    linkBuy: 'https://amzn.eu/d/fRgPWmV',
  },
  '0077ROUGE': {
    label: 'LES RELATIONNELS INSTINCTIFS',
    img: '0077ROUGE.jpg',
    imgEn: 'en/0077ROUGE.jpg',
    pdf: pdf_0077ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1rOMwNn_jbsCP08Ag6_k5z-40jPSSBp_O/view',
    linkVis:
      'https://drive.google.com/file/d/1a6NW9GrmrlzkJCXprgIZhXiVo1NpDSE4/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/iDCU53o',
  },
  '0070BLEU': {
    label: 'LES EMPATHIQUES ORGANISÉS',
    img: '0070BLEU.jpg',
    imgEn: 'en/0070BLEU.jpg',
    pdf: pdf_0070BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1rb06XMDNdFEIf_3VT0qgYd1pzErwIgLH/view',
    linkVis:
      'https://drive.google.com/file/d/1a8ytTCWN62ScNdnHepxFKKaKLbjZ9HXd/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/cKpCzdZ',
  },
  '0070ROUGE': {
    label: 'LES ORGANISATEURS COMPRÉHENSIFS',
    img: '0070ROUGE.jpg',
    imgEn: 'en/0070ROUGE.jpg',
    pdf: pdf_0070ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1rgrbJ7T3XNi3fCxQlk1rrcAKYu4-Kqxw/view',
    linkVis:
      'https://drive.google.com/file/d/1a93G1OxGgvQPrVDE2nPop8sGYoIfin4G/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/c7BBOe3',
  },
  '0707BLEU': {
    label: 'LES FACILITATEURS DU CHANGEMENT',
    img: '0707BLEU.jpg',
    imgEn: 'en/0707BLEU.jpg',
    pdf: pdf_0707BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1sYeKiDTUIF26Nqx3OQRiM7CTfpVcrx4W/view',
    linkVis:
      'https://drive.google.com/file/d/1aESdnF9bcR3M4VqrC2pZV4Lhvb0yq3D1/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/dCJzcdB',
  },
  '0707ROUGE': {
    label: 'LES LEADERS DU CHANGEMENT',
    img: '0707ROUGE.jpg',
    imgEn: 'en/0707ROUGE.jpg',
    pdf: pdf_0707ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1sqp7fTnRxvtGVzzs14q2dML0WxiaMnQq/view',
    linkVis:
      'https://drive.google.com/file/d/1aEpjTl83CjJU8F3rC2SsUNNmTAlhSJEC/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/3pFBdc5',
  },
  '0700BLEU': {
    label: "LES FACILITATEURS DE L'EFFICACITÉ",
    img: '0700BLEU.jpg',
    imgEn: 'en/0700BLEU.jpg',
    pdf: pdf_0700BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1rDnf1sW9x4Ju4LE8SeLX--d8fk2Q4X9w/view',
    linkVis:
      'https://drive.google.com/file/d/1aMMUuGLysROOnXifyG9mW6wsoiZqTBHw/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/ezSR7sL',
  },
  '0700ROUGE': {
    label: 'LES PROMOTEURS DE LA PERFORMANCE',
    img: '0700ROUGE.jpg',
    imgEn: 'en/0700ROUGE.jpg',
    pdf: pdf_0700ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1rzjqyfXD2Oe-8gc_yDayQaPmgFLRVecP/view',
    linkVis:
      'https://drive.google.com/file/d/1aN4Noe0Ck2FMH281fI5La1VPblGTVrV7/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/gWAMjiB',
  },
  '0777BLEU': {
    label: 'LES INNOVATEURS RÉFLÉCHIS',
    img: '0777BLEU.jpg',
    imgEn: 'en/0777BLEU.jpg',
    pdf: pdf_0777BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1tlBUzeZjXjln5NQ9nDIZExkBrv694bC5/view',
    linkVis:
      'https://drive.google.com/file/d/1aSlpmph_Q9npMgu2Qo_UjC-pzIL_J6VR/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/gTWqBAI',
  },
  '0777ROUGE': {
    label: 'LES LEADERS INSPIRANTS',
    img: '0777ROUGE.jpg',
    imgEn: 'en/0777ROUGE.jpg',
    pdf: pdf_0777ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1smzceZSEbLVUkXtS-MdPAwsaONGej6tA/view',
    linkVis:
      'https://drive.google.com/file/d/1aUpxHFc5S1yP5rPgN6s-KuXvmeMMJNcl/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/9lf1F78',
  },
  '0770BLEU': {
    label: 'LES COORDINATEURS MÉTHODIQUES',
    img: '0770BLEU.jpg',
    imgEn: 'en/0770BLEU.jpg',
    pdf: pdf_0770BLEU,
    linkVisEn: 'https://drive.google.com/file/d/1uAbJwqYcTtrNieIFpSTsy4u8ybBvNufK/view?usp=sharing',
    linkVis:
      'https://drive.google.com/file/d/1Y7tpMshiLKdyof4EDM8f2XCyao-K46Oz/view?usp=sharing',
    linkBuy: 'https://amzn.eu/d/furK7c6',
  },
  '0770ROUGE': {
    label: 'LES LEADERS VISIONNAIRES',
    img: '0770ROUGE.jpg',
    imgEn: 'en/0770ROUGE.jpg',
    pdf: pdf_0770ROUGE,
    linkVisEn: 'https://drive.google.com/file/d/1u8DBnDZN91gpLQaWJYIEXe9BAcNNFhUN/view',
    linkVis:
      'https://drive.google.com/file/d/1aVXOp36sZz9SIdhuAoyZCOTzX7xWIWa6/view?usp=drive_link',
    linkBuy: 'https://amzn.eu/d/7onVSiY',
  },
};

export const labelBlockToShow: any = {
  normal: 'Paragraphe',
  citation: 'Citation',
  encyclopedia: 'Information',
};
export const hardSkills = [
  {
    type: 'Traitement de Texte et Bureautique',
    metiers: [
      'Microsoft Office Suite (Word, Excel, PowerPoint)',
      'Google Workspace, (Docs, Sheets, Slides)',
      'LibreOffice',
      'Apple iWork (Pages, Numbers, Keynote)',
    ],
  },
  {
    type: 'Communication et Collaboration',
    metiers: [
      'Microsoft Teams',
      'Slack',
      'Zoom',
      'Google Meet',
      'Skype for Business',
      'Gestion de Projets',
      'Trello',
      'Asana',
      'Monday.com',
      'Jira',
      'Basecamp',
    ],
  },
  {
    type: 'CRM et Gestion de la Relation Client',
    metiers: [
      'Salesforce',
      'HubSpot',
      'Zoho CRM',
      'Microsoft Dynamics 365',
      'Comptabilité et Finances',
      'QuickBooks',
      'Xero',
      'FreshBooks',
      'Sage Comptabilité',
      'EBP',
      'Odoo',
    ],
  },
  {
    type: 'Conception Graphique et Édition',
    metiers: ['Photoshop', 'lllustrator', 'InDesign', 'Canva', 'CorelDRAW', 'GIMP'],
  },
  {
    type: 'Développement et codage',
    metiers: ['Visual Studio Code', 'Eclipse', 'IntelliJ IDEA', 'GitLab', 'GitHub'],
  },
  {
    type: 'Automatisation et Intégration',
    metiers: ['Zapier', 'IFTTT', 'Automate.ioA'],
  },
  {
    type: 'IA générative',
    metiers: ['Chat GPT', 'Google Bard', 'Dall-E', 'Midjourney', 'Copilot'],
  },
];
